export const ge: { [key: string]: string } = {
  opportunities_1: 'მიიღეთ მეტი ინფორმაცია ჩვენი ქეისების შესახებ',
  opportunities_2: 'გახსენით',
  opportunities_3: 'შესაძლებლობები',
  opportunities_4: 'საკუთარი თავისთვის',
  opportunities_5: 'საერთაშორისო ბიზნესი 4Service-ის კვლევით ჰოლდინგ-თან ერთად',
  opportunities_6:
    'რომელი <span> პროდუქტით </span> შეგვიძლია გავაძლიეროთ თქვენი ბიზნესი?',
  opportunities_7: 'СХ',
  opportunities_8: 'ბიზნესისთვის მორგებული ყოვლისმომცველი გადაწყვეტილებები',
  opportunities_9: 'ყველა სახის Mystery Shopping-ი',
  opportunities_10:
    'ჩვენ ვასრულებთ mystery employee, mystery caller, luxury mystery shopper, automotive mystery shopper და სხვა',
  opportunities_11: 'მორგებული IT გადაწყვეტილებები ბიზნესისთვის',
  opportunities_12:
    'საკუთარი it გადაწყვეტილებები AI-ით, პლატფორმები უკუკავშირის ანალიტიკისა და ზარის ტრანსკრიპციისთვის',
  opportunities_13: 'Market research',
  opportunities_14:
    'ნებისმიერი ბიზნეს მოთხოვნისთვის  (Brand Health Tracking), სეგმენტაცია, NPS, eNPS, CJM, პროდუქტისა და რეკლამის ტესტირება და ა.შ.)',
  opportunities_15: 'აუდიტი',
  opportunities_16:
    'ჩვენ ვახორციელებთ მომსახურების სხვადასხვა სახის აუდიტს, ასევე ფასების მონიტორინგს (ოფლაინ, კონკრეტული ნიშებისთვის და სხვა)',
  opportunities_17: 'Service Design',
  opportunities_18:
    '4Service - ვართ DesignThinkers Academy-ის სერტიფიცირებული პარტნიორები და გთავაზობთ გუნდის კორპორატიულ ტრენინგს და რეგულარულად ვატარებთ სემინარებს ბიზნესისთვის',
  opportunities_19:
    'ჩვენ გაგიზიარებთ ჩვენს გამოცდილებას, მაგრამ<span>პატივს ვცემთ და არ დავარღვევთ </span> თქვენი ბიზნესის პროცესს',
  opportunities_20:
    'ჩვენ ვიცით, რა სირთულეებს აწყდება ბიზნესი განვითარების გზაზე და ვიცით, როგორ გადავლახოთ ეს ბარიერები საერთაშორისო წარმატებულ გამოცდილებაზე დაყრდნობით. თქვენ მიიღებთ არა მხოლოდ გამოცდილებას, არამედ რესურსებსაც',
  opportunities_21: 'გიწვევთ თანამშრომლობისთვის!',
  opportunities_22:
    'ჩვენ გთავაზობთ <span>პარტნიორობის პროგრამას </span> თქვენი ბიზნესისთვის',
  opportunities_23:
    'საერთაშორისოდ აღიარებული 4Service ბრენდის ქვეშ თქვენ შეძლებთ დადებითი გავლენა მოახდინოთ ახალი მომხმარებლების მოზიდვაზე.',
  opportunities_24:
    'ჩვენი პარტნიორები იღებენ ყოვლისმომცველ მხარდაჭერას, მათ შორის ტრენინგს, მარკეტინგულ მასალებს და ოპერაციულ დახმარებას.',
  opportunities_25:
    'ჩვენთან თანამშრომლობა დაგეხმარებათ თქვენი გეგმების შესრულებაში,მიმდინარე ბიზნეს პროცესის შეფერხების გარეშე.',
  opportunities_26: 'ჩვენი <span>ოფისები</span>',
  opportunities_27: 'ჩვენი კლიენტები',
  opportunities_28: 'ჩვენ გვაქვს 20 წელზე მეტი გამოცდილება CX-ში',
  opportunities_29: 'დაფარული ქვეყნები',
  opportunities_30: 'ათასობით',
  opportunities_31: 'უნიკალური პროექტები',
  opportunities_32: 'მილიონი',
  opportunities_33: 'იდუმალი მყიდველების ვიზიტები',
  opportunities_34: 'შედის ევროპის CX სააგენტოების TOP 10-ში',
  opportunities_35: 'თქვენი შესაძლებლობები 4Service-თან მუშაობისას',
  opportunities_36: 'გაზრდილი მოგება',
  opportunities_37: 'თქვენ მიიღებთ წვდომას საერთაშორისო შეკვეთებზე',
  opportunities_38: 'უნიკალური CX მიდგომა',
  opportunities_39: '20 წლიანი გამოცდილების მქონე ექსპერტების მხარდაჭერა',
  opportunities_40: 'მხარდაჭერა',
  opportunities_41: 'ჩვენი გუნდი გაგიწევთ დაგეხმარებას შედეგის მიღწევაში',
  opportunities_42: 'გაყიდვები',
  opportunities_43: 'ჩვენ დაგეხმარებით გაყიდვების სისტემის დალაგებაში',
  opportunities_44: 'წვდომა პროგრამულ უზრუნველყოფაზე',
  opportunities_45:
    'თქვენ მიიღებთ წვდომას ყველა სერთიფიცირებულ It-ინსტრუმენტებზე',
  opportunities_46: 'შესწავლა',
  opportunities_47:
    'ჩვენ არა მხოლოდ შევასწავლით თქვენს თანამშრომლებს, არამედ გავაგრძელებთ თქვენს კონსულტაციას ',
  opportunities_48: 'ვისთვის იქნება საინტერესო პარტნიორობა?',
  opportunities_49: 'თქვენი ბიზნესი დაკავშირებულია მარკეტინგულ კვლევებთან?',
  opportunities_50: 'ან გსურთ მოსინჯოთ თავი ახალ სფეროში',
  opportunities_51: 'გეგმავთ:',
  opportunities_52: 'ინოვაციების დანერგვას',
  opportunities_53: 'საერთაშორისო ბრენდებთან მუშაობას',
  opportunities_54: 'პროდუქტის პორტფოლიოს გაფართოვებას',
  opportunities_55: 'თქვენი პოზიციის გამაგრებას ბაზარზე?',
  opportunities_56: 'შეასწავლოთ თქვენს თანამშრომლებს',
  opportunities_57: 'თქვენი ბიზნესის მაშტაბირებას',
  opportunities_58: 'ჩვენი რესურსი = თქვენს რესურსს',
  opportunities_59:
    'ჩვენი დიდი გამოცდილების გათვალისწინებით, ჩვენ მზად ვართ გაგიზიაროთ ის თანამშრომლობის პირველ ეტაპზე',
  opportunities_60: 'მონაცემების ანალიზი:',
  opportunities_61: 'საერთაშორისო ანალიტიკური გუნდი',
  opportunities_62: 'მონაცემების დამუშავების მეტოდიკა - SPSS, Power BI',
  opportunities_63: 'ინოვაციური მეთოდიკა და მეთოდოლოგიების ფართო სფექტრი',
  opportunities_64: 'ანგარიში ნებისმიერ ფორმატში',
  opportunities_65: 'პროგრამული უზრუნველყოფა:',
  opportunities_66: 'საკუთარი მორგებული IT შესაძლებლობა',
  opportunities_67: 'CAWI-სთვის',
  opportunities_68: 'DigSee CAPI-თვის',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'Call center',
  opportunities_71: 'მარკეტინგული მხარდაჭერა:',
  opportunities_72: 'PR-მხარდაჭერა',
  opportunities_73: 'მხარდაჭერა კონტენტის პოპულარიზაციასა და შექმნაში',
  opportunities_74: 'ლიდოგენერაციის პროცესების დალაგება',
  opportunities_75: 'IT-მხარდაჭერა: ',
  opportunities_76:
    'ტექნიკური მხარდაჭერა ჩვენი პროგრამული უზრუნველყოფის ინსტალაციის, კონფიგურაციისა და გამოყენებისას.',
  opportunities_77: 'დისტანციური დახმარება',
  opportunities_78: 'უსაფრთხოების კონტროლი',
  opportunities_79: 'ოპერაციული მხარდაჭერა:',
  opportunities_80: 'საველე სამუშაოების მხარდაჭერა და ჩამოყალიბება',
  opportunities_81: 'ანტიფროდის სისტემა',
  opportunities_82: 'ნებისმიერი სირთულის რეკრუტინგი',
  opportunities_83:
    'საპროექტო და საველე დეპარტამენტების გუნდის ოპერატიული მართვა',
  opportunities_84: 'რეკრუტინგის ხარისხის კონტროლი',
  opportunities_85: 'UpWork',
  opportunities_86: 'რა ბონუსებს მიიღებთ?',
  opportunities_87: 'მომხმარებელთა ბაზის გაზრდა',
  opportunities_88: 'ბაზრის იმიჯის გაძლიერება',
  opportunities_89: 'კლიენტების დაკარგვის რისკების დივერსიფიკაცია',
  opportunities_90: 'ტექნოლოგიური პროცესების ოპტიმიზაცია',
  opportunities_91: 'საერთაშორისო გამოცდილება',
  opportunities_92: 'მეტი გაყიდვები არსებულ კლიენტებზე',
  thank_you_page:
    'მადლობას გიხდით დაინტერესებისთვის! ჩვენი მენეჯერი მალე დაგიკავშირდებათ.',
  back_main: 'მთავარზე დაბრუნება',
  subscribe_with_click: 'გამოწერა ერთი დაწკაპუნებით',
  subscribe: 'გამოიწერეთ ბიულეტენი',
  menu_21: 'მანქანის ფასების ანალიზი',
  form_title: 'ჩვენ მალე დაგიკავშირდებით',
  form_required: 'მითითებული ველები *, სავალდებულოა შევსება',
  form_name_placeholder: 'სახელი',
  form_email_placeholder: 'ელფოსტა',
  form_phone_placeholder: 'Ტელეფონის ნომერი',
  form_company_placeholder: 'კომპანია',
  form_submit: 'გაგზავნა',
  form_1: 'ვეთანხმები პერსონალური მონაცემების დამუშავებას შესაბამისად',
  form_2: 'კონფიდენციალურობის პოლიტიკა',
  validation_privacy_policy: 'გთხოვთ დაეთანხმოთ კონფიდენციალურობის პოლიტიკას',
  validation_phone: 'Ტელეფონის ნომერი არასწორი',
  validation_email: 'ელფოსტის ფორმატი არასწორია',
  validation_required: 'სავალდებულო ველები არ არის შევსებული',
  submit_error: 'ფორმის შენახვისას მოხდა შეცდომა',
  footer_1: 'Ჩვენი პარტნიორები:',
  footer_2: 'მეთოდები',
  footer_3: 'პროდუქტები',
  footer_4: 'კონტაქტები:',
  footer_5: 'გამომავალი მონაცემები',
  footer_6: 'Კონფიდენციალურობის პოლიტიკა',
  about_us_1: 'Კორპორაციული სოციალური პასუხისმგებლობა 4Service',
  about_us_2:
    'ჩვენი გუნდის თითოეული წევრის გულიდან და სულიდან. ჩვენ თითოეულ ჩვენს თანამშრომელს ვზრდით სიკეთის ნაპერწკალებს და ვცდილობთ, რომ ჩვენს გარშემო სამყარო ცოტათი უკეთესი გავხადოთ',
  about_us_3: 'Კორპორაციული სოციალური პასუხისმგებლობა 4Service',
  about_us_4:
    'ჩვენი გუნდის თითოეული წევრის გულიდან და სულიდან. ჩვენ თითოეულ ჩვენს თანამშრომელს ვზრდით სიკეთის ნაპერწკალებს და ვცდილობთ, რომ ჩვენს გარშემო სამყარო ცოტათი უკეთესი გავხადოთ',
  about_us_5: 'ბიზნეს თამაში "ServiceMania»',
  about_us_6:
    'ჩვენი საგანმანათლებლო ინიციატივები ბავშვებისა და სტუდენტებისთვის',
  about_us_7: 'ქველმოქმედება / Მოხალისეობა',
  about_us_8:
    'ბავშვთა სახლები, მოხუცთა და მოხალისეების სახლები უკრაინის არმიაში. ჩვენი საქმიანობის ყველაზე საინტერესო ნაწილი',
  about_us_9: 'ცხოველებზე ზრუნვა',
  about_us_10:
    'ნებისმიერ მსურველს შეუძლია ჩვენს ოფისში მისვლა თავისი შინაური ცხოველით. ჩვენ ვეხმარებით თავშესაფრებს, ვაგროვებთ სახსრებს საკვებისთვის და ასევე ვეძებთ თავშესაფარს უსახლკარო ცხოველებისთვის.',
  about_us_11: 'კომპანია 4Service',
  about_us_12:
    'მომხმარებელთა გამოცდილების მართვის საერთაშორისო კვლევითი კომპანია.',
  about_us_13:
    'ჩვენ ვახორციელებთ კომპლექსურ პროექტებს გაყიდვების გაზრდისა და კლიენტზე ორიენტირებული კომპანიების ბიზნესის განვითარების მიზნით.',
  about_us_14:
    '4Service — საერთაშორისო კვლევითი ჰოლდინგი, რომლის სათაო ოფისი მდებარეობს ვენაში (ავსტრია). კომპანია დაარსდა 2001 წელს, რათა გააუმჯობესოს თავისი მომხმარებლების და იმ ადამიანების ცხოვრების ხარისხი, რომლებიც ურთიერთობენ ბიზნესთან მათი სერვისებისა და პროდუქტების გამოყენებით. სახელწოდება „ფორსერვისი“ შემთხვევით არ შერჩა – რადგან კომპანია განასახიერებს მომხმარებლის მომსახურების მაღალ სტანდარტებს. ',
  about_us_15:
    '4Service-ის ისტორია დაიწყო კიევში (უკრაინა), სადაც კომპანია გახდა საიდუმლო სავაჭრო სერვისების წამყვანი მიმწოდებელი. როგორც კვლევითი ჰოლდინგი, ჩვენ წარმატებით ვმუშაობთ 52 ქვეყანაში, ვხსნით ახალ შესაძლებლობებს ინტეგრირებული მიდგომისთვის მომხმარებელთა მომსახურების მთელი ჯაჭვის ანალიზისა და გაუმჯობესებისთვის.',
  about_us_16: 'მომსახურების საფუძველი',
  about_us_17: 'პირველი ოფისი უკრაინის გარეთ',
  about_us_18: 'შტაბ-ბინის ვენაში გადატანა',
  about_us_19: 'MSPA-ს ელიტარული წევრი, ევროპის ტოპ 10 სააგენტოში',
  about_us_20: 'ოფისების გახსნა 9 ქვეყანაში',
  about_us_21: 'პირველი ციფრული პროექტები, Voicer',
  about_us_22: 'DesignThinkers Academy-ის პარტნიორები',
  about_us_23: 'პირველი გლობალური მომხმარებელთა გამოცდილების პროექტები',
  about_us_24: 'Მისია',
  about_us_25:
    'ჩვენი მისიაა გავაუმჯობესოთ მომხმარებელთა მომსახურება მთელ მსოფლიოში! ჩვენ შთაგონებული ვართ იმ ხარისხობრივი ცვლილებებით, რომლებსაც ვხედავთ იმ ადამიანებში და კომპანიებში, რომლებთანაც ვმუშაობთ.',
  about_us_26: '20+ წლიანი მომხმარებლის გამოცდილება',
  about_us_27: '95 ქვეყანა',
  about_us_28:
    'ჩვენ ვაგროვებთ და ვუზიარებთ საუკეთესო ინდუსტრიის გამოცდილებას მთელი მსოფლიოდან',
  about_us_29: 'სათაო ოფისი ვენაში',
  about_us_30:
    'ქვეყნები. ჩვენ ვაგროვებთ და ვუზიარებთ საუკეთესო ინდუსტრიის გამოცდილებას მთელი მსოფლიოდან',
  about_us_31: 'მომსახურების ხარისხის რეიტინგები',
  about_us_32:
    'ჩვენ ვართ 10 საუკეთესო ევროპულ სააგენტოს შორის მომხმარებელთა გამოცდილების მართვისთვის',
  about_us_33: 'წარმომადგენლობითი ოფისები და შტაბები ავსტრიაში',
  about_us_34: 'აქტიური პროექტები',
  about_us_35: 'თქვენი მომავალი სამუშაო ადგილი',
  about_us_36: 'ჩვენი ოფისები',
  about_us_37:
    '4Service™ მუშაობს თავისი თანამშრომლებისთვის კომფორტული სამუშაო სივრცის შესაქმნელად. მოხერხებულობისა და მაქსიმალური პროდუქტიულობისთვის, თითოეულ თანამშრომელს შეუძლია აირჩიოს სამუშაო ფორმატი: ოფისში, დისტანციურად ან ჰიბრიდში. გარდა ამისა, კომპანიამ იზრუნა დასასვენებელი ოთახების ხელმისაწვდომობაზე, უფასო ფსიქოლოგიურ მხარდაჭერასა და მეგობრულ ატმოსფეროზე. და ჩვენ მეგობრული ვართ არა მხოლოდ ადამიანების, არამედ შინაური ცხოველების მიმართაც.',
  about_us_38: 'გუნდი, რომელიც ანათებს და ანთებს',
  about_us_39:
    'ჩვენი მომხმარებლების გამოხმაურება და ორმხრივი ზრდა ჩვენი მრავალეროვნული გუნდის პრიორიტეტია. ჩვენი მომხმარებლის მოგზაურობა თანამშრომლობის დროს ისეთივე მნიშვნელოვანია ჩვენი ბიზნესისთვის, როგორც ახალი პროდუქტების გამოშვება ან ფინანსური მიზნების მიღწევა. ჩვენ ვმუშაობთ იმისათვის, რომ შევქმნათ პოზიტიური გავლენა თემებზე და შევთავაზოთ ჩვენს მომხმარებლებს ინოვაციური გადაწყვეტილებები ხალხის გათვალისწინებით.',
  about_us_40: 'ყველა',
  about_us_41: 'მენეჯმენტი',
  about_us_42: 'გლობალური გუნდი',
  about_us_43: 'პროდუქტის მფლობელები',
  about_us_44: 'Ჩვენი პარტნიორები',
  about_us_45:
    'ჩვენ ვახორციელებთ კომპლექსურ პროექტებს გაყიდვების გაზრდისა და კლიენტზე ორიენტირებული კომპანიების ბიზნესის განვითარების მიზნით',
  about_us_46:
    'არის ერთ-ერთი წამყვანი დიზაინზე ორიენტირებული პროფესიული სწავლების ინსტიტუტი. ის წარმოდგენილია 25 ქვეყანაში. კრეატიული მულტიდისციპლინური გუნდები და საზოგადოებები აქ სწავლობენ, ვითარდებიან და მხარს უჭერენ. დიზაინის აზროვნება საშუალებას გაძლევთ განავითაროთ ინოვაციური იდეები, შესთავაზოთ ცვლილებები და გადაჭრათ რთული პრობლემები.',
  about_us_47:
    'მათი მისიაა უზრუნველყონ სივრცე და დრო გუნდებისა და ინდივიდებისთვის შთაგონებისთვის და გამოწვევისთვის, ისწავლონ საქმით და გააძლიერონ პრობლემების გადაჭრის კრეატიული უნარები, და დაეხმარონ ორგანიზაციებს შექმნან საჭირო გარემო და აზროვნება თამამი ინოვაციების დასაწყებად.',
  about_us_48:
    'არის ინდუსტრიაში ჩართული კომპანიების სავაჭრო ასოციაციის წარმომადგენელი Mystery Shopping. ასოციაცია მუშაობს რეგიონულ საფუძველზე მთელ მსოფლიოში, მისი ფილიალები განლაგებულია ამერიკაში, ევროპაში, აფრიკაში, აზიასა და წყნარი ოკეანის რეგიონში. წევრი კომპანიები იკრიბებიან ერთად იმუშაონ Mystery Shopping ინდუსტრიის გასაძლიერებლად.',
  about_us_49:
    'ეს არის არაკომერციული, წევრობაზე დაფუძნებული ორგანიზაცია. მისი წევრები ქმნიან საზოგადოებას, რომელიც დარწმუნებულია: მონაცემთა ანალიზს, კვლევასა და იდეებს შეუძლიათ გააუმჯობესონ საზოგადოების, ორგანიზაციებისა და ყველა ადამიანის ცხოვრება.',
  about_us_50:
    'ESOMAR-ის შტაბ-ბინა მდებარეობს ამსტერდამში (ნიდერლანდები). 1947 წლიდან ESOMAR მისი წევრი კომპანიების წყალობით წარმოდგენილია 130-ზე მეტ ქვეყანაში.',
  about_us_51:
    '— კერძო სპეციალისტებისა და კომპანიების პროფესიული საზოგადოება, რომელიც გაერთიანებულია საკონტაქტო ცენტრისა და მომხმარებელთა მომსახურების სფეროში განვითარებისა და ურთიერთქმედების მიზნით. UCCA-ს ფილოსოფიაა გააძლიეროს საკონტაქტო ცენტრის ინდუსტრიის კულტურა, რომელიც დაფუძნებულია თანამედროვე ტექნოლოგიებზე და მაღალ სტანდარტებზე.',
  about_us_52: 'უკრაინის საკონტაქტო ცენტრების ასოციაცია დაარსდა 2010 წელს.',
  about_us_53:
    'სწავლობს საუკეთესო მსოფლიო გამოცდილებას განათლების სფეროში, რათა მოერგოს და გამოიყენოს იგი უკრაინის ბაზარზე. სწორედ ამიტომ DTEK აკადემია თანამშრომლობს წამყვან საერთაშორისო ბიზნეს სკოლებთან: INSEAD, IE Business School და სტენფორდის უნივერსიტეტი.',
  about_us_54:
    'DTEK Academy ორიენტირებულია კლიენტზე ორიენტირებული და ინოვაციური კულტურის განვითარებაზე D.Client School, ID სკოლა, აღმასრულებელი განათლება: ინოვაციის ენერგია, კომუნიკაციების ძალა, DX School ციფრული პროგრამა, ეფექტური ლიდერი: Pre-MBA, Change Energy.',
  about_us_55: 'Сергій Пашковський',
  about_us_56: 'Вікторія Скорбота',
  about_us_57: 'Артем Фомін',
  about_us_58: 'Макс Папка',
  about_us_59: 'საერთაშორისო გაყიდვების მენეჯერი',
  about_us_59_female: 'საერთაშორისო გაყიდვების მენეჯერი',
  bht_1: 'ჯანმრთელობის თვალყურის დევნება',
  bht_2: 'ბრენდი',
  bht_3: 'ბრენდები წარმოუდგენლად ძლიერია',
  bht_4: 'გაარკვიეთ, რამდენად კარგად მუშაობს თქვენი ბრენდი მთლიანობაში',
  bht_5: 'შესახებ',
  bht_6: ' რა არის ბრენდის ჯანმრთელობის მონიტორინგი?',
  bht_7:
    'ეს არის ბაზრის კვლევის ტიპი, რომელიც ტარდება გარკვეული პერიოდულობით (ყოველ ორ კვირაში, ყოველ თვე და ა.შ.) იმისთვის, რომ მიიღოთ ინფორმაცია ბრენდის სტატუსის შესახებ',
  bht_8:
    'ბაზარზე, ისეთი მაჩვენებლების საფუძველზე, როგორიცაა ცნობადობა, მოთხოვნა, იმიჯი, მომხმარებელთა მახასიათებლები, ბრენდის ჯანმრთელობა და ა.შ.',
  bht_9: 'ისინი ყველაზე ხშირად ყიდულობენ ბრენდს',
  bht_10: 'ერთგული',
  bht_11: '3 თვეში ერთხელ ყიდულობენ ბრენდს',
  bht_12: 'რეგულარული მომხმარებლები',
  bht_13: '6 თვეში ერთხელ ყიდულობენ ბრენდს',
  bht_14: 'კლიენტები მოკლევადიან პერიოდში',
  bht_15: 'წელიწადში ერთხელ ყიდულობენ ბრენდს',
  bht_16: 'მომხმარებლები გრძელვადიან პერსპექტივაში',
  bht_17: 'იცნობს ბრენდს, მაგრამ არასოდეს გამომიყენებია/არ მიყიდია',
  bht_18: 'ნაცნობები, მაგრამ არა კლიენტები',
  bht_19: 'უცნობი: არასოდეს მსმენია ბრენდის შესახებ',
  bht_20: 'არ არის ნაცნობი',
  bht_21: 'ბრენდის მყიდველის პროფილი',
  bht_22:
    'ბრენდის შექმნისთვის გრძელვადიან პერსპექტივაში განხორციელებული ძალისხმევის თანმიმდევრულობის შეფასება',
  bht_23: 'მომხმარებლების ცოდნის დონის გაზომვა ბრენდის შესახებ',
  bht_24: 'სარეკლამო და საინფორმაციო კამპანიების ეფექტურობის ჩვენება',
  bht_25:
    'აქტიური სარეკლამო პერიოდის გავლენის განსაზღვრა გაყიდვებზე/კონკურენტების მარკეტინგულ საქმიანობაზე.',
  bht_26:
    'ბიზნესის მფლობელისთვის მუდმივი კონტროლის უზრუნველყოფა უწყვეტი ბაზრის ცვლილებების პერიოდში',
  bht_27: 'რა დავალებები შეუძლია შეასრულოს ბრენდის ჯანმრთელობის მონიტორინგს?',
  bht_28: 'კვლევის მოთხოვნა',
  bht_29: 'გადასაჭრელი ამოცანა',
  bht_30: 'მაგალითად,',
  bht_31:
    'თუ კომპანიას სჭირდება მხოლოდ ერთი სესია BHT კვარტალში ბაზრის წილების გაზომვისას, რესპონდენტთა გამოკითხვა უნდა ჩატარდეს უფრო ხშირად, რომ გაიზომოს ბრენდის ცნობადობა მომხმარებელთა შორის რეკლამიდან.',
  bht_32: 'CATI (კომპიუტერიზებული სატელეფონო ინტერვიუ)',
  bht_33: 'პირისპირ ინტერვიუ',
  bht_53: 'ინტერვიუ',
  bht_34: 'СAWI (ინტერნეტ ინტერვიუ კომპიუტერის გამოყენებით)',
  bht_35: 'ამოცანები გადასაჭრელად',
  bht_36: 'ინფორმაციის შეგროვება',
  bht_37:
    'სხვადასხვა მეთოდის გამოყენებით, ბრენდის ჯანმრთელობის მონიტორინგი, როგორც წესი, იყოფა სამ ეტაპად, მიზნობრივი აუდიტორიის და მისი მიღწევის სირთულის მიხედვით:',
  bht_38:
    'ჩვენ ვიყენებთ მონაცემთა შეგროვების როგორც ტრადიციულ, ასევე ინოვაციურ მეთოდებს.',
  bht_39:
    'ჩვენ ვმუშაობთ ორ მოდელზე: ერთი ინდიკატორების მარტივი ნაკრებით, ხოლო მეორე მიმართულია უფრო რთულ ინდუსტრიებზე, როგორიცაა საკვები და მომსახურება. უფრო რთული მოდელი მოიცავს სიღრმისეულ შესწავლას, მათ შორის 10-მდე გამოთვლილ ინდიკატორს.',
  bht_40: 'Ჩვენ გთავაზობთ',
  bht_41: 'გამომავალი კონტროლი',
  bht_42: 'ჩვენ გყავთ დაფარული',
  bht_43: 'მთელი ქვეყანა',
  bht_44: 'ჩვენ გთავაზობთ გადაწყვეტილებებს',
  bht_45:
    'არადინამიური ბაზრებისთვის/ბაზრებისთვის მოთამაშეთა შეზღუდული რაოდენობით (Brand Point Analyzer)',
  bht_46: 'Რატომ ჩვენ?',
  bht_47: 'რატომ გვირჩევენ ჩვენ?',
  bht_50: 'ცუდი შედეგი',
  bht_51: 'კარგი შედეგი',
  bht_52: 'საშუალო შედეგი',
  cases_1:
    'როგორ გავაუმჯობესოთ მომხმარებელთა მომსახურების ხარისხი ჰიუნდაის დილერებთან ელექტრო მანქანების შეძენისას?',
  cases_2: 'მომხმარებელთა ბილიკის რუკა',
  cases_3: 'იდეების ჩამოყალიბება',
  cases_4: 'თვისებრივი კვლევა',
  cases_5:
    'რა უნდა შეიცვალოს მაღაზიებში (როგორც მომსახურების პროცესში, ასევე ინტერიერში, ბრენდის აღქმაში) მყიდველებში ბრენდის მიმართ ინტერესის გასაღვივებლად Oppo?',
  cases_6: 'ონლაინ მომხმარებელთა ბილიკის რუკა',
  cases_7: 'მომხმარებლის ინტერფეისის ტესტირება',
  cases_8: 'ინტერვიუ',
  cases_9:
    'რა უნდა შეიცვალოს მაღაზიებში Oppo-ს ბრენდის მიმართ მყიდველების ინტერესის გასაღვივებლად?',
  cases_10: 'ხარისხის ნაწილი',
  cases_11: 'იდეების ჩამოყალიბება',
  cases_12: 'რაოდენობრივი ნაწილი',
  cases_13: 'მომხმარებელთა ბილიკის რუკა',
  cases_14: 'საქმეები',
  cases_15: 'ყველა',
  cases_16: 'მოდით ერთად გავაკეთოთ თქვენი მშვენიერი საქმე',
  csi_1: 'ინდექსი',
  csi_2: 'მომხმარებლის კმაყოფილება',
  csi_3: 'ჩვენ განვსაზღვრავთ კმაყოფილების მიზეზებს',
  csi_4: 'და მომხმარებელთა უკმაყოფილება',
  csi_5: 'მომხმარებელთა კმაყოფილების კვლევა',
  csi_6:
    'განსაზღვრავს ფაქტორებს, მიზეზებსა და მოტივებს, რომლებიც გავლენას ახდენენ მყიდველის გადაწყვეტილებაზე შესყიდვის შესახებ, ასევე მიზნობრივი აუდიტორიის ქცევაზე.',
  csi_7: 'მომხმარებელთა კმაყოფილების გამოკითხვა',
  csi_8:
    'აჩვენებს, რამდენად კმაყოფილია ან უკმაყოფილოა მომხმარებელი მომსახურების კონკრეტული ასპექტით ან პროდუქტის მთლიანობით',
  csi_9: 'კმაყოფილების გამოკითხვა',
  csi_10:
    'ტარდება კომპანიის არსებული მომხმარებლებისა და გარკვეული პროდუქტების/მომსახურების მომხმარებლებს შორის.',
  csi_11: 'რა არის CSI?',
  csi_12:
    'მომხმარებლის კმაყოფილება ზომავს, რამდენად შეესაბამება პროდუქტის ან მომსახურების შეძენისას მომხმარებლის მოლოდინებს თქვენი კომპანიის მიერ მიწოდებული პროდუქტი ან მომსახურება.',
  csi_13: 'ბედნიერი ადამიანი',
  csi_14: 'შესახებ',
  csi_15: 'განსაზღვროს მომხმარებელთა კმაყოფილებაზე, ',
  csi_16: 'მოქმედი ნებისმიერი ფარული ფაქტორი',
  csi_17: 'განსაზღვროს მოთხოვნის',
  csi_18: 'ზრდის/ვარდნის მიზეზები საქონელსა და მომსახურებაზე',
  csi_19: 'ვაუმჯობესებთ',
  csi_20: 'კომპანიის ბიზნეს-პროცესებს',
  csi_21: 'ვარგებთ მათ',
  csi_22: 'თანამედროვე მომხმარებლის მოთხოვნებთან',
  csi_23: 'ვქმნით ეფექტურ სარეკლამო შეტყობინებას',
  csi_24: 'და ვაყენებთ პროდუქტს მომხმარებლის მოთხოვნებზე',
  csi_25: 'ამოცანები გადასაჭრელად',
  csi_26:
    'რომელი ამოცანების გადაწყვეტა შეუძლია მომხმარებელთა კმაყოფილების გამოკითხვას',
  csi_27: 'კაცი ტელეფონით',
  csi_28: 'ჩვენ ვაშენებთ მათემატიკურ მოდელს',
  csi_29:
    'იმ ფაქტორებისათვის, რომლებიც შეიძლება გავლენას ახდენდნენ მომხმარებელთა კმაყოფილებაზე/ლოიალურობაზე (რეგრესიული ანალიზი)',
  csi_30: 'ვაუმჯობესებთ კომპანიის',
  csi_31: 'კბიზნეს-პროცესებს',
  csi_32: 'ჩვენ ვანგარიშობთ მომხმარებელთა კმაყოფილების ინდექსს',
  csi_33: '(CSI) და ვადარებთ მას დეკლარირებულს',
  csi_34: 'ჩვენ ვატარებთ კვლევებს',
  csi_35: 'B2B და B2C სეგმენტებისთვის.',
  csi_36: 'ჩვენი კითხვარები შემუშავებულია ანალიტიკოსთა გუნდის',
  csi_37:
    'გუნდის მიერ სპეციალურად ჩვენი კლიენტების ინდივიდუალური პროექტებისთვის',
  csi_38: 'Რატომ ჩვენ',
  csi_39: 'რატომ ირჩევენ ჩვენ?',
  csi_40: 'ინფორმაციის შეგროვების მეთოდები:',
  main_1:
    'ბიზნესი აუმჯობესებს ფინანსურ მაჩვენებელს მათი მომხმარებლების გამოცდილების გაცნობით',
  main_2:
    'კონსულტაციები და მომსახურება მომხმარებელთა გამოცდილების სფეროში, თქვენი ბიზნესის 360° ხედი',
  main_3:
    'აღმოაჩინეთ ჩვენი გადაწყვეტილებები და ინსტრუმენტები, რომლებიც დაგეხმარებათ თქვენი ბიზნესის მიზნების განხორციელებაში',
  main_4: 'პროდუქტები',
  main_5:
    'თვისებრივი კვლევა არის არარიცხობრივი მონაცემების შეგროვება და ანალიზი ცნებების, მოსაზრებების ან გამოცდილების გასაგებად.',
  main_6:
    'რაოდენობრივი კვლევის მეთოდები არის გამოკითხვების, კითხვარებისა და გამოკითხვების მეშვეობით შეგროვებული მონაცემების ობიექტური გაზომვა და რიცხვითი ანალიზი..',
  main_7:
    'საიდუმლო მყიდველი არის ბაზრის კვლევის მეთოდი მყიდველსა და კომპანიას ან ორგანიზაციას შორის ურთიერთქმედების გაზომვისა და მონიტორინგისთვის წინასწარ განსაზღვრულ სცენარში.',
  main_8:
    'უკუკავშირის მართვის სისტემა. თქვენი კლიენტის ხმა ერთ სისტემაში - მომხმარებელთა უკუკავშირის მართვის სისტემა',
  main_9:
    'ხელოვნური ინტელექტის მქონე კონტენტის ანალიზის პლატფორმა, რომელიც უზრუნველყოფს აუდიტორიის შეხედულებებს',
  main_10:
    'შესრულების მართვის პროგრამული უზრუნველყოფა. აპლიკაცია თამაშის სახით გაყიდვების გასაზრდელად',
  main_11:
    'ფასების მონიტორინგი არის კონკურენტების ფასების შეგროვების, დამუშავებისა და ანალიზის პროცესი.',
  main_12:
    'სერვის-დიზაინი — ეს არის ადამიანების საჭიროებებისა და სურვილების გაგება, რომლებიც ისარგებლებენ პროდუქტით ან სერვისით.',
  main_13:
    'ჩვენი ანალიტიკური გუნდი იყენებს უახლეს და ფუნდამენტურ მიდგომებს, რომელთა ეფექტურობა დასტურდება მრავალი კლიენტის გამოცდილებით.',
  main_14: 'მეთოდოლოგიები',
  main_15: 'მომხმარებელთა მოგზაურობის რუკა',
  main_16:
    'მომხმარებელთა მოგზაურობის რუქა (CJM) არის თქვენი სამიზნე აუდიტორიის განსაზღვრა, მათი საჭიროებებისა და გარემოს გაგება და შემდეგ გეგმის შექმნა, რათა ჩართოთ მომხმარებლები და წარმატებით ჩართოთ ისინი თქვენს ბრენდთან.',
  main_17: 'CJM მომხმარებელთა მოგზაურობის რუკა',
  main_18: 'მომხმარებელთა ლოიალობის ინდექსი (NPS)',
  main_19:
    'Net Promoter Score (NPS) არის მომხმარებელთა მომსახურების ოქროს სტანდარტი, რომელიც დაფუძნებულია ერთ კითხვაზე: რამდენად სავარაუდოა, რომ რეკომენდაციას გაუწევთ ორგანიზაციას/პროდუქტს/მომსახურებას?',
  main_20: 'მომხმარებელთა ლოიალობის ინდექსი NPS',
  main_21: 'BHT ბრენდის ჯანმრთელობის თვალყურის დევნება',
  main_22:
    'ბრენდის ჯანმრთელობის თვალთვალის (BHT) კვლევამ შეიძლება გაზომოს, თუ როგორ მუშაობს თქვენი ბრენდი ცნობადობისა და გამოყენების, ბრენდის პოზიციონირებისა და ბრენდის მუშაობის თვალსაზრისით.',
  main_23: 'BHT ბრენდის ჯანმრთელობის თვალყურის დევნება',
  main_24: 'ადამიანური რესურსების კვლევა',
  main_25:
    'ადამიანური რესურსების კვლევა გამოიყენება HR დეპარტამენტის მუშაობისა და პროდუქტიულობის შესაფასებლად და გთავაზობთ მიმდინარე განვითარებისა და მენეჯმენტის დეტალურ ანალიზს.',
  main_26: 'HR კვლევა',
  main_27: 'მომხმარებელთა კმაყოფილების ინდექსი',
  main_28:
    'ადამიანური რესურსების კვლევა გამოიყენება HR მუშაობის და პროდუქტიულობის შესაფასებლად და გთავაზობთ მიმდინარე განვითარებისა და მენეჯმენტის დეტალურ ანალიზს.',
  main_29: 'CSI მომხმარებელთა კმაყოფილების ინდექსი',
  main_30: 'UX ტესტირება',
  main_31:
    'გამოყენებადობის ტესტირება (UX) არის ტესტირება, თუ როგორ ურთიერთობენ რეალური ადამიანები ვებსაიტთან, აპლიკაციასთან ან სხვა პროდუქტთან; მომხმარებლის ქცევაზე დაკვირვება და მისი რეაქცია პროდუქტზე.',
  main_32: 'Რატომ ჩვენ',
  main_33:
    'ჩვენი მისიაა დავეხმაროთ კომპანიებს მომხმარებელთა პოზიტიური გამოცდილების შექმნაში.',
  main_34: 'ფოკუსირება ხარისხზე',
  main_35: 'ჩვენ ვაკონტროლებთ ხარისხს',
  main_36:
    'კვლევის მონაცემები. ყველა მონაცემთა ნაკრები ხელმისაწვდომია მომხმარებლებისთვის',
  main_37: 'ეკონომიკური ეფექტურობა',
  main_38: 'ჩვენი გამოცდილება, რესურსები და ოპტიმიზაცია',
  main_39: 'ბიზნეს პროცესები არის ის, რაც დაზოგავს თქვენს ფულს და დროს',
  main_40: 'ჭკვიანი გადაწყვეტილებები',
  main_41: 'ჩვენ ვიყენებთ სხვადასხვა ტექნიკას',
  main_42: 'და ინსტრუმენტები კონკრეტული პრობლემების გადასაჭრელად',
  main_52: 'Საცალო ვაჭრობა',
  main_53: 'ელექტრონიკა',
  main_54: 'Suite/ && Premium',
  main_55: 'რესტორნები და სასტუმროები',
  main_56: 'Საცალო',
  main_57: 'ავტომობილი',
  main_58: 'მოდა',
  main_59: 'ბანკები',
  main_60: 'მოგზაურობა და დასვენება',
  main_61: 'საათები და სამკაულები',
  main_62: 'Საყოფაცხოვრებო ნივთები',
  main_63: 'ბლოგი',
  main_64: 'გადადით ბლოგზე მეტი საინტერესო შინაარსის წასაკითხად',
  main_65: 'საცალო ვაჭრობის აუდიტი',
  main_66:
    'შეაგროვეთ დეტალური მონაცემები თქვენი მაღაზიის ან ბრენდის შესახებ, გააანალიზეთ ზრდის დაბრკოლებები და შექმენით ეფექტური სტრატეგიები მათ დასაძლევად',
  banner_1:
    'СX კონსულტაცია და მომსახურება, რომელიც საშუალებას გაძლევთ ნახოთ თქვენი ბიზნესი 360°-ში',
  banner_2: 'იყავით განახლებული უახლესი კვლევის შესახებ!',
  banner_3:
    'მე თანახმა ვარ პერსონალური მონაცემების დამუშავებაზე კონფიდენციალურობის პოლიტიკის შესაბამისად',
  banner_4: '*აირჩიეთ ბაზარი, რომლის შესახებაც გსურთ ინფორმაციის მიღება',
  banner_5: 'გმადლობთ თქვენი გამოწერისთვის!',
  banner_6: 'ჩვენ გაგიზიარებთ მხოლოდ ყველაზე საინტერესო შინაარსს!',
  banner_7: 'გაგზავნა',
  banner_8: 'უკრაინა',
  banner_9: 'ყაზახეთი',
  cjm_1: 'მომხმარებლის',
  cjm_2: 'გზის რუკა.გაეცანით',
  cjm_3: 'მომხმარებლების სამყაროს და გაიზიარეთ მათი გამოცდილება',
  cjm_4: 'რა არის მომხმარებლის გზის რუკა (Customer Journey Map)?',
  cjm_5:
    'CJM (Customer Journey Map) უზრუნველყოფს მომხმარებლის მიერ პროდუქტის, სერვისის, კომპანიის ან ბრენდის სხვადასხვა არხებზე და გარკვეული დროის განმავლობაში ურთიერთობის ვიზუალიზირებულ ისტორიას.',
  cjm_6:
    'ეს საშუალებას აძლევს კომპანიებს ობიექტურად გააანალიზონ მომხმარებლებთან ურთიერთობის გამოცდილება, ამოიცნონ და წაშალონ წარმოქმნილი ბარიერები და შესთავაზონ რეკომენდაციები პროდუქტის გაუმჯობესებისთვის.',
  cjm_7: 'გააზრება მიზნობრივი აუდიტორიისა და მისი სეგმენტაცია',
  cjm_8: 'კლიენტთან ურთიერთობის ეტაპების გამოვლენა',
  cjm_9: 'მომხმარებლებთან ურთიერთობის ძირითადი არხების იდენტიფიცირება',
  cjm_10: 'მომხმარებლის გამოცდილების კვლევა',
  cjm_11: 'ბარიერების ანალიზი და ოპტიმიზაციის ჰიპოთეზის შედგენა',
  cjm_12: 'ჰიპოთეზის განხორციელება და შემოწმება',
  cjm_13: 'მომხმარებლის გზის რუკის შექმნა შემდეგი ნაბიჯებისგან შედგება:',
  cjm_14: 'მომხმარებლის გზის რუკა გვაჩვენებს:',
  cjm_15:
    'CJM უზრუნველყოფს მომხმარებლის მიერ პროდუქტის, სერვისის, კომპანიის ან ბრენდის სხვადასხვა არხებზე და გარკვეული დროის განმავლობაში ურთიერთობის ვიზუალიზირებულ ისტორიას.',
  cjm_16: 'ჩვენ უზრუნველყოფთ გუნდურ მუშაობას',
  cjm_17: 'ანალიტიკოსებსა და დიზაინერებს შორის',
  cjm_18: 'ჩვენ ვთავაზობთ ინდივიდუალურ',
  cjm_19: 'მიდგომას თითოეულ კლიენტთან',
  cjm_20: 'ჩვენ გვყავს ინსტრუმენტები, რომლებიც',
  cjm_21:
    'რომლებიც ზრდიან კლიენტების დაკმაყოფილებას მომსახურებით ან პროდუქციით და, საბოლოო ჯამში, აუმჯობესებენ მათი ლოიალობას კომპანიის მიმართ.',
  cjm_22: 'ჩვენ გარანტიას გაძლევთ',
  cjm_23:
    'მომხმარებლის გზის ოპტიმიზაციას და კომპანიის ბიზნეს პროცესების გათვალისწინებას',
  cjm_24: 'ჩვენ ვთავაზობთ ჩვენს მომხმარებლებს',
  cjm_25:
    'კომბინირებული მიდგომების გამოყენების შესაძლებლობა: CATI, CAWI, ონლაინ ფოკუს-ჯგუფები, სიღრმისეული ინტერვიუები, ექსპერტთა ინტერვიუები, ეთნოგრაფია და ა.შ.',
  cjm_26: 'რატომ უნდა აგვირჩიოთ ჩვენ?',
  methods_hr_1: 'კვლევა პერსონალის მართვის შესახებ',
  methods_hr_2:
    'მიიღეთ ობიექტური ინფორმაცია თქვენი გუნდის შესახებ და ისწავლეთ როგორ გააუმჯობესოთ HR დეპარტამენტის ეფექტურობა.',
  methods_hr_3: 'არსებობს რამდენიმე მიზეზი, რის გამოც დაგჭირდებათ HR კვლევა',
  methods_hr_4: 'გამოკითხული თანამშრომლები',
  methods_hr_5: 'განხორციელებული HR პროექტები',
  methods_hr_6: 'ჩაატარა ტრენინგ-სემინარები პერსონალისთვის',
  methods_hr_7:
    'წამყვანი ევროპული ჰოლდინგი მომხმარებელთა გამოცდილებისა და თანამშრომლების კვლევის სფეროში',
  methods_hr_8: '4Service HR კვლევა ციფრებში',
  methods_hr_9:
    'პრობლემებისა და სუსტი წერტილების იდენტიფიცირება თქვენი კომპანიის თანამშრომლების ცხოვრების ყველა ეტაპზე: ძიება/დასაქმება/ადაპტაცია/კარიერული განვითარება/ხელახალი სერტიფიცირება',
  methods_hr_10: 'იცოდეთ რომელი საქმეები იმსახურებენ დანამატებსა და პრემიებს',
  methods_hr_11:
    'თქვენ უნდა იწინასწარმეტყველოთ ან შესთავაზოთ გადაწყვეტილებები თანამშრომლების უკმაყოფილებაზე',
  methods_hr_12:
    'ადამიანური რესურსების მართვის სფეროში კვლევის მეშვეობით შესაძლებელია ადამიანური რესურსების მართვის პოლიტიკის შეფასების ახალი და მიმდინარე პროგრამები, პრაქტიკა და მეთოდები.',
  methods_hr_13:
    'კომპანიის თანამშრომლების ფსიქიკური ჯანმრთელობის გასაუმჯობესებლად',
  methods_hr_14: 'თუ გსურთ გაზარდოთ პროდუქტიულობა ორიენტირებული მიდგომით',
  methods_hr_15:
    'თუ გყავთ საერთაშორისო და/ან დისტანციური გუნდი და გჭირდებათ მისი მართვა',
  methods_hr_16:
    'გაიგეთ, რამდენად მიმზიდველია თქვენი დამსაქმებლის ბრენდი პოტენციური თანამშრომლებისთვის',
  methods_hr_17: 'თანამშრომლების კმაყოფილება',
  methods_hr_18: 'HR ბრენდინგის კვლევა',
  methods_hr_19: 'Კულტურული მრავალფეროვნება',
  methods_hr_20: 'ანაზღაურება და სახელფასო გეგმები',
  methods_hr_21: 'გუნდური ჩართულობა და ერთგულება',
  methods_hr_22: 'დაცული კლასის თანამშრომლები',
  methods_hr_23: 'კვლევის სფეროები',
  methods_hr_24: 'გამოსავალი 1',
  methods_hr_25: 'eNPS, თანამშრომლების კმაყოფილება, თანამშრომლების ლოიალურობა',
  methods_hr_26: 'რასაც ვზომავთ:',
  methods_hr_27: 'ლოიალურობა:',
  methods_hr_28:
    'თანამშრომლების ლოიალურობა, მომავალი ქცევის პროგნოზირება, ლოიალურობაზე გავლენის მქონე ფაქტორების განსაზღვრა',
  methods_hr_29: 'მონაწილეობა:',
  methods_hr_30:
    'თანამშრომლების ჩართულობა სამუშაოში, შედეგებით და მიღწევებით დაინტერესება',
  methods_hr_31: 'ჩართულობა:',
  methods_hr_32: 'თანამშრომლების და კომპანიის ღირებულებების იდენტიფიკაცია',
  methods_hr_33: 'ნდობა 360:',
  methods_hr_34:
    'ნდობა ხელმძღვანელობის, კოლეგების, დაქვემდებარებულების მიმართ, ნდობა დამსაქმებლის სტრატეგიებისა და პოლიტიკის მიმართ',
  methods_hr_35: 'კმაყოფილება:',
  methods_hr_36:
    'თითოეული კომპანიისთვის უნიკალური ფაქტორების განსაზღვრა, კმაყოფილების შეფასება თითოეულ მნიშვნელოვან ფაქტორზე, რომელიც ლოიალურობაზე მოქმედებს.',
  methods_hr_37: 'გამოსავალი 2',
  methods_hr_38: 'დამსაქმებლის ბრენდი',
  methods_hr_39: 'შიდა ბრენდის ანალიზი',
  methods_hr_40:
    'დამსაქმებელი (თანამშრომლების, აქციონერების, შიდა რეკრუტერების და HR სპეციალისტების გამოკითხვა)',
  methods_hr_41: 'დამსაქმებლის გარე ანალიზი',
  methods_hr_42:
    '(EVP ანალიზი კონკურენტებთან შედარებით, გარე დამსაქმებლების გამოკითხვები, პოზიციებზე განმცხადებლების გამოკითხვები)',
  methods_hr_43: 'ბრენდის ცნობადობისა და რეპუტაციის ანალიზი',
  methods_hr_44: 'ანალიზი',
  methods_hr_45: 'დამსაქმებლის ყოფნის ანალიზი',
  methods_hr_47: 'მიმოხილვების კრებული დამსაქმებლის შესახებ',
  methods_hr_48: 'შეხვედრა',
  methods_hr_49: 'კონკურენტული ბენჩმარკინგი',
  methods_hr_50: 'ისეთ ძირითად ფაქტორებზე, როგორიცაა',
  methods_hr_51: 'ხელფასი,',
  methods_hr_52: 'სამუშაო გარემო, ატმოსფერო, სამუშაოს ბუნება',
  methods_hr_53: 'საჭიროებებისა და მოლოდინების ანალიზი',
  methods_hr_54: 'განმცხადებლები',
  methods_hr_55: 'სიღრმისეული ინტერვიუ:',
  methods_hr_56: 'გამოიყენება სამაგიდო და რაოდენობრივი კვლევები',
  methods_hr_57: 'გამოსავალი 3',
  methods_hr_58: 'თანამშრომლის გზის რუკა/ფარული თანამშრომელი',
  methods_hr_59: 'სამუშაოს ძიების გზის აგება, ძიების',
  methods_hr_60:
    'ძირითადი ეტაპების, კომუნიკაციის არხების, შერჩევისა და კანდიდატების შეფასების კრიტერიუმების განსაზღვრა',
  methods_hr_61: 'ყველა ეტაპისა და',
  methods_hr_62:
    'საკომუნიკაციო არხების მონიტორინგი ფარული კანდიდატების მეშვეობით (გასაუბრებაზე ჩაწერა, გასაუბრების გავლა, კომპანიის სტაჟირება)',
  methods_hr_63: 'დაქირავებისა',
  methods_hr_64: 'და ადაპტაციის პროცესებში სუსტი ადგილების იდენტიფიკაცია',
  methods_hr_65: 'გაუმჯობესების რეკომენდაციები,',
  methods_hr_66: 'შედარებითი ანალიზი სფეროს ლიდერებთან',
  mystery_shopping_1: 'საიდუმლო',
  mystery_shopping_2: 'მყიდველი',
  mystery_shopping_3:
    'შეაფასეთ თქვენი კომპანიის მიერ რეალური მომხმარებლების მიერ მოწოდებული სერვისები',
  mystery_shopping_4:
    'გადახედეთ და განსაზღვრეთ სტანდარტები, თუ როგორ შეიძლება თქვენი პერსონალი დაუახლოვდეს მომხმარებელს',
  mystery_shopping_5:
    'Ჩვენ ვართ საიდუმლო სავაჭრო მომწოდებლების პროფესიული წამყვანი ასოციაციის ელიტური წევრი MSPA Europe.',
  mystery_shopping_6: 'გამოცდილება',
  mystery_shopping_7: 'ვიზიტები ყოველთვიურად',
  mystery_shopping_8: 'საიდუმლო მყიდველები მთელს მსოფლიოში',
  mystery_shopping_9: 'აქტიური პროექტები',
  mystery_shopping_10: 'ოფისები, სათაო ოფისები ავსტრიაში',
  mystery_shopping_11: 'საიდუმლო მყიდველების სერვისის პროვაიდერები ევროპაში',
  mystery_shopping_12: 'მომსახურების ხარისხის რეიტინგები',
  mystery_shopping_13: 'კითხვარი',
  mystery_shopping_14: 'პროგრამული უზრუნველყოფა',
  mystery_shopping_15: 'მყიდველის პროფილი',
  mystery_shopping_16: 'პრეტენზიები და წინააღმდეგობები',
  mystery_shopping_17: 'ანალიტიკა',
  mystery_shopping_18:
    'ამ 5 ნაბიჯის წყალობით, ჩვენი კომპანია 4Service გარანტიას იძლევა საიდუმლო მყიდველების მომსახურების ხარისხს.',
  mystery_shopping_19: 'პროგრამა',
  mystery_shopping_20: '"Mystery Shopper" პროგრამის 5 ელემენტი 4Service-დან',
  mystery_shopping_21: 'კითხვარი:',
  mystery_shopping_22: 'თქვენი პროგრამის არსი',
  mystery_shopping_23:
    'აპლიკაციის ეს ნაწილი ხელმისაწვდომია ყველა დაინტერესებული მხარის სანახავად',
  mystery_shopping_24: 'ტოპ მენეჯერებისთვის.',
  mystery_shopping_25: 'აჩვენეთ პროცესის ყველა მნიშვნელოვანი ნაბიჯი და დეტალი',
  mystery_shopping_26: 'თანამშრომლებისთვის.',
  mystery_shopping_27: 'ასახეთ რას მოელიან მათგან დამსაქმებლები',
  mystery_shopping_28: 'საიდუმლო მყიდველებისთვის.',
  mystery_shopping_29:
    'სიცხადე და სტრუქტურა დაბნეულობისა და მიკერძოების თავიდან ასაცილებლად',
  mystery_shopping_30: 'Shopmetrics პროგრამული უზრუნველყოფა:',
  mystery_shopping_31: 'მოსახერხებელი და ინოვაციური',
  mystery_shopping_32: 'უპირატესობები:',
  mystery_shopping_33: 'აერთიანებს',
  mystery_shopping_34: 'თქვენი ბიზნეს პროცესებითა და პროგრამული უზრუნველყოფით',
  mystery_shopping_35: 'GDPR რეგულაცია',
  mystery_shopping_36: 'კონფიდენციალურობის მართვის ინსტრუმენტარიუმი',
  mystery_shopping_37: 'დეტალურად',
  mystery_shopping_38: 'სამართლებრივი შესაბამისობის პაკეტი',
  mystery_shopping_39: 'ავტომატიზირებული',
  mystery_shopping_40: 'ანგარიშების მშენებლობა',
  mystery_shopping_41: 'მენეჯმენტი',
  mystery_shopping_42: 'წვდომის დონეები',
  mystery_shopping_43: 'კითხვარების უმეტესობა',
  mystery_shopping_44: 'შესრულებულია ერთი საათის განმავლობაში',
  mystery_shopping_45: 'მყიდველის პროფილი:',
  mystery_shopping_46: '200,000+ იდუმალი მყიდველი მთელ მსოფლიოში',
  mystery_shopping_47:
    'ძირითადი კრიტერიუმები: მაქსიმალური სიახლოვე თქვენს სამიზნე აუდიტორიასთან, თქვენს კომპანიასთან ან კონკურენტებთან მუშაობის წინა გამოცდილება',
  mystery_shopping_48: 'მყიდველების ტრენინგი:',
  mystery_shopping_49: 'შესასვლელი სასწავლო ტესტი',
  mystery_shopping_50: 'სკაიპი / სატელეფონო ზარი',
  mystery_shopping_51: 'შეფასების ტესტი (სურვილისამებრ)',
  mystery_shopping_52: 'პრეტენზიები და წინააღმდეგობები',
  mystery_shopping_53: 'სისტემა',
  mystery_shopping_54: 'განცხადებები',
  mystery_shopping_55: '100% იუწყება',
  mystery_shopping_56: 'შემოწმებულია ვალიდატორთა ჯგუფის მიერ',
  mystery_shopping_57: 'დამატებითი ზარები',
  mystery_shopping_58: 'დაზუსტების მიზნით',
  mystery_shopping_59: 'აუდიო ჩანაწერები,',
  mystery_shopping_60:
    'ვიზიტის შემდეგ ყველაზე მნიშვნელოვანი პუნქტების აღსანიშნავად',
  mystery_shopping_61: 'პრევენციის სისტემა',
  mystery_shopping_62: 'თანამშრომლების თაღლითობა',
  mystery_shopping_63: 'სისტემა',
  mystery_shopping_64: 'წინააღმდეგობები',
  mystery_shopping_65: 'მყიდველის ნებისმიერი შეფასება',
  mystery_shopping_66: 'შეიძლება უარყოს თანამშრომელი პირდაპირ ვებგვერდზე',
  mystery_shopping_67: 'ყოველი წინააღმდეგობა',
  mystery_shopping_68:
    'განიხილება და უპასუხა ვალიდატორთა ადგილობრივი ჯგუფის მიერ',
  mystery_shopping_69: 'სტატისტიკის ნახვა შეგიძლიათ',
  mystery_shopping_70: 'წინააღმდეგობები',
  mystery_shopping_71: 'ანალიტიკა.',
  mystery_shopping_72: 'ანგარიში წარდგენილია პირადად და შეიცავს:',
  mystery_shopping_73: 'მტკივნეული',
  mystery_shopping_74: 'კომპანიის პუნქტები და პრობლემები',
  mystery_shopping_75: 'დინამიკა',
  mystery_shopping_76: 'ქვედანაყოფებისა და განყოფილებების მიხედვით',
  mystery_shopping_77: 'კორელაცია',
  mystery_shopping_78:
    'სტანდარტებთან შესაბამისობასა და მომხმარებლის კმაყოფილებას შორის',
  mystery_shopping_79: 'კონკურენტუნარიანი',
  mystery_shopping_80: 'ბენჩმარკინგი',
  mystery_shopping_81: 'პრაქტიკული',
  mystery_shopping_82: 'რეკომენდაციები სერვისის გასაუმჯობესებლად',
  mystery_shopping_83: 'რაც გამოგვარჩევს?',
  mystery_shopping_84: 'ჩვენ ვატარებთ იდეების გენერირების სესიებს',
  mystery_shopping_85:
    'ჩვენ არა მხოლოდ ვაძლევთ რეკომენდაციებს, თუ რა უნდა გავაკეთოთ, არამედ ვეძებთ თქვენთან ერთად სერვისის ამოცანების გადაჭრის პრაქტიკულ გზებს.',
  mystery_shopping_86: 'ტვინის შტორმის სესიები ჩვენთვის ძლიერი ინსტრუმენტია:',
  mystery_shopping_87:
    'შეიმუშავეთ მიმართულებები პროდუქტის ან სერვისის გაუმჯობესებისთვის',
  mystery_shopping_88:
    'გამოიკვლიეთ შემოსავლების ნაკადის ახალი შესაძლებლობები და ბიზნეს სტრატეგიები',
  mystery_shopping_89:
    'იპოვნეთ გადაწყვეტილებები მომხმარებელზე ორიენტირებული რთული ამოცანებისთვის',
  mystery_shopping_90: 'გადააქციეთ მომხმარებლის ტკივილის წერტილები სატყუარებად',
  mystery_shopping_91: 'ვატარებთ ვიდეო ინტერვიუს',
  mystery_shopping_92:
    'ჩვენ არ ვაგროვებთ მხოლოდ კითხვარებს - ასევე ვიღებთ მყიდველების პირდაპირ კომენტარებს',
  mystery_shopping_93: 'ჩვენ ამას ვაკეთებთ იმისათვის, რომ:',
  mystery_shopping_94:
    'ჩვენი ფასილიტატორები ჩაატარებენ სიღრმისეულ ინტერვიუებს და მოგცემენ ეფექტურ უკუკავშირს',
  mystery_shopping_95: 'შეხედეთ მომსახურებას მომხმარებლის პერსპექტივიდან',
  mystery_shopping_96: 'გააუმჯობესე კონტენტ მარკეტინგის სტრატეგია',
  mystery_shopping_97: 'იწინასწარმეტყველეთ მომხმარებლის ქცევა',
  mystery_shopping_98: 'ჩვენ ვამუშავებთ მომხმარებელთა მოგზაურობის რუკას',
  mystery_shopping_99:
    'მომხმარებელთა მოგზაურობის რუქის შექმნა გვეხმარება მომხმარებლების ადგილზე ჩავდოთ მათი საჭიროებებისა და პრობლემების გაგებაში.',
  mystery_shopping_100: 'მომხმარებლის მოგზაურობის შექმნა საუკეთესო გზაა',
  mystery_shopping_101: 'განიხილეთ გამოცდილება მომხმარებლის პერსპექტივიდან',
  mystery_shopping_102: 'გააუმჯობესე კონტენტ მარკეტინგის სტრატეგია',
  mystery_shopping_103: 'იწინასწარმეტყველეთ მომხმარებლის ქცევა',
  mystery_shopping_104: 'იდენტიფიცირება ხარვეზები სამსახურში ან კომუნიკაციებში',
  mystery_shopping_105: 'გთავაზობთ სხვადასხვა სახის საიდუმლო შოპინგის',
  mystery_shopping_106: 'საიდუმლო შოპინგის სახეები',
  mystery_shopping_107: 'იდუმალი გამრეკელი',
  mystery_shopping_108:
    'ურეკავს თქვენს მენეჯერებს და/ან ქოლ ცენტრში, რათა დადგინდეს მოწოდებული სერვისის ხარისხი ტელეფონით',
  mystery_shopping_109: 'ფუფუნების საიდუმლო შოპინგი',
  mystery_shopping_110:
    'ლუქს დაწესებულებებში მომსახურების შემოწმება საიდუმლო მყიდველების სპეციალური კატეგორიის მიერ',
  mystery_shopping_111: 'საკონკურსო ვიზიტები',
  mystery_shopping_112:
    'უმარტივესი გზა იმის გასაგებად, თუ როგორ მუშაობს თქვენი კონკურენცია',
  mystery_shopping_113: 'საიდუმლო თანამშრომელი',
  mystery_shopping_114:
    'დაგეხმარებათ გაიგოთ თქვენი თანამშრომლის მთელი მოგზაურობა (დაქირავება, ბორტზე დაყენება, საოფისე პროცესები და ა.შ.)',
  mystery_shopping_115: 'სამოტივაციო ვიზიტები',
  mystery_shopping_116:
    'სასარგებლო ინსტრუმენტი დამატებითი სერვისების ან/და საქონლის შეთავაზების, კონკრეტული საქონლის გაყიდვის სტიმულირებისთვის',
  mystery_shopping_117: 'Mystery shopper ონლაინ',
  mystery_shopping_118:
    'ახდენს და განსაზღვრავს მომხმარებლის მომსახურების ხარისხს თქვენს ონლაინ მაღაზიაში, ვებსაიტზე ან აპლიკაციაში.',
  mystery_shopping_119: 'გაყიდვებისა და აქციების შემოწმება',
  mystery_shopping_120:
    'გვეხმარება იმის დადგენაში, თუ როგორ არის ნაჩვენები აქციები ყველა ადგილას და რამდენად ეფექტურად მუშაობს ისინი.',
  mystery_shopping_121: 'შესყიდვა და დაბრუნების ვიზიტები',
  mystery_shopping_122:
    'ეხმარება შეძენიდან დაბრუნებამდე პროცესის შედგენას, რათა გააუმჯობესოს მომხმარებელთა მომსახურება.',
  mystery_shopping_123: '20+ წელი',
  nps_1: 'ინდექსი NPS',
  nps_2: 'მომხმარებლის ლოიალურობის',
  nps_3: 'გაზომეთ, აკონტროლეთ და გაზარდეთ მომხმარებელთა ლოიალურობა',
  nps_4: 'ისინი პასუხობენ 0-დან 6-მდე შეფასებით.',
  nps_5:
    'შესაძლოა, მათ ჰქონდათ ცუდი გამოცდილება — ისინი აღარ შეიძენენ თქვენგან და შეიძლება სხვებსაც ურჩიონ იგივე.',
  nps_6: 'ეს არიან რესპონდენტები, რომლებმაც აირჩიეს 7-დან 8 ქულამდე შეფასება.',
  nps_7:
    'ისინი კმაყოფილები არიან თქვენი სერვისით, მაგრამ არა იმდენად, რომ მათ პრომოუტერები ვუწოდოთ.',
  nps_8:
    'ეს არიან რესპონდენტები, რომლებიც აფასებენ თქვენს ბიზნესს 9 ან 10 ქულით.',
  nps_9:
    'ეს ნიშნავს, რომ ისინი გირჩევენ მეგობარს ან კოლეგას და დადებითად ისაუბრებენ თქვენზე.',
  nps_10: 'რა არის NPS?',
  nps_11: 'ის აფასებს მომხმარებლების აღქმას ერთი მარტივი კითხვის საფუძველზე:',
  nps_12:
    'რამდენად შესაძლებელია, რომ თქვენ ურჩევთ [ორგანიზაციას/პროდუქტს/სერვისს] მეგობარს ან კოლეგას?',
  nps_13: 'სჭირდება თუ არა ეს ჩემს კომპანიას?',
  nps_14: 'NPS — თქვენი სტაბილური ზრდა',
  nps_15: 'მომხმარებლების ლოიალურობის დინამიკის გაგება',
  nps_16: 'თქვენი თანამშრომლების მოტივირება',
  nps_17: 'გავიგოთ კავშირი სხვადასხვა  პროდუქტის მიმართ',
  nps_18:
    'შევადაროთ, რა დამოკიდებულება აქვს მომხმარებელს თქვენსა და კონკურენტის შორის',
  nps_19: 'რა შეიძლება გავაკეთო NPS-ით?',
  nps_20: 'სად გამოდგება NPS?',
  nps_21: 'ინფორმაციის შეგროვების მეთოდები:',
  nps_22: 'ჩვენი რეკომენდაციები NPS-თან მუშაობისთვის',
  nps_23:
    'ეს ნიშნავს, რომ ჩვენ ვქმნით რეკომენდაციებს, რომლებიც დაგეხმარებათ მოწინააღმდეგეების პრომოუტერებად გარდაქმნაში.',
  nps_24: 'ვმუშაობთ დახურული ციკლის მეთოდით.',
  nps_25:
    'NPS — ეს არის მონიტორინგის კვლევა, რომლის დახმარებითაც ვადევნებთ თვალს მომხმარებლების ლოიალურობის ცვლილებებს.',
  nps_26: 'დინაიმიკის კონტროლი',
  nps_27:
    'გირჩევთ ყოველთვის შეაფასოთ თქვენი ნიშის კონკურენტები უფრო ღრმა ანალიზისთვის',
  nps_28: 'კონკურენტების შეფასება',
  price_monitoring_1: 'ფასების მონიტორინგი',
  price_monitoring_2: 'და საცალო ვაჭრობის მონიტორინგი',
  price_monitoring_3:
    'ზრდის გაყიდვების პოტენციალს და ოპტიმიზებს საფასო პოლიტიკას კონკურენტების ფასების მონიტორინგით',
  price_monitoring_4:
    '4Service 20 წელზე მეტია ახორციელებს ფასების მონიტორინგის სერვისებს მთელ მსოფლიოში.',
  price_monitoring_5:
    'ჩვენი კვალიფიციური სრულ განაკვეთზე აუდიტორთა გუნდი აკონტროლებს ფასებს მოკლე დროში, რაც საშუალებას გვაძლევს სწრაფად ვუპასუხოთ კონკურენტების ფასების ცვლილებას.',
  price_monitoring_6:
    'ამოცანები, რომლებსაც ჩვენი კომპანია ეხმარება გადაჭრას ფასების მონიტორინგის დახმარებით',
  price_monitoring_7: 'კონკურენტების ფასების შეფასება',
  price_monitoring_8: 'და კვების პოლიტიკა',
  price_monitoring_9: 'აქციების მონიტორინგი',
  price_monitoring_10: 'და სპეციალური შეთავაზებები',
  price_monitoring_11: 'ბაზრის პირობების მონიტორინგი',
  price_monitoring_12: 'და საბაზრო გარემო',
  price_monitoring_13: 'გაყიდვების პუნქტების ინსპექტირება და კონტროლი',
  price_monitoring_14:
    'სპეციალური აღჭურვილობისა და საქონლის ხელმისაწვდომობისთვის',
  price_monitoring_15: 'კვების მენეჯმენტი',
  price_monitoring_16: 'ნაკადი ვაჭრობის ფარგლებში',
  price_monitoring_17: 'ოპტიმიზაციის პირობები',
  price_monitoring_18: 'მომწოდებლებთან, დილერებთან უკეთესი თანამშრომლობისთვის',
  price_monitoring_19: 'თაროების სივრცის გაზომვა,',
  price_monitoring_20:
    'საქონლის ადგილმდებარეობის შეფასება, მარაგების ხელმისაწვდომობა',
  price_monitoring_21: 'ძირითადი ინდიკატორები და მონიტორინგის კრიტერიუმები',
  price_monitoring_22: 'ყველა მონაცემი გროვდება ერთ ინტერფეისში, მათ შორის:',
  price_monitoring_23: 'სახელი',
  price_monitoring_24: 'პროდუქტისა და ბრენდის კატეგორიები',
  price_monitoring_25: 'ხელმისაწვდომობა',
  price_monitoring_26: 'სარეკლამო მასალები',
  price_monitoring_27: 'ფასი',
  price_monitoring_28: 'და სარეკლამო შეთავაზებების ხელმისაწვდომობა',
  price_monitoring_29: 'ზომა',
  price_monitoring_30: 'თაროები',
  price_monitoring_31: 'წარმომადგენლობა',
  price_monitoring_32: 'პროდუქტი',
  price_monitoring_33: 'SKU',
  price_monitoring_34: 'პირისპირ',
  price_monitoring_35: 'ტიპი',
  price_monitoring_36: 'შეფუთვა',
  price_monitoring_37: 'ნებისმიერი სხვა',
  price_monitoring_38: 'ზოგადი ინფორმაცია',
  price_monitoring_39: 'პროექტის წინასწარი ანალიზი:',
  price_monitoring_40: 'Ჩვენ ვსწავლობთ',
  price_monitoring_41:
    'თქვენი კომპანიის ფასებისა და პროდუქტის პოლიტიკა, ბიზნეს და ინდუსტრიის პრაქტიკა',
  price_monitoring_42: 'ჩვენ გთავაზობთ',
  price_monitoring_43:
    'აუდიტორთა ოპერატიული მომზადება, ტესტირება და სერტიფიცირება',
  price_monitoring_44: 'ჩვენ ინდივიდუალურად ადაპტირდებით',
  price_monitoring_45: 'და დააკონფიგურირეთ პროგრამული უზრუნველყოფა',
  price_monitoring_46: 'საველე სამუშაოები:',
  price_monitoring_47: 'ვიზიტის წერტილები',
  price_monitoring_48: 'საცალო ვაჭრობა',
  price_monitoring_49: 'ანგარიშების შედგენა:',
  price_monitoring_50: 'ჩვენი ანალიტიკური გუნდი',
  price_monitoring_51: 'ამზადებს ონლაინ ანგარიშებს კომპანიის პირად ოფისებში',
  price_monitoring_52: 'ჩვენ გთავაზობთ',
  price_monitoring_53:
    'სრული ფოტორეპორტაჟი, PPT ანგარიში, Excel ანგარიში, სადაც მითითებულია დასახლების ტიპი, ქსელის სახელი, განყოფილების მისამართი',
  price_monitoring_54: 'Როგორ არის',
  price_monitoring_55: 'სამუშაო',
  price_monitoring_56: 'ინდივიდუალური ფასდაკლების ოდენობა',
  price_monitoring_57: 'ხარჯების გაანგარიშება',
  price_monitoring_58: 'ინდივიდუალური ბონუსების ოდენობა',
  price_monitoring_59: 'ლოიალობის პროგრამები',
  price_monitoring_60: 'და ა.შ.',
  price_monitoring_61: 'ჩვენ ვიყენებთ სპეციალიზებულ პროგრამულ უზრუნველყოფას:',
  price_monitoring_62:
    'PRADATA, Shopmetrics და გთავაზობთ ყოვლისმომცველ ტექნიკურ მხარდაჭერას',
  price_monitoring_63: 'სწრაფი გამოყენება',
  price_monitoring_64: 'და სკალირება (პირველი დღიდან)',
  price_monitoring_65: 'ყველა მონაცემი დადასტურებულია',
  price_monitoring_66: 'ფოტოები და GPS ტეგები',
  price_monitoring_67: 'ჩვენ გვაქვს საჭირო რაოდენობა',
  price_monitoring_68: 'საველე აგენტები ნებისმიერ ქვეყანაში',
  price_monitoring_69: 'ჩვენ შეგვიძლია ვიმუშაოთ დიდი',
  price_monitoring_70: 'მონაცემთა რაოდენობა',
  price_monitoring_71: 'ინდივიდუალური ფასების მონიტორინგი',
  price_monitoring_72:
    'თუ თქვენ გაქვთ პროდუქტის მიქსი, ჩვენ დაგეხმარებით თქვენი ფასების სტრატეგიის განსაზღვრაში',
  price_monitoring_73:
    'ჩვენ შეგვიძლია ვადევნოთ თვალი კონკურენტების ცალკეულ ფასებს, მაგალითად:',
  price_monitoring_74: 'დაბალი',
  price_monitoring_75: 'ღირს',
  price_monitoring_76: 'მაღალი',
  price_monitoring_77: 'ეფექტურობა',
  price_monitoring_78: 'Excel ანგარიში',
  price_monitoring_79: 'PRT-ანგარიში',
  price_monitoring_80: 'ბიზნეს დაზვერვის ანგარიში',
  price_monitoring_81:
    'კონკურენტების ფასების შესახებ მონაცემები ხელს უწყობს ფასების ოპტიმალური გადაწყვეტილებების მიღებას.',
  price_monitoring_82:
    'ჩვენ გთავაზობთ სრულ ფოტორეპორტაჟს, PPT ანგარიშს, Excel-ის ანგარიშს დასახლების ტიპის მიხედვით',
  qualitative_research_1: 'ხარისხიანი',
  qualitative_research_2: 'კვლევები',
  qualitative_research_3:
    'შეაგროვეთ, გააანალიზეთ და ინტერპრეტაცია გაუკეთეთ მონაცემებს, დაკვირვებით თქვენს კლიენტების ქმედებებსა და სიტყვებზე.',
  qualitative_research_4: 'ღირებულებები',
  qualitative_research_5: 'Მოქმედება',
  qualitative_research_6: 'დაგროვილი გამოცდილება',
  qualitative_research_7: 'მოლოდინი',
  qualitative_research_8: 'გარემო',
  qualitative_research_9: 'შიშები/ბარიერები',
  qualitative_research_10: 'რა არის მომხმარებლის არჩევანის მიზანი?',
  qualitative_research_11: 'კაცი ტელეფონით',
  qualitative_research_12: 'ბრენდი',
  qualitative_research_13: 'კატეგორია',
  qualitative_research_14: 'სარეკლამო',
  qualitative_research_15: 'პროდუქტი',
  qualitative_research_16:
    'თვისებრივი მეთოდების უნიკალურობა იმაში მდგომარეობს, რომ ისინი საშუალებას გვაძლევს გავიგოთ მომხმარებლის ქცევის მიზეზები და მოტივები.',
  qualitative_research_17:
    'მომხმარებლის დამოკიდებულების ანალიზი ამა თუ იმ მოვლენასთან დაკავშირებით',
  qualitative_research_18: 'ინდივიდუალურ შეხედულებებსა და გამოცდილებას',
  qualitative_research_19:
    'თემებს, რომელთა გამოკვლევაც შეუძლებელია გამოკითხვებით',
  qualitative_research_20: 'დელიკატურ თემებს',
  qualitative_research_21: 'რთულად მისადგომ აუდიტორიას',
  qualitative_research_22: 'რთულ გეოგრაფიულ მდებარეობას',
  qualitative_research_23:
    'სიღრმისეული ინტერვიუები სასარგებლოა, როდესაც საქმე ეხება:',
  qualitative_research_24: 'სიღრმისეული ინტერვიუები',
  qualitative_research_25:
    'სიღრმისეული ინტერვიუ არის ხარისხიანი კვლევის მეთოდი, რომელიც მოიცავს ინდივიდუალური ინტერვიუების ჩატარებას რესპონდენტებთან, რათა შეისწავლოს მათი შეხედულებები კონკრეტულ იდეაზე, პროგრამაზე ან სიტუაციაზე. დეტალური ინტერვიუ ღრმად იკვლევს ინდივიდუალურ გამოცდილებას/აღქმას/პრაქტიკას.',
  qualitative_research_26: 'მიზნები:',
  qualitative_research_27: 'სოციალური და კულტურული ნორმების დახასიათებას',
  qualitative_research_28: 'რთულად მისადგომ აუდიტორიას',
  qualitative_research_29: 'რთულად მისაღწევი აუდიტორიის ჩართულობას',
  qualitative_research_30:
    'თემებს, რომელთა გამოკვლევაც შეუძლებელია გამოკითხვებით',
  qualitative_research_31:
    'სიღრმისეული ონლაინ ფოკუს-ჯგუფები სასარგებლოა, როდესაც საქმე ეხება:',
  qualitative_research_32: 'ონლაინ ფოკუს-ჯგუფები',
  qualitative_research_33:
    'ღრმა შესწავლა ინდივიდუალური შეხვედრებისა და წამოჭრილი დისკუსიების, ჯგუფის მოდერატორის ხელმძღვანელობით.',
  qualitative_research_34:
    'ინფორმაციის მიღება საერთო გამოცდილებისა და სოციალური ნორმების შესახებ მიზანმიმართული ჯგუფური განხილვისა და მოთხრობების მონაცემების საფუძველზე.',
  qualitative_research_36: 'უპირატესობები:',
  qualitative_research_37:
    'მომხმარებლის ცხოვრების სტილისა და ქცევის შესასწავლად სხვადასხვა რეალურ პირობებში (სახლში, სავაჭრო წერტილში, სამუშაოზე და ა.შ.)',
  qualitative_research_38:
    'იდეების ძიებისთვის ახალი პროდუქტების, შეფუთვის, მომსახურების გაუმჯობესების და ა.შ. შემუშავებისათვის',
  qualitative_research_39: 'ღრმა ეთნოგრაფიული კვლევა სასარგებლოა:',
  qualitative_research_40: 'ეთნოგრაფიული კვლევა',
  qualitative_research_41:
    'ეთნოგრაფია — ეს არის ხარისხობრივი კვლევის ტიპი, რომელიც მოიცავს განსაზღვრული საზოგადოების ან ორგანიზაციის ცხოვრებაში ჩაღრმავებას და მათი ქცევის და ურთიერთქმედების ახლო მანძილიდან დაკვირვებას.',
  qualitative_research_42:
    'ეთნოგრაფია არის მოქნილი კვლევის მეთოდი, რომელიც საშუალებას გაძლევთ უფრო ღრმად გაიგოთ ჯგუფის საერთო კულტურა, ტრადიციები და სოციალური დინამიკა. თუმცა, ის ასევე დაკავშირებულია ზოგიერთ პრაქტიკულ და ეთიკურ გამოწვევებთან.',
  qualitative_research_43: 'მეთოდები:',
  qualitative_research_44:
    'ეთნოგრაფია — ეს არის მომხმარებლის რეალურ პირობებში შესწავლა და მისი ურთიერთქმედება პროდუქტთან/მომსახურებასთან.',
  qualitative_research_45: 'ჩვენთან მუშაობის უპირატესობები',
  qualitative_research_46:
    'ჩვენ შეგვიძლია მოვძებნოთ რესპონდენტები ნებისმიერი მიზნობრივი აუდიტორიისგან. ჩვენ ვაკონტროლებთ რეკრუტინგის ხარისხს',
  qualitative_research_47: 'ნებისმიერი სირთულის რეკრუტინგი',
  qualitative_research_48:
    'ჩვენი მოდერატორები არიან მრავალენოვანი და აქვთ ფასილიტაციისა და პრობლემების მოგვარების უნარები',
  qualitative_research_49: 'გამოცდილი მოდერატორები',
  qualitative_research_50: 'ონლაინ/ოფლაინ მუშაობა',
  qualitative_research_51: 'ჩვენ გთავაზობთ აუდიო/ვიდეო ჩანაწერებს',
  qualitative_research_52: 'ჩაწერა',
  qualitative_research_53:
    'ჩვენ შეგვიძლია ჩავატაროთ ხარისხიანი კვლევა ნებისმიერ ლოკაციაში',
  quantitative_research_1: 'კლიენტთა კმაყოფილების კვლევა',
  quantitative_research_2:
    'კონკრეტული პროდუქტის ან მომსახურების მიმართ (SCI, NPS)',
  quantitative_research_3: 'სხვადასხვა ბაზრების',
  quantitative_research_4: 'სეგმენტაციის გამოკითხვების ჩატარება',
  quantitative_research_5: 'ბაზრის კვლევა',
  quantitative_research_6: 'NPS მართვა',
  quantitative_research_7: 'კონკურენტების ანალიზი',
  quantitative_research_8: 'რაოდენობრივი',
  quantitative_research_9: 'კვლევები',
  quantitative_research_10:
    'კვლევის მეთოდოლოგია, რომელიც გამოიყენება თეორიების შესამოწმებლად ადამიანების დამოკიდებულებისა და ქცევის შესახებ, ობიექტური, რიცხვითი და სტატისტიკური მონაცემების საფუძველზე.',
  quantitative_research_11: 'წლები',
  quantitative_research_12: 'CX გამოცდილება მთელ მსოფლიოში',
  quantitative_research_13: 'პანელი',
  quantitative_research_14: 'რესპონდენტებს',
  quantitative_research_15: 'ქვეყნები',
  quantitative_research_16: 'ჩვენ ვმუშაობთ პროექტებზე მთელ მსოფლიოში',
  quantitative_research_17: 'ვინ ვართ ჩვენ',
  quantitative_research_18:
    '4Service — გლობალური ჰოლდინგი, რომელიც ახორციელებს მარკეტინგულ და CX-კვლევებს. ჩვენ ვთავაზობთ ექსპერტულ სერვისებს მონაცემთა შეგროვებაში სხვადასხვა ბიზნესისთვის',
  quantitative_research_19: '4service რიცხვებში',
  quantitative_research_20: 'კომპიუტერიზებული',
  quantitative_research_21: 'ვებ ინტერვიუ',
  quantitative_research_22:
    'გამოკითხვის მეთოდი ინტერნეტში. რესპონდენტი ავსებს ელექტრონულ კითხვარს ინტერვიუერის დახმარების გარეშე. კითხვარი შეიძლება გაიგზავნოს ელექტრონული ფორმით ან განთავსდეს ვებგვერდზე.',
  quantitative_research_23: 'კომპიუტერული ვებ-გასაუბრება',
  quantitative_research_24: 'უმეტეს შემთხვევაში',
  quantitative_research_25:
    'აღნიშნული მეთოდი ყველაზე ეკონომიურია როგორც მატერიალური, ასევე დროითი ხარჯების თვალსაზრისით',
  quantitative_research_26: 'ეს გამოკითხვა საშუალებას გაძლევთ',
  quantitative_research_27:
    'ჩაატაროთ ინტერვიუ რთულად ხელმისაწვდომ აუდიტორიასთან',
  quantitative_research_28: 'ის გთავაზობთ ფართო შესაძლებლობებს ვიდეო',
  quantitative_research_29:
    'და აუდიო მასალების, ასევე გამოსახულებების ჩვენებისთვის',
  quantitative_research_30: 'რესპონდენტები შეიძლება',
  quantitative_research_31: 'იყვნენ მსოფლიოს ნებისმიერი წერტილიდან',
  quantitative_research_32: 'ეს საშუალებას იძლევა ინტერნეტ',
  quantitative_research_33:
    'ინფორმაციისთვის, დელიკატური, პირადი თემა ან შეკითხვა, რომელზეც რესპონდენტებს შესაძლოა არ სურდეთ პასუხის გაცემა',
  quantitative_research_34:
    'ხელმისაწვდომია ნებისმიერი კონფიდენციალური ინფორმაციისთვის,',
  quantitative_research_35:
    'დელიკატური, პირადი თემა ან შეკითხვა, რომელზეც რესპონდენტებს შესაძლოა არ სურდეთ პასუხის გაცემა ინტერვიუერთან საუბრის დროს',
  quantitative_research_36: '150000+ პანელი',
  quantitative_research_37:
    'ჩვენ გვყავს რესპონდენტთა საკუთარი პანელი მთელს მსოფლიოში.',
  quantitative_research_38: 'ჩვენ ვმუშაობთ კომპლექსური მოთხოვნებით',
  quantitative_research_39:
    'დამატებითი ინსტრუმენტების გამოყენებით (სოციალური ქსელები, რეკლამა) შეგვიძლია ვიპოვოთ კონკრეტული აუდიტორია და რესპონდენტის კონკრეტული პროფილი.',
  quantitative_research_40: 'მოტივაციას ვაძლევთ ჩვენს რესპონდენტებს',
  quantitative_research_41:
    'ჩვენ შევიმუშავეთ მატერიალური წახალისების მიწოდებით ხანგრძლივი კვლევების დასრულების წახალისების სისტემა.',
  quantitative_research_42: 'პირადი ინტერვიუები',
  quantitative_research_43: 'ტაბლეტის გამოყენებით ტარდება',
  quantitative_research_44:
    'ეს არის ერთ-ერთი ძირითადი მეთოდი რაოდენობრივი მონაცემების შეგროვებისთვის, რომლის დროსაც ინტერვიუერი პირდაპირ ურთიერთობს რესპონდენტთან მკაცრად სტრუქტურირებული კითხვარის მეშვეობით.',
  quantitative_research_45:
    'პირადი ინტერვიუები შეიძლება ჩატარდეს რესპონდენტის სამუშაო ადგილზე, საცხოვრებელ ადგილზე, ქუჩაში ან სპეციალურად გამოყოფილ სავაჭრო ადგილებში ტაბლეტის გამოყენებით.',
  quantitative_research_46:
    'პირადი ინტერვიუები, ჩატარებული ტაბლეტის გამოყენებით',
  quantitative_research_47: 'ბრენდის პოპულარობისა',
  quantitative_research_48: 'და ცნობადობის დონის განსაზღვრა',
  quantitative_research_49: 'მომხმარებლების სეგმენტაცია',
  quantitative_research_50: 'მათი ყიდვის ქცევის მიხედვით',
  quantitative_research_51: ' სარეკლამო კამპანიის',
  quantitative_research_52: 'ეფექტიანობის ანალიზი',
  quantitative_research_53: 'კლიენტთა კმაყოფილების',
  quantitative_research_54: 'გაზომვა',
  quantitative_research_55: ' პროდუქტის ან მომსახურების საუკეთესო',
  quantitative_research_56: 'საუკეთესო ფასის განსაზღვრა',
  quantitative_research_57: 'მომხმარებელთა',
  quantitative_research_58: 'პრეფერენციების ანალიზი',
  quantitative_research_59: 'მომხმარებელთა',
  quantitative_research_60: 'ყიდვის პროცესის შესწავლა',
  quantitative_research_61: 'ბაზრის',
  quantitative_research_62: 'საბაზრო შესაძლებლობები',
  quantitative_research_63: 'DigSee პროგრამული უზრუნველყოფა',
  quantitative_research_64:
    'ჩვენ ვიყენებთ სპეციალურ პროგრამულ უზრუნველყოფას აუდიოჩანაწერით და GPS-ით',
  quantitative_research_65: 'ინტერვიუერები და სუპერვაიზერები',
  quantitative_research_66:
    'ჩვენ შეგვიძლია ჩავატაროთ ინტერვიუ ნებისმიერი ენით და ვთარგმნოთ ის კლიენტის სასურველ ენაზე',
  quantitative_research_67: 'შერჩევა',
  quantitative_research_68:
    'ანალიტიკური განყოფილება შეიმუშავებს რესპონდენტების შერჩევის სისტემას საუკეთესო შედეგის მისაღწევად',
  quantitative_research_69: 'კომპიუტერიზებული',
  quantitative_research_70: 'სატელეფონო ინტერვიუ',
  quantitative_research_71:
    'რაოდენობრივი ინფორმაციის შეგროვების მეთოდოლოგია სატელეფონო ინტერვიუების მეშვეობით მკაცრად სტრუქტურირებული კითხვარის გამოყენებით.',
  quantitative_research_72: 'კომპიუტერული სატელეფონო ინტერვიუ',
  quantitative_research_73: 'ჩვენ გვაქვს საკუთარი ქოლ-ცენტრები',
  quantitative_research_74:
    'ჩვენ ვიყენებთ სპეციალურ პროგრამულ უზრუნველყოფას აუდიოჩანაწერით და GPS-ით',
  quantitative_research_75: 'კვალიფიციური ოპერატორები',
  quantitative_research_76:
    'ჩვენი ოპერატორები ფლობენ სხვადასხვა ენას, არიან გაწვრთნილები, კვალიფიციურები და მუდმივად აუმჯობესებენ თავიანთ უნარებს.',
  quantitative_research_77: 'მონაცემთა ბაზები',
  quantitative_research_78:
    'ჩვენ ვმუშაობთ როგორც საკუთარ მონაცემთა ბაზებთან, ასევე თქვენი კლიენტების ბაზებთან.',
  quantitative_research_79: 'SLA',
  quantitative_research_80:
    'ჩვენ ვაძლევთ ხარისხის გარანტიას და ვაფორმებთ SLA-ს (მომსახურების დონის შეთანხმება)',
  quantitative_research_81: 'Მიზნების დასახვა',
  quantitative_research_82: 'მეთოდოლოგიის განმარტება',
  quantitative_research_83: 'სეგმენტაცია და სინჯის აღება',
  quantitative_research_84: 'მონაცემთა შეგროვების არხების განსაზღვრა',
  quantitative_research_85: 'რესპონდენტისთვის ლოგიკური კითხვარის შექმნა',
  quantitative_research_86: 'მონაცემთა შეგროვების პროცესი',
  quantitative_research_87: 'ხარისხის უზრუნველყოფა',
  quantitative_research_88: 'ანალიზის მეთოდები',
  quantitative_research_89: 'მონაცემთა დამუშავება',
  quantitative_research_90: 'გამოკითხვის განვითარება',
  quantitative_research_91:
    'ინტერვიუერების ადგილმდებარეობის მონიტორინგი GPS-ის გამოყენებით',
  quantitative_research_92: 'მონაცემების შემოწმება',
  quantitative_research_93: 'კითხვარის შემუშავება და ტესტირება',
  quantitative_research_94: 'მონაცემთა დადასტურება',
  quantitative_research_95: 'GDPR-ის შესაბამისი აუდიო ჩანაწერები',
  quantitative_research_96: 'სამეცნიერო პერსონალის მომზადება და კომპეტენცია',
  quantitative_research_97: 'ხარისხის უზრუნველყოფა',
  quantitative_research_98: 'ფაქტორული ანალიზი',
  quantitative_research_99: 'სეგმენტაცია',
  quantitative_research_100: 'აღქმის რუკა',
  quantitative_research_101: 'კორელაცია',
  quantitative_research_102: 'კონვერსიის მოდელი',
  quantitative_research_103: 'ჟაკარის ინდექსი',
  quantitative_research_104: 'კლასტერული ანალიზი',
  quantitative_research_105: 'და ა.შ.',
  quantitative_research_106: 'ანალიტიკური ანგარიშები',
  quantitative_research_107:
    'ჩვენ ვიყენებთ SPSS®-ს და სხვა ინსტრუმენტებს სხვადასხვა მეთოდოლოგიებით ანალიტიკური ანგარიშების შესაქმნელად.',
  quantitative_research_108: 'რომელი ბიზნეს ამოცანების გადაჭრაა შესაძლებელი:',
  quantitative_research_109: 'რომელი ბიზნეს ამოცანების გადაჭრაა შესაძლებელი:',
  social_responsibility_1: 'Კორპორაციული სოციალური პასუხისმგებლობა 4Service',
  social_responsibility_2:
    'ჩვენი გუნდის თითოეული წევრის გულიდან და სულიდან. ჩვენ ვცდილობთ შევინარჩუნოთ სიკეთის ნაპერწკალი თითოეულ ჩვენს თანამშრომელში და ცოტა უკეთესი გავხადოთ ჩვენს გარშემო არსებული სამყარო',
  social_responsibility_3:
    'საგანმანათლებლო აქტივობები / ახალგაზრდების მხარდაჭერა',
  social_responsibility_4:
    'ჩვენი საგანმანათლებლო ინიციატივები ბავშვებისა და სტუდენტებისთვის',
  social_responsibility_5: 'ბიზნეს თამაში "სერვისმანია"',
  social_responsibility_6:
    'ჩვენი საგანმანათლებლო საქმიანობის მნიშვნელოვანი ნაწილია ბიზნეს თამაში "სერვისომანია".',
  social_responsibility_7:
    'სერვის მანია გასწავლით სტრატეგიულად აზროვნებას უჩვეულო სიტუაციების მარტივად დასაძლევად.',
  social_responsibility_8: 'კვლევის პრეზენტაცია/მოქმედება',
  social_responsibility_9:
    'ბიზნესისა და კლიენტის შეხედულება სერვისთან დაკავშირებული სიტუაციის შესახებ: ჩვენი კვლევის შედეგების პრეზენტაცია ვიქტორია სკორბოტას, 4Service უკრაინის განვითარების განყოფილების ხელმძღვანელის მიერ',
  social_responsibility_10: 'სერვისის დიზაინის სესიები',
  social_responsibility_11:
    'სერვისის დიზაინის მეთოდოლოგია 4Service მნიშვნელოვანი ნაწილია. რამდენიმე წლის წინ ჩვენ გავხდით DesignThinkers Academy-ის პარტნიორი და არა მხოლოდ ვიყენებთ საუკეთესო პრაქტიკას ჩვენს საქმიანობაში, არამედ აქტიურად ვამზადებთ საუკეთესო კომპანიებს',
  social_responsibility_12: 'ქველმოქმედება / მოხალისეობა',
  social_responsibility_13:
    'ბავშვთა სახლები, მოხუცთა სახლები და მოხალისეობა უკრაინის არმიის სასარგებლოდ. ჩვენი საქმიანობის ყველაზე საინტერესო ნაწილი',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    'ჩვენ ვთანამშრომლობთ ბლაგომაის საქველმოქმედო ფონდთან და ვცდილობთ შვებულება მივცეთ და დავეხმაროთ მათ, ვისაც უკიდურესად სჭირდება',
  social_responsibility_16:
    'ფონდების შეგროვება ბავშვთა სახლებისა და მოხუცთა სახლებისთვის',
  social_responsibility_17:
    '4სერვისში ჩვენ დავიწყეთ რამდენიმე ფონდის შეგროვება მოხუცთა სახლებისა და ბავშვთა სახლებისთვის აუცილებელი ნივთების შესაძენად.',
  social_responsibility_18: '#SaveUkraine',
  social_responsibility_19:
    'ომმა გავლენა მოახდინა ჩვენს ბევრ თანამშრომელზე და ახლო მეგობარზე. თითოეული ჩვენგანი გვეხმარება შეძლებისდაგვარად',
  social_responsibility_20: 'ცხოველებზე ზრუნვა',
  social_responsibility_21:
    'ნებისმიერ მსურველს შეუძლია ჩვენს ოფისში მისვლა თავისი შინაური ცხოველით. ჩვენ ვეხმარებით თავშესაფრებს, ვაგროვებთ ფულს საკვებისთვის და ზოგჯერ ვეძებთ სახლს უსახლკარო ცხოველებისთვის.',
  social_responsibility_22: 'ცხოველთა თავშესაფრების მხარდაჭერა',
  social_responsibility_23:
    'უსახლკარო ცხოველებს დახმარება სჭირდებათ ისევე, როგორც ჩვენი საზოგადოების დანარჩენ დაუცველ წევრებს.',
  social_responsibility_24:
    'ჩვენმა კომპანიამ აიღო უსახლკარო ცხოველების თავშესაფარი "სირიუსი" (კიევის რეგიონი, უკრაინა).',
  social_responsibility_25:
    'კრეატიული ინიციატივები უსახლკარო ცხოველების დასახმარებლად',
  social_responsibility_26:
    'რომლის მეშვეობითაც ჩვენს კლიენტებსა და პარტნიორებს გადავცემთ ცხოველთა თავშესაფრების პრობლემის აქტუალურობას',
  social_responsibility_27: 'შინაური ცხოველებისთვის განკუთვნილი ოფისი',
  social_responsibility_28:
    'ჩვენი გუნდის ბევრ წევრს ჰყავს შინაური ცხოველები. ჩვენ შევქმენით ჯანსაღი გარემო, სადაც ყველას შეეძლება ოფისში მისვლა შინაური ცხოველით და თავი კომფორტულად იგრძნოს.',
  social_responsibility_29: 'ჩვენი სოციალური აქტივობები',
  ux_testing_1: 'UX ტესტირება',
  ux_testing_1_1: 'UX ტესტირება',
  ux_testing_2:
    'ტესტირება და თქვენი ვებსაიტებისა და აპლიკაციების გაუმჯობესება: ადამიანური მიდგომა და ხელოვნური ინტელექტის გამოყენება',
  ux_testing_3: 'რა არის UX ტესტირება',
  ux_testing_4:
    'UX ტესტირება გეხმარებათ გაიგოთ, როგორ ურთიერთობენ ადამიანები თქვენს პროდუქტთან, აპლიკაციასთან ან ვებსაიტთან.',
  ux_testing_5: 'ნავიგაცია არ არის ძალიან ნათელი',
  ux_testing_6: 'არ მესმის, როგორ გავაკეთო შეკვეთა',
  ux_testing_7: 'კატალოგში არ არის საკმარისი ფოტოები',
  ux_testing_8: 'Შეგეძლება:',
  ux_testing_9: 'გაუმჯობესების გზების გახსნა',
  ux_testing_10:
    'პრობლემების იდენტიფიცირება დიზაინში და კლიენტთან ურთიერთობისას',
  ux_testing_11:
    'გაარკვიეთ რა სირთულეებს აწყდება მომხმარებელი საიტთან ურთიერთობისას',
  ux_testing_12: 'თვალყური ადევნეთ მომხმარებლის მოგზაურობას',
  ux_testing_13:
    'გაარკვიეთ როდის და რატომ ტოვებს თქვენი სამიზნე აუდიტორია თქვენს საიტს',
  ux_testing_14:
    'განსაზღვრეთ რომელი სექციები იწვევს ყველაზე ნაკლებ და ყველაზე მეტ ინტერესს და ემოციას',
  ux_testing_15: 'UX ტესტირება მომხმარებლების მიერ',
  ux_testing_16:
    '4Service უზრუნველყოფს რეალურ ადამიანურ შეხედულებებს, რომლებიც საჭიროა მომხმარებელზე ორიენტირებული ვებსაიტებისა და აპლიკაციების შესაქმნელად ხარისხობრივი და რაოდენობრივი მეთოდების გამოყენებით.',
  ux_testing_17: 'არ მესმის როგორ გამოვიყენო საიტი. სად არის დამალული მენიუ?',
  ux_testing_18:
    'ვფიქრობ, რომ ასოებს შორის ძალიან დიდი სივრცეა, ტექსტი არ იკითხება',
  ux_testing_19: 'სურათები ერთმანეთზეა გადახურული. ასეც უნდა იყოს?',
  ux_testing_20:
    'UX ტესტირება გეხმარებათ გაიგოთ, როგორ ურთიერთობენ ადამიანები თქვენს პროდუქტთან, აპლიკაციასთან ან ვებსაიტთან.',
  ux_testing_21: 'UX-ტესტირების მომხმარებლის კვლევის დიზაინი:',
  ux_testing_22: 'გაუმჯობესების შესაძლებლობების გახსნა',
  ux_testing_23:
    'ტესტირების ტიპისა და მეთოდის განსაზღვრა (ხარისხობრივი/რაოდენობრივი)',
  ux_testing_24: 'ჰიპოთეზებისა და მომხმარებლის სცენარების შედგენა',
  ux_testing_25: 'ტესტის შედეგების ანალიზი და მოხსენება',
  ux_testing_26: 'ორი გადაწყვეტილება ',
  ux_testing_27: 'ჩვენ გთავაზობთ ორ მიდგომას წარმატებული UX ტესტირებისთვის',
  ux_testing_28: 'UX ტესტირება მომხმარებლების მიერ',
  ux_testing_29: 'UX ტესტირება ადამიანებისა და ხელოვნური ინტელექტის მიერ',
  ux_testing_30: 'ჩვენი ძლიერი მხარეები:',
  ux_testing_31: 'ჩვენ შეგვიძლია გავაანალიზოთ კონკურენტული გარემო',
  ux_testing_32:
    'შეგვიძლია მოვიზიდოთ ვიწრო სპეციალისტები ინტერვიუს ჩატარებისა და მონაწილეობისთვის',
  ux_testing_33:
    'ჩვენ შეგვიძლია ჩავატაროთ ინტერვიუები სხვადასხვა ენაზე და ვთარგმნოთ ისინი საჭირო ენაზე',
  ux_testing_34: 'არსებული გამოყენებადობის',
  ux_testing_35: 'მაჩვენებლები ან სტანდარტები',
  ux_testing_36: 'თქვენი წარმადობა',
  ux_testing_37: 'კონკურენტთან შედარებით',
  ux_testing_38: 'იმავე',
  ux_testing_39: 'პროდუქტის ვერსიები',
  ux_testing_40: 'კმაყოფილების რეიტინგი',
  ux_testing_41: 'მომხმარებელთა ლოიალობის ინდექსი NPS',
  ux_testing_42: 'წარმატების მაჩვენებლები',
  ux_testing_43: 'შეცდომის მაჩვენებელი',
  ux_testing_44: 'დავალების შესრულების დრო',
  ux_testing_45: 'UX ტესტირება მომხმარებლების მიერ',
  ux_testing_46: 'რაოდენობრივი მეთოდი',
  ux_testing_47:
    'ჩვენ ვიწვევთ მინიმუმ 100 ადამიანს UX ტესტირებაში მონაწილეობის მისაღებად ამ ეტაპზე',
  ux_testing_48:
    'აქტუალურია, როდესაც გჭირდებათ თქვენი ვებსაიტის ან აპლიკაციის შედარება:',
  ux_testing_49: 'რაოდენობრივი გაზომვის მეთოდი:',
  ux_testing_50: 'დაკვირვება',
  ux_testing_51:
    'დროის გატარება მომხმარებელთან ან მომხმარებელთა ჯგუფთან და დაკვირვება, თუ როგორ ურთიერთობენ ისინი პროდუქტთან, როდესაც იყენებენ მას ყოველდღიურ ცხოვრებაში.',
  ux_testing_52: 'სიღრმისეული ინტერვიუ',
  ux_testing_53:
    'საშუალებას გაძლევთ გაეცნოთ თქვენს საიტზე მოსულ მომხმარებლების დამოკიდებულებებს, რწმენას, სურვილებს და გამოცდილებას. ჩვენ გირჩევთ ჩაატაროთ 15-20 ინტერვიუ',
  ux_testing_54: 'ეთნოგრაფიული კვლევები',
  ux_testing_55:
    'ტარდება რესპონდენტთა გარემოში, სადაც ისინი გამოიყენებენ პროდუქტს. დაკვირვება საშუალებას იძლევა კარგად გაიაზროს მომხმარებლის ფსიქოლოგია, ემოციური პრობლემები, რომლებიც მას აწყდება.',
  ux_testing_56: 'UX ტესტირება მომხმარებლების მიერ',
  ux_testing_57: 'ხარისხობრივი მეთოდი',
  ux_testing_58:
    'ეს მეთოდი გვეხმარება მომხმარებლის ქცევის მოტივებისა და ლოგიკის გაგებაში.',
  ux_testing_59: 'Ჩვენ ვიყენებთ:',
  ux_testing_60:
    'ჩვენ ვამუშავებთ მომხმარებლის მოგზაურობის რუკას ჩვენი კვლევის შედეგების საილუსტრაციოდ.',
  ux_testing_61: '30 მონაწილე (კაცები/ქალები)',
  ux_testing_62:
    'რესპონდენტებს უტარდებათ წინასწარი სკრინინგი და მოწვეულნი არიან გამოკითხვაში მონაწილეობის მისაღებად.',
  ux_testing_63: 'დისტანციური ონლაინ ინტერვიუ Wantent პლატფორმაზე',
  ux_testing_64: 'AI + ადამიანი',
  ux_testing_65: 'UX ტესტირება: AI+ადამიანი',
  ux_testing_66:
    'Wantent-ის უნიკალური ხელოვნური ინტელექტის ტექნოლოგიის და რეალური მომხმარებლის ჩართულობის კომბინაცია',
  ux_testing_67: 'ყურადღება მიიპყრო სათაურის დიდმა შრიფტმა',
  ux_testing_68:
    'მომხმარებლები უყურებენ „ხმამაღლა“ ნომრებს, მაგრამ არ კითხულობენ მათ გვერდით არსებულ ინფორმაციას',
  ux_testing_69:
    'UX ტესტირება გეხმარებათ გაიგოთ, როგორ ურთიერთობენ ადამიანები თქვენს პროდუქტთან, აპლიკაციასთან ან ვებსაიტთან.',
  ux_testing_70: 'კვლევის მეთოდოლოგია - AI + ადამიანის ტესტირება',
  ux_testing_71: 'Როგორ მუშაობს',
  ux_testing_72:
    'Wantent — ეს არის ხელოვნურ ინტელექტზე დაფუძნებული გადაწყვეტილება, რომელიც შეესაბამება ბაზრის მოთხოვნებს.',
  ux_testing_73:
    'Wantent აფასებს ვებსაიტებისა და აპლიკაციების ეფექტიანობას, იყენებს რა მანქანური სწავლების ტექნოლოგიებს აუდიტორიის ემოციური რეაქციებისა და ჩართულობის ანალიზისთვის.',
  ux_testing_74:
    'შედეგების ინტერპრეტაციისთვის ვიყენებთ სტორითელინგის, მრავალფეროვნების და ემპათიის მეთოდებს, რათა გავაძლიეროთ წარმადობა და ზრდა.',
  ux_testing_75: 'მომხმარებლის ყურადღება და ემოციები სექციებში გადაადგილებისას',
  ux_testing_76:
    'სტატისტიკა მონაწილეთა ჯგუფების შესახებ (ყურადღება და კონცენტრაცია მთელი სესიის განმავლობაში)',
  ux_testing_77: 'გვერდის კონვერტაციის ანალიზი',
  ux_testing_78: 'ყურადღება და ემოციები დავალების შესრულებისას',
  ux_testing_79: 'დასკვნები აღქმის შესახებ',
  ux_testing_80: 'საიტი მონაწილეთა სხვადასხვა ჯგუფის მიერ',
  ux_testing_81: 'სიმსუბუქის ანალიზი',
  ux_testing_82: 'გვერდის ნავიგაცია და მნიშვნელოვანი ნივთების პოვნის სიმარტივე',
  ux_testing_83: 'აღქმის ანალიზი',
  ux_testing_84: 'საიტზე განთავსებული ინფორმაცია',
  ux_testing_85: 'ფრაგმენტების განმარტება',
  ux_testing_86:
    'ცალკეული გვერდების შიგნით დასასრულებლად (ნავიგაცია, საინფორმაციო ბლოკები და ა.შ.)',
  ux_testing_87: 'ჩვენ დეტალურად ვაანალიზებთ',
  ux_testing_87_about: 'მიდგომა',
  ux_testing_88: 'კვლევის ძირითადი შედეგები',
  ux_testing_89:
    'რეკომენდაციები საიტისა და ცალკეული გვერდების სტრუქტურის გასაუმჯობესებლად',
  ux_testing_90:
    'ჩვენ ყურადღებით ვირჩევთ სამიზნე აუდიტორიას გამოყენებადობის ტესტირებისთვის.',
  ux_testing_91: 'ჩვენ ვატარებთ კვლევებს სხვადასხვა ქვეყანაში',
  ux_testing_92: 'ჩვენ შეგვიძლია შევამოწმოთ აპლიკაციები',
  ux_testing_93: 'და კონკურენტი საიტები და ჩაატაროს შედარებითი ანალიზი.',
  ux_testing_94: 'ჩვენ ვაერთიანებთ კვლევის სხვადასხვა მეთოდს.',
  ux_testing_95:
    'ჩვენი კვალიფიციური ფასილიტატორები ხელმძღვანელობენ მონაწილეს ტესტირების პროცესში.',
  ux_testing_96: 'ჩვენ ვამოწმებთ',
  ux_testing_97:
    'სხვადასხვა მოწყობილობებზე და პროგრამული უზრუნველყოფის ვერსიებზე',
  ux_testing_98: 'რატომ უნდა აგვირჩიოთ ჩვენ?',
  ux_testing_99: ', სხვადასხვა ენაზე და მომხმარებელთა სხვადასხვა ჯგუფში',
  wantent_1: '4Сервіс х',
  wantent_2: 'Wantent',
  wantent_3:
    'უნიკალური პარტნიორული პროექტი 4Service and Wantent-ისგან © ხელოვნური ინტელექტისა და ადამიანური მიდგომის შერწყმა კონტენტ ანალიზისადმი',
  wantent_4: 'წარმატების გაზომვა კონტენტის გაშვებამდე',
  wantent_5: 'მრავალფეროვნების საკითხებთან დაკავშირებული რისკების შემცირება',
  wantent_6: 'ინსაითი და რეკომენდაციები შინაარსის გასაუმჯობესებლად',
  wantent_7:
    'ობიექტური გადაწყვეტილებები კონტენტთან და მარკეტინგულ სტრატეგიასთან დაკავშირებით',
  wantent_8:
    'Wantend — ხელოვნურ ინტელექტზე დაფუძნებული გადაწყვეტა, რომელიც ადაპტირებულია კონტენტ ბაზარზე.',
  wantent_9:
    'Wantend — არის ხელოვნურ ინტელექტზე დაფუძნებული ტექნოლოგიური გადაწყვეტა, რათა კონტენტი ბაზრის მახასიათებლებთან შესაბამისობაში მოიყვანოს. Wantend, მანქანური სწავლების ტექნოლოგიების გამოყენებით, აფასებს ვიდეო კონტენტის ეფექტურობას, აანალიზებს ემოციურ რეაქციას და აუდიტორიის ჩართულობას.',
  wantent_10:
    'Wantend გვეხმარება იმის დადგენაში, თუ რამდენად შეესაბამება კონტენტი ბაზარს, ასევე მაქსიმალურად გაზრდის კონტენტის ეფექტურობას ხარჯზე:',
  wantent_11: 'სკრიპტის დაყენება და მონაწილეთა შერჩევა',
  wantent_12:
    'პროექტის ინდივიდუალური განვითარება და აუდიტორიის მოზიდვა მთელი მსოფლიოდან',
  wantent_13: 'მომხმარებლის გამოხმაურების შეგროვება',
  wantent_14: 'დეტალური და ზუსტი გამოხმაურება აუდიტორიისგან',
  wantent_15: 'შინაარსის აღქმის ანალიზი',
  wantent_16:
    'მომხმარებლის ქცევისა და ემოციური რეაქციების ანალიზი AI-ს დახმარებით',
  wantent_17: 'ანალიზიდან მიღებული ინფორმაციის მიწოდება',
  wantent_18: 'საბოლოო რეკომენდაციები შინაარსის გასაუმჯობესებლად',
  wantent_19: 'Wantent მაქსიმალურად ზრდის თქვენი შინაარსის ეფექტურობას',
  wantent_20: 'სარეკლამო კონცეფციის წინასწარი ტესტირება',
  wantent_21: 'კრეატიული კონცეფციის ტესტირება',
  wantent_22:
    'მომავალი კრეატიულის შემოწმება შემუშავებულ სტრატეგიასთან შესაბამისობაში და სამიზნე აუდიტორიის რეაქციის გაგება, რაც საშუალებას მოგცემთ მოარგოთ შემოქმედებითი კონცეფციები/შეტყობინებები',
  wantent_23: 'ბრენდის ელემენტების ხილვადობის ტესტირება (პოსტპროდუქცია)',
  wantent_24: 'სარეკლამო/სპონსორობითი ინვესტიციის ეფექტურობის დადასტურება',
  wantent_25: 'სარეკლამო ტესტირება',
  wantent_26: 'A/B-ტესტირება',
  wantent_27:
    'შემოქმედებითი შესრულების ბენჩმარკინგი, ჩართულობის გაზრდა და შეკავება წარმოების ეტაპზე',
  wantent_28: 'რეკლამის ტესტირების დაწყება',
  wantent_29:
    'შეტყობინებების ეფექტურობის დადგენა და აუდიო და ვიზუალის გასაუმჯობესებლად რეკომენდაციების მიცემა',
  wantent_30: 'გადაწყვეტილებები ტელევიზორისთვის',
  wantent_31:
    'საპილოტე რელიზები, პრომოები, ახალი ფორმატები, ტელეწამყვანების ტესტირება',
  wantent_32:
    'შედარებითი ანალიზის ჩატარება ყველაზე მიმზიდველი შინაარსის გამოსავლენად და მის გასაძლიერებლად',
  wantent_33: 'სატელევიზიო შოუების და მხატვრული ფილმების ტესტირება',
  wantent_34:
    'მაყურებლის ჩართულობის, ყურადღების დონისა და ემოციური რეაქციის ანალიზი ბუნებრივ პირობებში ხანგრძლივი კონტენტის ყურებისას. ჩვენ ავტომატურად ვპოულობთ აუდიტორიის უინტერესობის მწვერვალს და ყურადღების დაკარგვის მომენტებს, რათა შევაფასოთ და გავაუმჯობესოთ ვიდეოს მონტაჟი',
  wantent_35: 'UI/UX-ტესტირება',
  wantent_36: 'საიტებისა და მობილური აპლიკაციების პროტოტიპების ტესტირება',
  wantent_37:
    'მომხმარებლის რეაქციების და ემოციების ანალიზი Wantent ტექნოლოგიის გამოყენებით:',
  wantent_38: 'ყურადღების დონე',
  wantent_39: 'ემოციური რეაქციები',
  wantent_40: 'მონაწილეთა მზერის მიმართულების სითბოს რუქები',
  wantent_41:
    'ვებსაიტების და აპლიკაციების გამოყენებადობის ანალიზი მონაწილეთა უკუკავშირის საფუძველზე:',
  wantent_42: 'სისტემის გამოყენებადობის მასშტაბი (SUS)',
  wantent_43: 'კლიენტის ძალისხმევის შეფასება (ურთიერთქმედების სიმარტივე)',
  wantent_44: 'პრომოუტერის წმინდა ქულა (NPS)',
  wantent_45: 'GDPR შესაბამისობა და მომხმარებლის კონფიდენციალურობა',
  wantent_46:
    'Wantent სრულად შეესაბამება GDPR და CCPA პოლიტიკას და წევრების პერსონალური მონაცემების შეგროვების, შენახვის, დამუშავებისა და დაცვის პრინციპებს.',
  wantent_47: 'ნიკიტა ლობინცევი',
  wantent_48: 'СDO, Reface (მედია და გართობა)',
  wantent_49:
    'ყოველდღიურად ჩვენ ექსპერიმენტებს ვატარებთ მრავალი ახალი შინაარსის იდეით მანქანური სწავლების ტექნოლოგიების გამოყენებით. სურვილი გვეხმარება გავიგოთ და შევაფასოთ რისკები და სარგებელი, ვისწავლოთ მომხმარებლის უკუკავშირი, ქცევა და აღქმა, რათა დავადგინოთ მიზეზობრიობა ჩვენი გადაწყვეტილებების სხვადასხვა ასპექტებს შორის.',
  wantent_50: 'ალექსანდრე სმირნოვი',
  wantent_51: 'TABASCO-ს თანამფლობელი (რეკლამა)',
  wantent_52:
    'Wantent გთავაზობთ მართლაც უნიკალურ სერვისს, რომელიც გვეხმარება გავიგოთ მომხმარებელთა მოწონებისა და არმოწონების ნიუანსები. არ არსებობს მოტყუების ან ტყუილის საშუალება - Wantent-მა ყოველთვის იცის სიმართლე და გვაძლევს, როგორც მარკეტოლოგებს, ფასდაუდებელ (ჰაჰაჰა - ჩვენ ვიცით ზუსტი ფასი და ეს ხელმისაწვდომია) მითითებებს ჩვენი კომუნიკაციის გასაუმჯობესებლად.',
  wantent_53: 'მიმოხილვები',
  terms_1: 'პირობები',
  terms_2: 'გამოყენების პირობების შეთანხმება',
  terms_3:
    'გთხოვთ, ყურადღებით წაიკითხოთ გამოყენების პირობების შეთანხმება ("გამოყენების პირობები", "შეთანხმება") საიტის გამოყენებამდე.',
  terms_4:
    '(«საიტი»), რომელიც მართავს 4Service Holdings GmbH («4Service», «ჩვენ», «ჩვენ», «ჩვენი»).',
  terms_5:
    'გამოყენების პირობები: ამ ვებგვერდის გამოყენებით, თქვენ ადასტურებთ, რომ წაიკითხეთ და გაიგეთ ეს შეთანხმება და ეთანხმებით, რომ ვალდებულნი ხართ მისი პირობებით. თუ არ გსურთ იყოთ ვალდებული წინამდებარე ხელშეკრულების პირობებით, მოგიწოდებთ, პირველ რიგში დატოვოთ საიტი. 4Service ამ ვებსაიტზე, მის პროდუქტებსა და სერვისებზე სარგებლობისა და წვდომის საშუალებას აძლევს მხოლოდ მათ, ვინც დაეთანხმა მის პირობებს.',
  terms_6: 'Კონფიდენციალურობის პოლიტიკა',
  terms_7:
    'სანამ გააგრძელებთ ჩვენი ვებსაიტის გამოყენებას, გირჩევთ, წაიკითხოთ ჩვენი კონფიდენციალურობის პოლიტიკა მომხმარებლის მონაცემების შეგროვებასთან დაკავშირებით. ეს დაგეხმარებათ უკეთ გაიგოთ ჩვენი პრაქტიკა.',
  terms_8: 'ასაკობრივი შეზღუდვა',
  terms_9:
    'თქვენ უნდა იყოთ მინიმუმ 16 (თექვსმეტი) წლის, სანამ შეძლებთ ამ ვებსაიტის გამოყენებას. ამ ვებგვერდის გამოყენებით თქვენ იძლევით გარანტიას, რომ ხართ 16 (თექვსმეტი) წლის ან მეტი და შეგიძლიათ კანონიერად დაემორჩილოთ ამ შეთანხმებას. 4Service არ არის პასუხისმგებელი ასაკობრივი ინფორმაციის დამახინჯებასთან დაკავშირებულ ვალდებულებებზე.',
  terms_10: 'Ინტელექტუალური საკუთრების',
  terms_11:
    'თქვენ ეთანხმებით, რომ ამ ვებგვერდზე წარმოდგენილი ყველა მასალა, პროდუქტი და სერვისი არის 4Service, მისი შვილობილი კომპანიების, დირექტორების, ოფიცრების, თანამშრომლების, აგენტების, მომწოდებლების ან ლიცენზირების საკუთრება, მათ შორის ყველა საავტორო უფლება, სავაჭრო საიდუმლოება, სავაჭრო ნიშნები, პატენტები და სხვა ინტელექტუალური საკუთრება. თქვენ ასევე ეთანხმებით, რომ არ გაამრავლებთ ან გაავრცელებთ 4Service-ის ინტელექტუალურ საკუთრებას, ელექტრონული, ციფრული ან ახალი სავაჭრო ნიშნის რეგისტრაციების ჩათვლით.',
  terms_12: 'წვდომა ჩვენს ვებსაიტზე',
  terms_13:
    'ჩვენს საიტზე წვდომა ნებადართულია დროებით და ჩვენ ვიტოვებთ უფლებას გავაუქმოთ ან შევცვალოთ ჩვენს საიტზე მოწოდებული სერვისები შეტყობინების გარეშე. ჩვენ არ ვიქნებით პასუხისმგებელი, თუ რაიმე მიზეზით ჩვენი საიტი მიუწვდომელია ნებისმიერ დროს ან რაიმე პერიოდის განმავლობაში. დროდადრო ჩვენ შეიძლება შევზღუდოთ წვდომა ჩვენი საიტის ზოგიერთ ნაწილზე ან მთელ ჩვენს საიტზე იმ მომხმარებლებისთვის, რომლებიც დარეგისტრირებულნი არიან ჩვენთან. თქვენ პასუხისმგებელი ხართ ჩვენს საიტზე წვდომისთვის საჭირო ყველა ნაბიჯის გადადგმაზე, მათ შორის ჩვენს საიტთან თავსებადი აღჭურვილობის გამოყენებაზე. თქვენ ასევე პასუხისმგებელნი ხართ უზრუნველყოთ, რომ ყველა პირმა, ვინც შემოდის ჩვენს საიტზე თქვენი ინტერნეტის საშუალებით, იცოდეს ეს პირობები და დაიცვას ისინი.',
  terms_14: 'Მოქმედი კანონი',
  terms_15:
    'ამ ვებსაიტის მონახულებით თქვენ ეთანხმებით, რომ ავსტრიის რესპუბლიკის კანონები, კანონის კონფლიქტის პრინციპების გარეშე, არეგულირებს ამ პირობებს და ნებისმიერი სახის დავა, რომელიც შეიძლება წარმოიშვას 4Service და თქვენ შორის.',
  terms_16: 'დავები',
  terms_17:
    'ნებისმიერი დავა, რომელიც წარმოიქმნება თქვენი ვიზიტის შედეგად ამ ვებსაიტზე, არბიტრაჟს ექვემდებარება ვენის კომერციული სასამართლოს მიერ.',
  terms_18: 'კომპენსაცია',
  terms_19:
    'თქვენ თანახმა ხართ, აანაზღაუროთ 4Service და მისი შვილობილი კომპანიები და უვნებლად თვლით 4Service იურიდიული პრეტენზიებისა და მოთხოვნებისგან, რომლებიც შეიძლება წარმოიშვას თქვენ მიერ ჩვენი ვებსაიტის გამოყენების ან ბოროტად გამოყენების შედეგად. ჩვენ ვიტოვებთ უფლებას ავირჩიოთ საკუთარი იურიდიული მრჩეველი.',
  terms_20: 'შენახვის პირობები',
  terms_21:
    'დამუშავების მიზნებიდან გამომდინარე, მომხმარებლის პერსონალური მონაცემების შენახვის ვადა (შენახვის პერიოდი) არის 24 თვე თქვენგან მიღების დღიდან მონაცემთა დამუშავებაზე თანხმობის დადგენილი წესით.',
  terms_22: 'Პასუხისმგებლობის შეზღუდვა',
  terms_23:
    '4Service არ არის პასუხისმგებელი ზარალზე, რომელიც შეიძლება მოგეყენოთ ჩვენი ვებსაიტის არასწორად გამოყენების შედეგად. 4Service იტოვებს უფლებას, წინასწარი შეტყობინების გარეშე, შეცვალოს, შეცვალოს და შეცვალოს წინამდებარე ხელშეკრულება ნებისმიერ დროს ამ პოსტის განახლებით. თქვენ განაგრძობთ ვებგვერდის გამოყენებას ახლა ან მას შემდეგ, რაც გამოქვეყნდება რაიმე ცვლილება ან მოდიფიკაცია, ნიშნავს თქვენს მიერ ასეთ ცვლილებებს ან მოდიფიკაციას. თუ ამ შეთანხმების რომელიმე ნაწილი ჩაითვლება უკანონოდ, ბათილად ან არააღსრულებად, ეს ნაწილი ჩაითვლება გაწყვეტად და არ იმოქმედებს ნებისმიერი სხვა დებულების ვალიდობასა და აღსრულებაზე. საიტის უკანონო გამოყენების შესაძლო მტკიცებულებები სამართალდამცავ ორგანოებს გადაეცემათ. ეს შეთანხმება არის ხელშეკრულება 4Service და მომხმარებელს შორის.',
  terms_24:
    'გთხოვთ, მიმართოთ კონფიდენციალურობას/გამოყენებასთან დაკავშირებული ყველა შეკითხვა და შეშფოთება:',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Tegethofstrasse 7',
  terms_27: '1010 ვენა',
  terms_28: 'ავსტრია',
  terms_29: 'Მიმოხილვა',
  terms_30:
    'თუ თქვენ მიერ მოწოდებული პერსონალური მონაცემები არაზუსტია, თქვენ გაქვთ უფლება მოგვთხოვოთ მათი დაუყონებლივ გამოსწორება (მუხლი 16 GDPR).',
  thank_you_1: 'მადლობას გიხდით!',
  thank_you_2: 'ჩვენ დაგიკავშირდებით 24 საათის განმავლობაში',
  thank_you_3:
    'P.S. ჩვენი მენეჯერები უკვე განიხილავენ თქვენს მოთხოვნას საუკეთესო შეთავაზების გასაკეთებლად',
  thank_you_4: 'მენიუ',
  thank_you_5: 'ქალი ბეჭდავს',
  contacts_1: 'მომხმარებლისთვის',
  contacts_2:
    'ველა ტიპის ბიზნესისთვის, ბაზრის კვლევის სააგენტოებისთვის და მსხვილი კომპანიებისთვის, ბიზნეს პარტნიორებისთვის და მედიისთვის.',
  contacts_3: 'წმ. ჩიგორინა, 61, კიევი, უკრაინა',
  contacts_4: 'მყიდველებისთვის',
  contacts_5:
    'ადგილობრივებისთვის და მოგზაურებისთვის, მძღოლებისთვის და სტუდენტებისთვის, პროფესიონალი საიდუმლო მყიდველებისთვის და დიასახლისებისთვის.',
  contacts_6: 'დაგვიკავშირდით თქვენი ქვეყნიდან:',
  contacts_7: 'იტალია',
  contacts_8: 'აშშ',
  contacts_9: 'Დიდი ბრიტანეთი',
  contacts_10: 'შვეიცარია',
  contacts_11: 'ნიდერლანდები',
  contacts_12: 'სლოვაკეთი',
  contacts_13: 'სლოვენია',
  contacts_14: 'რუმინეთი',
  contacts_15: 'აზერბაიჯანი',
  contacts_16: 'უკრაინა',
  contacts_17: 'ყაზახეთი',
  contacts_18: 'Სხვა ქვეყნები',
  contacts_19: 'საქართველოს',
  menu_1: 'CJM',
  menu_2: 'NPS',
  menu_3: 'CSI',
  menu_4: 'BHT',
  menu_5: 'UX-ტესტირება',
  menu_6: 'HR-კვლევა',
  menu_7: 'ხარისხიანი კვლევები',
  menu_8: 'რაოდენობრივი კვლევები',
  menu_9: 'საიდუმლო მყიდველი',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: 'ფასების მონიტორინგი',
  menu_14: 'Ჩვენს შესახებ',
  menu_15: 'კონტაქტები',
  menu_16: 'ბლოგი',
  menu_17: 'მეთოდები',
  menu_18: 'პროდუქტები',
  menu_19: 'Shoppers  platform',
  menu_20: 'CSR',
  nps_passives: 'Პასიური',
  nps_detractors: 'მოწინააღმდეგეები',
  nps_promoters: 'პრომოუტერები',
  nps_a_score: 'რეიტინგი',
  area: 'რეგიონი',
  products_tabs_1:
    'მაქსიმალური ეფექტურობის მისაღწევად ჩვენ ასევე ვატარებთ კომპლექსურად:',
  products_tabs_2: 'პროდუქტები',
  products_tabs_3:
    'ხარისხიანი კვლევა — ეს არის არარიცხვითი მონაცემების შეგროვება და ანალიზი კონცეფციების, აზრების ან გამოცდილების გასაგებად.',
  products_tabs_4:
    'რაოდენობრივი კვლევის მეთოდები — ეს არის მონაცემების ობიექტური გაზომვა და რიცხვითი ანალიზი, რომლებიც შეგროვებულია გამოკითხვების, ანკეტების საშუალებით.',
  our_clients_1: 'Ჩვენი კლიენტები',
  preview_cases_section_1: 'საქმეები',
  preview_cases_section_2:
    'გადადით საქმის შესწავლაზე მეტი საინტერესო პოსტების წასაკითხად',
  blog_1: 'ბლოგი საინტერესო შინაარსით',
  blog_2: 'არ არსებობს პოსტები, რომლებიც შეესაბამება თქვენს მოთხოვნას.',
  about: 'შესახებ',
  why_us: 'Რატომ ჩვენ',
  about_us: 'Ჩვენს შესახებ',
  key_features: 'ძირითადი თვისება',
  solutions: 'გადაწყვეტილება',
  monitoring: 'Მონიტორინგი',
  how: 'როგორც',
  how_it_works: 'Როგორ მუშაობს',
  when_to_use: 'როდის გამოვიყენოთ',
  mystery_shopping: 'საიდუმლო მყიდველი',
  voicer: 'დამკვეთის ხმა',
  wantent: 'ვიდეო შინაარსის ტესტირება',
  play4sales: 'Play4Sales',
  price_monitoring: 'ფასების მონიტორინგი',
  service_design: 'სერვის-დიზაინი',
  qualitative_research: 'თვისებრივი კვლევა',
  quantitative_research: 'რაოდენობრივი კვლევები',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#Საავტომობილო ინდუსტრია',
  hashtag_retayl: '#Საცალო',
  hashtag_all_posts: '#ყველა_პოსტი',
  hashtag_feedback: '#კავშირი',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#საქმეები',
  hashtag_market_research: '#ბაზრის კვლევა',
  more: 'მეტი',
  speak_to_an_expert: 'მიმართეთ ექსპერტს',
  book_consultancy: 'შეუკვეთეთ კონსულტაცია',
  read_all: 'წაიკითხეთ ყველა',
  find_out_more: 'Გაიგე მეტი',
  address: 'მისამართი',
  mon_fri: 'ორშაბათი-პარასკევი',
  phone_number: 'Ტელეფონის ნომერი',
  flag: 'დროშა',
  scroll_to_left: 'გადახვევა მარცხნივ',
  online: 'ონლაინ',
  tel: 'ტელ.',
  email: 'ელფოსტა',
  light_it_up: 'აანთეთ',
  about_us_60: 'ალინა ანდრეევა',
  about_us_61: 'ბიზნესის განვითარების დირექტორი',
  about_us_61_female: 'ბიზნესის განვითარების დირექტორი',
  about_us_62: 'იულია კრავჩენკო',
  about_us_63: 'Პროექტის უფროსი მენეჯერი',
  about_us_63_female: 'Პროექტის უფროსი მენეჯერი',
  about_us_64: 'ოლგა აქსონოვა',
  about_us_65: 'Ბიზნესის განვითარების მენეჯერი',
  about_us_65_female: 'Ბიზნესის განვითარების მენეჯერი',
  about_us_66: 'დიმიტრო ჟელევსკი',
  about_us_67: 'ოპერაციების დირექტორი',
  about_us_roles_1: 'მენეჯმენტი',
  about_us_roles_2: 'Ბიზნესის განვითარება',
  about_us_roles_3: 'პროდუქტის მფლობელები',
  ad_testing_1: 'სარეკლამო ტესტირება',
  ad_testing_2:
    'სარეკლამო კომპანია-დიდი ინვესტიციაა. დარწმუნდით, რომ თქვენი რეკლამები ეფექტურია და მაქსიმალურ შემოსავალს იძლევა',
  ad_testing_3: 'ციხე',
  ad_testing_4: 'ინდუსტრიები, რომლებსაც ვემსახურებით',
  ad_testing_5:
    '4Service – გლობალური კვლევითი ჰოლდინგი, რომელიც სპეციალიზირებულია მომხმარებლის გამოცდილების შესწავლაზე',
  ad_testing_6:
    '4Service — გლობალური ჰოლდინგი მარკეტინგული კვლევებისა და CX-ის სფეროში. ჩვენ ვთავაზობთ ექსპერტულ მომსახურებას მონაცემთა შეგროვებაში სხვადასხვა ბიზნესისთვის',
  ad_testing_7: 'თვითმომსახურების მაღაზიები',
  ad_testing_8: 'Საცალო',
  ad_testing_9: 'ელექტრონიკა',
  ad_testing_10: 'ლუქსი/პრემიუმი',
  ad_testing_11: 'რესტორნები და სასტუმროები',
  ad_testing_12: 'საავტომობილო ბიზნესი',
  ad_testing_13: 'მოგზაურობა და დასვენება',
  ad_testing_14: 'მოდა',
  ad_testing_15: 'ბანკები',
  ad_testing_16: 'საათები და სამკაულები',
  ad_testing_17: 'Საყოფაცხოვრებო ტექნიკა',
  ad_testing_18: 'წევრი ეზომარი',
  ad_testing_19:
    'ჩვენ ჩავატარეთ სარეკლამო ტესტირების კვლევა სხვადასხვა ბიზნესისთვის სხვადასხვა ინდუსტრიაში',
  ad_testing_20: 'თქვენ გჭირდებათ რეკლამის ტესტირება, თუ',
  ad_testing_21: 'ახალი პროდუქტის ან სერვისის პოპულარიზაციას ახორციელებთ  ',
  ad_testing_22: 'დელიკატურ თემას ეხებით',
  ad_testing_23: 'გეგმავთ ახალი სამიზნე აუდიტორიის ან ბაზრის მოზიდვას',
  ad_testing_24: 'იხილავთ დიზაინის რამდენიმე ვარიანტს',
  ad_testing_25:
    'საჭიროებთ კონცეფციის შემოწმებას მენეჯმენტის გუნდებისთვის ან ინვესტორებისთვის',
  ad_testing_26: 'თქვენ მიიღებთ პასუხებს თქვენს კითხვებზე',
  ad_testing_27: 'რომელი სარეკლამო არხებია საუკეთესო ამ რეკლამებისთვის?',
  ad_testing_28: 'თქვენ იყენებთ სწორ ვიზუალს თქვენი შეტყობინების გასაგებად?',
  ad_testing_29: 'თქვენი სარეკლამო ტექსტები და შეტყობინებები რეზონანსულია?',
  ad_testing_30: 'რომელი სარეკლამო არხებია საუკეთესო ამ რეკლამებისთვის?',
  ad_testing_31: 'რა იპყრობს მათ ყურადღებას პირველ რიგში?',
  ad_testing_32: 'ადვილი გასაგებია რეკლამის განლაგება და განლაგება?',
  ad_testing_33: 'ჩვენ ვაფასებთ',
  ad_testing_34: 'ბრენდინგი',
  ad_testing_35:
    'როგორ უკავშირდება თქვენი ბრენდი რეკლამას და რამდენად დასამახსოვრებელია ის',
  ad_testing_36: 'ძირითადი მეტრიკა',
  ad_testing_37: 'ინტეგრაცია',
  ad_testing_38: 'Აღიარება',
  ad_testing_39: 'კონფორმულობა',
  ad_testing_40: 'კრეატიულობა',
  ad_testing_41: 'როგორ გამოირჩევა თქვენი რეკლამა და იპყრობს ხალხის ყურადღებას',
  ad_testing_42: 'ძირითადი მეტრიკა',
  ad_testing_43: 'ᲐᲦᲘᲐᲠᲔᲑᲐ',
  ad_testing_44: 'ლაიქები',
  ad_testing_45: 'МТО',
  ad_testing_46: 'ᲛᲝᲢᲘᲕᲐᲪᲘᲐ',
  ad_testing_47: 'კლიენტების შთაბეჭდილებები, ემოციური ჩართულობა',
  ad_testing_48:
    'ხელოვნური ინტელექტის ტექნოლოგიებისა და ანალიტიკოს-ექსპერტების დახმარებით, ჩვენ ვაანალიზებთ ადამიანების რეალურ ემოციებს და ვიღებთ წარმოდგენას მათი რეკლამის აღქმის შესახებ',
  ad_testing_49: 'რეიტინგი',
  ad_testing_50: 'მამრობითი',
  ad_testing_51: 'ქალი',
  ad_testing_52: 'ჩართულობის მაღალი დონე',
  ad_testing_53: 'გაფრთხილება',
  ad_testing_54: 'რაც მოეწონა და ახსოვდა საზოგადოებას?',
  ad_testing_55: 'მსახიობი ქალი',
  ad_testing_56: 'Თანასწორობა',
  ad_testing_57: 'მუსიკალური ფონი',
  ad_testing_58: 'დადებითი ემოციები',
  ad_testing_59: 'სხვადასხვა რასის და გარეგნობის ხალხი',
  ad_testing_60: 'გადაღება ღია სივრცეში',
  ad_testing_61: 'რა არ მოეწონა მაყურებელს და არ ახსოვდა?',
  ad_testing_62: 'დიქტორის ხმა არ შეესაბამებოდა იმას, რაც ეკრანზე ხდებოდა',
  ad_testing_63: 'დაბალი ყურადღება პროდუქტის მიმართ',
  ad_testing_64: 'ძალიან დინამიური',
  ad_testing_65: 'ძნელი გასაგებია',
  ad_testing_66: 'TRP',
  ad_testing_67: 'შთაბეჭდილება',
  ad_testing_68: 'ჩვენება',
  ad_testing_69: 'ტრანსფორმაცია',
  ad_testing_70: 'მასმედია',
  ad_testing_71:
    'ჩვენ ვზომავთ სარეკლამო კამპანიის ეფექტურობას მედია აქტივობასთან ერთად, გამოვთვლით მედია ინვესტიციების გავლენას სხვადასხვა არხებში მიღწეულ შედეგებზე.',
  ad_testing_72:
    'ჩვენ ვატარებთ სარეკლამო კვლევას ნებისმიერ ფორმატში, ნებისმიერ პლატფორმაზე ან არხზე',
  ad_testing_73: 'ვიდეო კონტენტი',
  ad_testing_74: 'გარე რეკლამა / გარე რეკლამა',
  ad_testing_75: 'სატელევიზიო რეკლამა',
  ad_testing_76: 'ბეჭდვის ინდუსტრია',
  ad_testing_77: 'ციფრული',
  ad_testing_78: 'სარეკლამო კამპანიები',
  ad_testing_79: 'სარეკლამო მასალების განთავსება გაყიდვების წერტილებში',
  ad_testing_80: 'ანიმატიკა',
  ad_testing_81:
    'ჩვენი დახმარებით თქვენ შეგიძლიათ შეამოწმოთ თქვენი რეკლამა ნებისმიერ ეტაპზე',
  ad_testing_82: 'Შინაარსი',
  ad_testing_83: 'რომელ იდეებს აქვთ ყველაზე ძლიერი პოტენციალი?',
  ad_testing_84: 'ადრეული სტადიის წარმოება',
  ad_testing_85: 'რომელი ანიმატიკა შევა წარმოებაში?',
  ad_testing_86: 'წარმოება',
  ad_testing_87: 'როგორ დაარედაქტირო ვიდეო ისე, რომ მან ყურადღება მიიპყროს?',
  ad_testing_88: 'წინასწარი მედია',
  ad_testing_89:
    'რა საკომუნიკაციო არხები იმუშავებს და რა შედეგები შეიძლება იყოს მოსალოდნელი?',
  ad_testing_90: 'რეკლამის შემდგომი ტესტირება',
  ad_testing_91: 'წარმოება',
  ad_testing_92:
    'არის ჩემი რეკლამა მიმზიდველი? დროთა განმავლობაში მცირდება მისი ეფექტურობა?',
  ad_testing_93: 'წინასწარი მედია',
  ad_testing_94:
    'რამდენად ეფექტურია ჩემი რეკლამა ციფრებში? როგორ ადარებს კონკურენციას?',
  ad_testing_95: 'რეკლამის წინასწარი ტესტირება',
  ad_testing_96:
    'იმისათვის, რომ მოგაწოდოთ ხარისხიანი მონაცემები, ჩვენ ვიყენებთ',
  ad_testing_97: 'რაოდენობრივი კვლევის მეთოდოლოგია',
  ad_testing_98: 'CAWI',
  ad_testing_99: 'თვისებრივი კვლევის მეთოდოლოგია',
  ad_testing_100: 'ონლაინ ფოკუს-ჯგუფები',
  ad_testing_101: 'Ხელოვნური ინტელექტი',
  ad_testing_102:
    'Wantent - მაყურებლის რეაქციის ანალიზი ნახული მასალის ეფექტურობის შესაფასებლად',
  ad_testing_103: 'თქვენ მიიღებთ ანალიტიკურ ანგარიშებს',
  ad_testing_104:
    'ჩვენი ანალიტიკოსების, მედია ექსპერტების, მარკეტოლოგების გუნდი მოამზადებს და მოგაწვდით ინდივიდუალურ ანგარიშს დეტალური რეკომენდაციებით',
  ad_testing_age: 'ასაკი',
  ad_testing_ad: 'რეკლამა',
  automotive_industry_price_analysis_1:
    'ფასების ანალიზი საავტომობილო ინდუსტრიაში',
  automotive_industry_price_analysis_2:
    'კონკურენტების ფასების ანალიზი დაგეხმარებათ თავიდან აიცილოთ დაკარგული მოგება, გაზარდოთ ბაზრის წილი და გააკონტროლოთ თქვენი პოზიცია ბაზარზე. დაგეხმარებით წარმატებული კონკურენტული სტრატეგიის არჩევაში!',
  automotive_industry_price_analysis_3: 'წინადადების მოთხოვნა',
  automotive_industry_price_analysis_4: 'ჩვენი მეთოდოლოგია',
  automotive_industry_price_analysis_5:
    'მანქანის სალონი ელეგანტური და ელეგანტური ადამიანებისთვის',
  automotive_industry_price_analysis_6:
    'Mystery Shopping მეთოდი ერთადერთი მიდგომაა, რომელიც ზუსტად ასახავს მომხმარებლის რეალურ გამოცდილებას და იძლევა მის საიმედო სურათს.',
  automotive_industry_price_analysis_7:
    'ჩვენ გთავაზობთ ზუსტ ციფრებს და სანდო ყოვლისმომცველ მონაცემებს',
  automotive_industry_price_analysis_8:
    'ჩვენ გვაქვს გლობალური გაშუქება, რომელიც მოიცავს მსოფლიოს ყველა ქვეყანას',
  automotive_industry_price_analysis_9:
    'ჩვენი შიდა რესურსები მოიცავს საიდუმლო მყიდველებს და აუდიტორებს',
  automotive_industry_price_analysis_10:
    'ჩვენ ვამოწმებთ ჩვენი მონაცემების ხარისხს',
  automotive_industry_price_analysis_11: 'ჩვენი უპირატესობები:',
  automotive_industry_price_analysis_12:
    'ფასების მონიტორინგი კონკრეტული კონკურენტუნარიანი მოდელებისთვის (B2B და B2C)',
  automotive_industry_price_analysis_13: 'ფასდაკლების დონის მონიტორინგი',
  automotive_industry_price_analysis_14:
    'დააკვირდით საცალო ვაჭრობის ინვენტარს თქვენი ბრენდისა და კონკურენტების ბრენდებისთვის',
  automotive_industry_price_analysis_15:
    'ავტომობილების ელექტრონული კომერციის ფასების მონიტორინგი',
  automotive_industry_price_analysis_16: 'ფასების კომუნიკაციის ანალიზი',
  automotive_industry_price_analysis_17:
    'თვალყური ადევნეთ მიწოდების ხარჯებს საცალო მოვაჭრეებისგან',
  automotive_industry_price_analysis_18:
    'საცალო ვაჭრობაში აქციებისა და გაყიდვების მონიტორინგი',
  automotive_industry_price_analysis_19:
    'ყოველთვიური გადასახადების ოდენობის განსაზღვრა',
  automotive_industry_price_analysis_20: 'სალიზინგო გადახდების გაანგარიშება',
  automotive_industry_price_analysis_21:
    'ელექტრო მანქანების სპეციფიკური ფასების ფაქტორების ანალიზი (EV)',
  automotive_industry_price_analysis_22:
    'ფასების შედარება პირდაპირ მომხმარებელზე და საცალო გაყიდვებს შორის',
  automotive_industry_price_analysis_23:
    'სააბონენტო ფასების მოდელების შემუშავება',
  automotive_industry_price_analysis_24:
    '4Service — არის საერთაშორისო ჰოლდინგი, რომელიც სპეციალიზირებულია მომხმარებლის გამოცდილების შექმნასა და გაუმჯობესებაში 20 წელზე მეტი ხნის განმავლობაში (CX)',
  automotive_industry_price_analysis_25:
    'თქვენ შეძლებთ გამოიყენოთ მონაცემები მომხმარებელთა მზადყოფნის შესახებ გადაიხადონ სხვადასხვა ფუნქციისთვის თქვენი შეთავაზების ოპტიმიზაციისთვის და თქვენი სამიზნე აუდიტორიისთვის ყველაზე მნიშვნელოვანი ფუნქციების იდენტიფიცირებისთვის.',
  automotive_industry_price_analysis_26:
    '4Service საავტომობილო ფასების ანალიზი მოიცავს:',
  automotive_industry_price_analysis_27:
    'ყველაზე დაბალი ფასები ყოველთვის არ არის საავტომობილო ბრენდების კონკურენტუნარიანობის გასაღები. მოდით დაგეხმაროთ გრძელვადიანი ფასების სტრატეგიის შექმნაში',
  automotive_industry_price_analysis_28:
    'მომხმარებელს ესმის, რომ ფასები იზრდება ყველა ბრენდისთვის',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    'მომხმარებლებმა თქვეს, რომ ისინი მაინც იყიდიან იმ მანქანას, რომელიც მოეწონათ, მაშინაც კი, თუ ბრენდი მათ აცნობებს ფასის მოახლოებულ ზრდას,',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    'ადამიანები მანქანის შესაძენად ყველაზე სასურველ გზად ლიზინგი და ყოველთვიური გადასახადები თვლიან',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    'დილერებმა ისაუბრეს კომუნიკაციის/გაყიდვის პროცესში ფასების ზრდის შესაძლებლობის შესახებ',
  automotive_industry_price_analysis_35: '47,6',
  automotive_industry_price_analysis_36: 'ძირითადი ინდიკატორები',
  automotive_industry_price_analysis_37:
    'თქვენ გაიგებთ, თუ როგორ უნდა შეაფასოთ თქვენი პროდუქტი ხაზის სხვა მანქანების წინააღმდეგ.',
  automotive_industry_price_analysis_38:
    'თქვენ გამოიყენებთ მონაცემებს მომხმარებელთა მზადყოფნის შესახებ გადაიხადონ სხვადასხვა ფუნქციებისთვის თქვენი შეთავაზების ოპტიმიზაციისთვის და თქვენი სამიზნე მომხმარებლებისთვის ყველაზე მნიშვნელოვანი ფუნქციების იდენტიფიცირებისთვის.',
  automotive_industry_price_analysis_39:
    'თქვენ შეძლებთ უფრო დეტალურად გაიგოთ თქვენი უპირატესობა კონკურენტებთან შედარებით',
  automotive_industry_price_analysis_40:
    'თქვენ შეძლებთ განსაზღვროთ შესაბამისი ყოველთვიური გადასახადი და ლიზინგის განაკვეთები.',
  automotive_industry_price_analysis_41:
    'რა სარგებელს მიიღებთ თქვენი ბრენდისთვის ან დილერისთვის:',
  automotive_industry_price_analysis_42: 'თქვენ მიმართეთ',
  automotive_industry_price_analysis_43:
    'ჩვენი მენეჯერი დაგიკავშირდებათ ძირითადი მიზნების დასადგენად',
  automotive_industry_price_analysis_44: 'ჩვენ ვატარებთ მარკეტინგულ კვლევას',
  automotive_industry_price_analysis_45:
    'ჩვენ რეგულარულად მოგაწვდით ანგარიშებს და რეკომენდაციებს ონლაინ ფორმატში',
  automotive_industry_price_analysis_46: 'მანქანა გასაყიდი სტიკერით',
  automotive_industry_price_analysis_47: 'პროექტს ვიწყებთ 1 დღეში!',
  automotive_industry_price_analysis_48:
    'ჩვენ გთავაზობთ ანგარიშების სრულ პაკეტს, მათ შორის ფოტორეპორტაჟებს, PPT ანგარიშებს და Excel-ის მოხსენებებს, რომლებიც სეგმენტირებულია რელიეფის ტიპის მიხედვით',
  retail_audit_1: 'ვაჭრობის ქსელების აუდიტი / საცალო ვაჭრობის აუდიტი',
  retail_audit_2:
    'შეაგროვეთ დეტალური მონაცემები თქვენი მაღაზიის ან ბრენდის შესახებ, გააანალიზეთ ზრდის ბარიერები და შექმენით ეფექტური სტრატეგიები მათ დასაძლევად',
  retail_audit_3: 'შექმენით ციტატის მოთხოვნა',
  retail_audit_4:
    '4Service ატარებს მაღაზიების აუდიტს ბრენდების სახელით, რათა შეაფასოს მათი სარეკლამო აქციების, შემსრულებელი გუნდების და მარკეტინგული ტაქტიკების ეფექტურობა მიზნობრივი ბაზრის მისაღწევად.',
  retail_audit_5:
    'ჩვენ ყურადღებით ვაკვირდებით სარეკლამო კამპანიების ჩატარებას და ვუზრუნველყოფთ სარეკლამო მითითებების დაცვას.',
  retail_audit_6: '10 საუკეთესო',
  retail_audit_7: 'CX სააგენტოები ევროპაში',
  retail_audit_8: 'წლების გამოცდილება',
  retail_audit_9: 'ქვეყნების გაშუქება',
  retail_audit_10: '1,6 მილიონი',
  retail_audit_11: 'შეფასებები ყოველწლიურად',
  retail_audit_12: 'რასაც ვადევნებთ თვალყურს?',
  retail_audit_13: 'მასალების ხელმისაწვდომობა გაყიდვის წერტილებისთვის (POS)',
  retail_audit_14:
    'ბრენდის წარმომადგენლების არსებობა და გააქტიურება, დაგეგმილი გრაფიკის დაცვის უზრუნველყოფა',
  retail_audit_15:
    'ბრენდის წარმომადგენლების ჩართულობის შეფასება მხარდამჭერ კამპანიებში',
  retail_audit_16:
    'მომხმარებელთან ურთიერთქმედების შეფასება, სარეკლამო პროგრამებისა და ბრენდის შეტყობინებების დაცვის უზრუნველყოფა',
  retail_audit_17: 'თაღლითობის პრევენციის ზომები',
  retail_audit_18:
    'თქვენი ბიზნესი შეძლებს გამოიყენოს სავაჭრო წერტილში მარკეტინგის აუდიტის  შემდეგისთვის:',
  retail_audit_19: 'ბიუჯეტისა და პროცესის შესაბამისობის შეფასება',
  retail_audit_20: 'რეალური შედეგების შედარება მოსალოდნელ მიზნებთან',
  retail_audit_21: 'მარკეტინგული კამპანიების ეფექტურობის გაუმჯობესება ',
  retail_audit_22: 'მომავლის სტრატეგიული დაგეგმვა',
  retail_audit_23: 'ხარჯების შემცირების შესაძლებლობების იდენტიფიცირება',
  retail_audit_24: 'გაყიდვებისა და კონვერტაციის განაკვეთების გაუმჯობესება',
  retail_audit_25: 'ინვესტიციის დაბრუნების ოპტიმიზაცია (ROI)',
  retail_audit_26:
    'ისინი ირჩევენ 4SERVICE-ს, როგორც სავაჭრო საინვესტიციო პარტნიორს',
  retail_audit_27:
    'მათ აირჩიეს 4Service, როგორც სავაჭრო ინვესტიციების პარტნიორი წამყვანი საერთაშორისო თამბაქოს მწარმოებელი გახდა 4Service-ის პარტნიორი თავისი ბრენდების გაძლიერებისა და მაღაზიებში მუშაობის გაუმჯობესების მიზნით. ჩვენი გუნდები ატარებდნენ მარკეტინგის აუდიტს ადგილზე და დანერგეს მომხმარებელთა შთაბეჭდილებების რეალური ანგარიშგების სისტემა',
  retail_audit_28: 'საველე მარკეტინგული სააგენტოს დაგეგმვის სიზუსტის გაზრდა',
  retail_audit_29: 'ბრენდის შინაარსის გადაცემის გაძლიერება',
  retail_audit_30: 'მომხმარებელთა მოზიდვა და აქტივობის გაზრდა (BA engagement)',
  retail_audit_31:
    'მონაცემთა შეგროვების სიზუსტისა და მონაცემთა დაცვის ზოგადი დებულების მოთხოვნებთან შესაბამისობის გაზრდა (GDPR)',
  retail_audit_32: 'რა ღირებულ ინსაითებს ვიღებთ ჩვეულებრივ:',
  retail_audit_33:
    'SLA-ს პირობებს შორის შეუსაბამობები ან თუნდაც კონფლიქტები, რომლებიც იწვევს მნიშვნელოვან ზედმეტ ხარჯებს კლიენტისთვის',
  retail_audit_34:
    'სერვისების ტიპებში არევა, რაც იწვევს მომსახურების ღირებულების არასწორად გამოთვლას',
  retail_audit_35:
    'საომარი სამუშაოები არ ტარდება (მათ შორის, როდესაც დაგეგმილ ლოკაციას ან POS-ს პერსონალი არ ენიშნება)',
  retail_audit_36:
    'გადახდები ხდება შეფასების საფუძველზე და არა ფაქტობრივი მაჩვენებლების მიხედვით, და ეს არ არის შეთანხმებული',
  retail_audit_37:
    'პრომო-ინსტრუქცია გამოიყენება არასწორად, რაც იწვევს არასწორი მონაცემების მიწოდებას',
  retail_audit_38: 'როგორ ვმუშაობთ?',
  retail_audit_39:
    'ჩვენი აუდიტორი სააგენტოს გეგმის მიხედვით ეწვევა დანიშნულ გაყიდვების პუნქტებს (POS).',
  retail_audit_40:
    'ისინი ზომავენ შესრულების ძირითად ინდიკატორებს (KPI), რომლებიც მითითებულია მითითების პირობებში, როგორიცაა POS ყოფნა, ბრენდის წარმომადგენლის ჩართულობა, შესაბამისობა სარეკლამო გაიდლაინებთან და თაღლითობის პრევენციის ზომები.',
  retail_audit_41: 'ვალიდაცია:',
  retail_audit_42: 'ჩვენ ვაგროვებთ და ვაჯამებთ მიღებულ მონაცემებს.',
  retail_audit_43: 'შედგენილია ყოვლისმომცველი ანგარიში.',
  retail_audit_44:
    'ჩვენი გუნდი განიხილავს ყველა გამოკითხვას ვალიდობისთვის, მათ შორის პროექტის ბრიფინგთან შესაბამისობაში და ნებისმიერ დამატებით კომენტარს.',
  retail_audit_45: 'ონლაინ ანგარიშგების სისტემა:',
  retail_audit_46:
    'შევსებული და დამოწმებული კითხვარები აიტვირთება ჩვენს ონლაინ პორტალზე 36 საათის განმავლობაში.',
  retail_audit_47:
    'კლიენტებს აქვთ წვდომა პორტალზე არსებულ პირად ანგარიშზე, რომელიც საშუალებას აძლევს მათ ნებისმიერ დროს დააკვირდნენ პროექტის მიმდინარეობას.',
  retail_audit_48:
    'მოწოდებულია საბოლოო ანგარიში შედეგებითა და რეკომენდაციებით.',
  retail_audit_49: 'დაუკავშირდით ექსპერტს',
  retail_audit_50: 'ჩვენი უპირატესობები:',
  facility_check_audit_1: 'დაწესებულება',
  facility_check_audit_2: 'დაწესებულების აუდიტი',
  facility_check_audit_3: 'აამაღლეთ ბრენდის გამოცდილება ყველა დეტალში',
  facility_check_audit_4: 'შეიტყვეთ ჩვენი მიდგომის შესახებ',
  facility_check_audit_5: 'Ჩვენს შესახებ',
  facility_check_audit_6: 'Ვინ ვართ ჩვენ',
  facility_check_audit_7:
    'როგორც მომხმარებელთა გამოცდილების გლობალური ლიდერი, 4Service გთავაზობთ სერვისების კომპლექტს, რომელიც ეხმარება ბრენდებს შექმნან და მიაწოდონ განსაკუთრებული გამოცდილება თავიანთი მომხმარებლებისთვის.',
  facility_check_audit_8: 'ჩვენი ობიექტის ინსპექტირების სამსახური',
  facility_check_audit_9:
    'შექმნილია იმისთვის, რომ დარწმუნდეთ, რომ თქვენი მდებარეობები და ბრენდის ყოფნა საცალო მაღაზიებში შეესაბამება თქვენი ბრენდის სტანდარტებს და ქმნის პოზიტიურ მომხმარებელთა გამოცდილებას.',
  facility_check_audit_10: 'გამოსავალი 1',
  facility_check_audit_11: 'დაწესებულების აუდიტი',
  facility_check_audit_12:
    ' - ეს არის საფუძვლიანი კვლევა, რომელიც აფასებს თქვენი საცალო დაწესებულებების ან თქვენი ბრენდის სტანდარტებთან შესაბამისობას. ჩვენ არა მხოლოდ განვიხილავთ ფიზიკურ ატრიბუტებს, არამედ განვსაზღვრავთ, თუ როგორ მოქმედებს ეს ელემენტები თქვენი ბრენდის აღქმაზე თქვენი ძვირფასი მომხმარებლების მიერ.',
  facility_check_audit_13: 'ორი გადაწყვეტილება ',
  facility_check_audit_14: 'შესრულების ორი მეთოდი',
  facility_check_audit_15: 'მეთოდი',
  facility_check_audit_16: 'დაწესებულების შემოწმება ექსპერტი აუდიტორების მიერ',
  facility_check_audit_17: 'დაწესებულების აუდიტის დადასტურება',
  facility_check_audit_18: 'იუწყება',
  facility_check_audit_19:
    'თქვენ მიიღებთ ანგარიშებს, რომლებიც შეიცავს ვიზუალურ მტკიცებულებებს და სტატისტიკას, რომელიც ხელმისაწვდომი იქნება 48 საათის განმავლობაში',
  facility_check_audit_20:
    'კარგად შესრულებული დაწესებულების აუდიტს შეუძლია მრავალი სარგებელი მოუტანოს თქვენს ბრენდს, მათ შორის:',
  facility_check_audit_21: 'მომხმარებელთა კონვერტაციის გაუმჯობესება:',
  facility_check_audit_22:
    'მომხმარებელთა პოზიტიურმა გამოცდილებამ შეიძლება გამოიწვიოს გაყიდვების გაზრდა და განმეორებითი შესყიდვები. ჩვენი აუდიტი დაგეხმარებათ იდენტიფიცირება და გადაჭრას ნებისმიერი პრობლემური სფერო, რომელიც გავლენას ახდენს მომხმარებელთა კმაყოფილებაზე.',
  facility_check_audit_23: 'ბრენდის იმიჯის გაუმჯობესება:',
  facility_check_audit_24:
    'თქვენი ფიზიკური მდებარეობები კლიენტებისთვის მთავარი შეხების წერტილია და შეუძლია მნიშვნელოვანი როლი ითამაშოს თქვენი ბრენდის იმიჯის ჩამოყალიბებაში. ჩვენი აუდიტი დაგეხმარებათ დარწმუნდეთ, რომ თქვენი მდებარეობები შეესაბამება თქვენი ბრენდის ღირებულებებს და შექმნათ დადებითი მომხმარებლის გამოცდილება.',
  facility_check_audit_25: 'Რატომ ჩვენ?',
  facility_check_audit_26: 'რატომ არის მნიშვნელოვანი დაწესებულების აუდიტი?',
  facility_check_audit_27:
    'კარგად შესრულებული დაწესებულების აუდიტს შეუძლია მრავალი სარგებელი მოუტანოს თქვენს ბრენდს, მათ შორის:',
  facility_check_audit_28: 'ბრენდის იმიჯის გაუმჯობესება:',
  facility_check_audit_29:
    'თქვენი ფიზიკური მდებარეობები კლიენტებისთვის მთავარი შეხების წერტილია და შეუძლია მნიშვნელოვანი როლი ითამაშოს თქვენი ბრენდის იმიჯის ჩამოყალიბებაში. ჩვენი აუდიტი დაგეხმარებათ დარწმუნდეთ, რომ თქვენი მდებარეობები შეესაბამება თქვენი ბრენდის ღირებულებებს და შექმნათ დადებითი მომხმარებლის გამოცდილება.',
  facility_check_audit_30: 'მომხმარებელთა კონვერტაციის გაუმჯობესება:',
  facility_check_audit_31:
    'მომხმარებელთა პოზიტიურმა გამოცდილებამ შეიძლება გამოიწვიოს გაყიდვების გაზრდა და განმეორებითი შესყიდვები. ჩვენი აუდიტი დაგეხმარებათ იდენტიფიცირება და გადაჭრას ნებისმიერი პრობლემური სფერო, რომელიც გავლენას ახდენს მომხმარებელთა კმაყოფილებაზე.',
  facility_check_audit_32: 'ვისაც სჭირდება',
  facility_check_audit_33: 'ვის სჭირდება ობიექტის შემოწმება?',
  facility_check_audit_34:
    'ობიექტის აუდიტი არის ღირებული სერვისი ნებისმიერი ბრენდისთვის ფიზიკური მდებარეობით და რეალურ სამყაროში ფიზიკური ყოფნით. ეს განსაკუთრებით მნიშვნელოვანია ბრენდებისთვის, რომლებსაც სურთ:',
  facility_check_audit_35: 'დარწმუნდით, რომ შეესაბამება ბრენდის სტანდარტებს:',
  facility_check_audit_36:
    'ჩვენი აუდიტი დაგეხმარებათ ნებისმიერი სფეროს იდენტიფიცირებაში, სადაც თქვენი ობიექტები შეიძლება გადახრის თქვენი ბრენდის სტანდარტებს.',
  facility_check_audit_37: 'გააუმჯობესეთ მომხმარებლის გამოცდილება:',
  facility_check_audit_38:
    'ჩვენი აუდიტი დაგეხმარებათ იდენტიფიცირება შესაძლებლობების გაუმჯობესება მომხმარებლის გამოცდილება თქვენს ობიექტებში.',
  facility_check_audit_39: 'შექმენით უფრო ძლიერი ბრენდი:',
  facility_check_audit_40:
    'ჩვენი აუდიტი დაგეხმარებათ დარწმუნდეთ, რომ თქვენი ფიზიკური მდებარეობები ქმნის მომხმარებლის პოზიტიურ გამოცდილებას.',
  facility_check_audit_41:
    'ჩვენი აუდიტი დაგეხმარებათ დარწმუნდეთ, რომ თქვენი ფიზიკური მდებარეობები ქმნიან მომხმარებლის პოზიტიურ გამოცდილებას.',
  facility_check_audit_42: 'შემდეგ ავსებს ფორმას და ამატებს ფოტოს.',
  facility_check_audit_43:
    'ვალიდატორი იღებს ფოტოებს და ამოწმებს მათ შესაბამისობას სტანდარტებთან.',
  facility_check_audit_44: 'დაწესებულების შემოწმება ექსპერტი აუდიტორების მიერ',
  facility_check_audit_45: 'მომზადების ეტაპი:',
  facility_check_audit_46: 'აუდიტის განრიგის ერთობლივი დამტკიცება',
  facility_check_audit_47:
    'დილერები მზად არიან და ეცნობებათ მომავალი აუდიტის შესახებ',
  facility_check_audit_48: 'აუდიტორთა ტრენინგი:',
  facility_check_audit_49:
    'ჩვენი გამოცდილი 4Service ტრენერები აუდიტორებს აწვდიან რეკომენდაციებს ბრენდის მოთხოვნების შესაბამისად',
  facility_check_audit_50: 'დაწესებულების აუდიტის ეტაპი:',
  facility_check_audit_51:
    'აუდიტორები, რომლებსაც აქვთ სპეციალური ნებართვის წერილები, სტუმრობენ ადგილებს',
  facility_check_audit_52:
    'თითოეული პუნქტის საფუძვლიანი შესწავლა, რეკომენდაციების დაცვით',
  facility_check_audit_53:
    'ვიზუალური დოკუმენტაცია სათაო ოფისის მოთხოვნებთან შესაბამისობის შეფასებებთან ერთად',
  facility_check_audit_54: 'საბოლოო ანგარიში ფორმატში PPT',
  facility_check_audit_55:
    'ყოვლისმომცველი ანგარიში PowerPoint ფორმატში, რომელიც განმარტავს კვლევის შედეგებს',
  facility_check_audit_56:
    'აუდიტის შედეგების იმერსიული პრეზენტაცია ონლაინ/ოფლაინ',
  facility_check_audit_57: 'დაწესებულების აუდიტის დადასტურება',
  facility_check_audit_58: 'ნაბიჯები:',
  facility_check_audit_59: 'დაწესებულების აუდიტის ეტაპი:',
  facility_check_audit_60:
    'ბრენდის წარმომადგენლები იყენებენ 4Service აპს ადგილზე ფოტოგრაფიისთვის',
  facility_check_audit_61: 'მკაცრი ვიზუალური და აღწერითი კრიტერიუმების დაცვა',
  facility_check_audit_62: 'ვალიდაციის ეტაპი:',
  facility_check_audit_63:
    'კომპეტენტური ვალიდატორები ყურადღებით განიხილავენ თითოეულ ანგარიშს',
  facility_check_audit_64: 'ყოვლისმომცველი ფოტო შედარება ბრენდის სტანდარტებთან',
  facility_check_audit_65:
    'აბსტრაქტები და დასკვნები ჩართულია ანგარიშში სიცხადისთვის',
  facility_check_audit_66:
    'აუდიტორებთან პირდაპირი კომუნიკაცია საჭიროების შემთხვევაში დაზუსტებისთვის',
  facility_check_audit_67: 'მოხსენების ეტაპი:',
  facility_check_audit_68:
    'ვიზუალური მტკიცებულებებისა და სტატისტიკის შემცველი ანგარიშები ხელმისაწვდომია ორი დღის განმავლობაში',
  facility_check_audit_69: 'დაგვიკავშირდით დღესვე',
  cx_solution_1: 'ჩვენ არ ვპოულობთ მხოლოდ შეხედულებებს,',
  cx_solution_2: 'ჩვენ თქვენს ბიზნესს ახალ სიმაღლეებზე ვაყენებთ',
  cx_solution_3:
    '20 წელზე მეტი მომხმარებლის გამოცდილების მქონე ექსპერტები აღმოაჩენენ კომპლექსურ გადაწყვეტილებებს და მოგაწვდით კონკრეტულ სამოქმედო გეგმას, რომელიც მხარს უჭერს თქვენს ზრდას',
  cx_solution_4:
    'გახსენით სერვისების უნიკალური ნაკრები სამომავლო გადაწყვეტილებით',
  cx_solution_5: 'All-in-one გადაწყვეტა CX',
  cx_solution_6: 'სარეკლამო ტესტირება',
  cx_solution_7: 'ხელოვნური ინტელექტი და ნეირომარკეტინგი',
  cx_solution_8: 'დამკვეთის ხმა',
  cx_solution_9: 'სამაგიდო კვლევა',
  cx_solution_10: 'მომხმარებელთა მოგზაურობის რუკა',
  cx_solution_11: 'საიდუმლო შოპინგი',
  cx_solution_12: 'CX კონსულტაცია',
  cx_solution_13: 'მოსმენა სოციალურ ქსელებში',
  cx_solution_14: 'რაოდენობრივი და თვისებრივი კვლევა',
  cx_solution_15: 'სერვისების დიზაინი',
  cx_solution_16: 'Მარკეტინგული სტრატეგია',
  cx_solution_17: 'UX/UI ტესტირება',
  cx_solution_18: 'შეხედულებები აუდიტორიის შესახებ',
  cx_solution_19:
    'ჩვენ მადლობელი ვართ იმ შესაძლებლობისთვის, რომ წვლილი შევიტანოთ თქვენს წარმატებაში',
  cx_solution_20:
    'ჩვენ ვაკონფიგურირებთ და ვაერთიანებთ ინსტრუმენტებსა და სერვისებს თქვენი ბიზნესის მიზნებისა და ამოცანების საფუძველზე კონკრეტული შედეგების მისაღწევად',
  cx_solution_21: 'ყოვლისმომცველი კვლევები',
  cx_solution_22:
    'გააძლიერეთ თქვენი გადაწყვეტილების მიღება კონკურენტული უპირატესობით მონაცემთა ბაზარში.',
  cx_solution_23:
    'თვისებრივი კვლევა არის არარიცხობრივი მონაცემების შეგროვება და ანალიზი ცნებების, მოსაზრებების ან გამოცდილების გასაგებად',
  cx_solution_24:
    'რაოდენობრივი კვლევის მეთოდები არის ინტერვიუების, კითხვარებისა და გამოკითხვების შედეგად მიღებული მონაცემების ობიექტური გაზომვა და რიცხვითი ანალიზი',
  cx_solution_25:
    'ჩვენ ვიყენებთ ინსტრუმენტების სპეციალურ კომპლექტს თქვენი კონკრეტული მოთხოვნების გათვალისწინებით',
  cx_solution_26: 'ხელსაწყოები',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    'კომპიუტერული ვებ გამოკითხვა არის მნიშვნელოვანი ინსტრუმენტი ჩვენს არსენალში, რომელიც საშუალებას გვაძლევს ჩავატაროთ გამოკითხვები და შევაგროვოთ მონაცემები ონლაინ პლატფორმების მეშვეობით სპეციალიზებული პროგრამული უზრუნველყოფის გამოყენებით, რაც უზრუნველყოფს ჩვენი კლიენტების მარკეტინგული კვლევის საჭიროებების ეფექტური და ზუსტი მონაცემების შეგროვებას',
  cx_solution_29: 'CATI',
  cx_solution_30:
    'კომპიუტერული სატელეფონო გამოკითხვა არის მეთოდი, რომელსაც ვიყენებთ გამოკითხვების ჩასატარებლად და ტელეფონით ღირებული მონაცემების შესაგროვებლად, სპეციალიზებული პროგრამული უზრუნველყოფის გამოყენებით პროცესის გასამარტივებლად და ჩვენი ბაზრის კვლევის სიზუსტის უზრუნველსაყოფად',
  cx_solution_31: 'F2F',
  cx_solution_32:
    'პერსონალური შეხება ჩვენი მიდგომის განუყოფელი ნაწილია, რომელიც საშუალებას აძლევს კლიენტებთან და მომხმარებლებთან პირდაპირი ურთიერთობისა და პერსონალიზებული კონტაქტების ხელშეწყობას, ნდობის, გაგებისა და ეფექტური კომუნიკაციის ხელშეწყობას, რაც არის ხანგრძლივი ურთიერთობების დამყარებისა და ბიზნესის წარმატების უზრუნველსაყოფად',
  cx_solution_33: 'სამაგიდო კვლევა',
  cx_solution_34:
    'სამაგიდო კვლევა მოიცავს მონაცემთა ყოვლისმომცველ შეგროვებას და ანალიზს, რაც ფუნდამენტური ნაბიჯია ჩვენი კვლევის პროცესში, რათა შევაგროვოთ შეხედულებები და განვსაზღვროთ სტრატეგიული გადაწყვეტილებები ჩვენი კლიენტებისთვის',
  cx_solution_35: 'SWOT-ანალიზი',
  cx_solution_36:
    'SWOT-ანალიზი - არის სტრატეგიული შეფასების ინსტრუმენტი, რომელიც ეხმარება ჩვენს კლიენტებს ამოიცნონ შიდა ძლიერი და სუსტი მხარეები, ასევე გარე შესაძლებლობები და საფრთხეები, რაც უზრუნველყოფს გადაწყვეტილების მიღებისა და ეფექტური ბიზნეს სტრატეგიების შემუშავებას',
  cx_solution_37: 'ეთნოგრაფიული კვლევები',
  cx_solution_38:
    'ადამიანებისა და კულტურების შესწავლა მათ ბუნებრივ გარემოში ღრმა ჩაძირვისა და დაკვირვების გზით, რაც ხშირად იწვევს ქცევის, რწმენის და სოციალური დინამიკის გაგებას',
  cx_solution_39: 'სიღრმისეული ინტერვიუები',
  cx_solution_40:
    'სიღრმისეული ინტერვიუები - არის თვისებრივი კვლევის მეთოდი, რომელსაც ჩვენ ვიყენებთ, მათ შორის სიღრმისეული პირადი დისკუსიები მონაწილეებთან, რათა მივიღოთ მათი შეხედულებების, გამოცდილების და მოსაზრებების სიღრმისეული გაგება, ჩვენი კლიენტების კვლევის მიზნებისა და გადაწყვეტილების მიღების პროცესების მდიდარ შეხედულებებსა და გაგებას',
  cx_solution_41: 'იდეების გენერირების სესიები',
  cx_solution_42:
    'იდეების გენერირების სესიები - არის ერთობლივი სესიები, რომელსაც ჩვენ ვატარებთ, რომლებიც აერთიანებს სხვადასხვა პერსპექტივებსა და გამოცდილებას კრეატიული იდეებისა და გადაწყვეტილებების შესაქმნელად, ჩვენი კლიენტების გამოწვევებისა და შესაძლებლობების გადასაჭრელად, ინოვაციებისა და სტრატეგიული ინიციატივების წინსვლისთვის',
  cx_solution_43: 'მყიდველის პროფილები',
  cx_solution_44:
    'მყიდველის პროფილები - ეს არის დეტალური პროფილები, რომლებსაც ჩვენ ვავითარებთ ჩვენი კლიენტების სამიზნე კლიენტების წარმოსახვით, კვლევისა და მონაცემთა ანალიზის საფუძველზე, რაც საშუალებას გვაძლევს უკეთ გავიგოთ მათი საჭიროებები, პრეფერენციები და ქცევები და მოვარგოთ ჩვენი სტრატეგიები და კომუნიკაციები მათთან ეფექტური ჩართვისა და კომუნიკაციისთვის. ბიზნესის წარმატება',
  cx_solution_45: 'საიდუმლო შოპინგი',
  cx_solution_46:
    'საიდუმლო შოპინგი - არის სტრატეგიული სერვისი, რომელსაც ვთავაზობთ კლიენტსა და კომპანიას შორის ურთიერთქმედების გაზომვისა და მონიტორინგისთვის წინასწარ განსაზღვრული სცენარის დროს',
  cx_solution_47: 'თანმხლები ჩეკი',
  cx_solution_48:
    'თანმხლები ჩეკი - არის საიდუმლო შოპინგის სპეციალიზებული ფორმა, სადაც ჩვენი შემფასებლები თან ახლავს კლიენტებს მათი სერვისის გამოცდილების განმავლობაში, რაც უზრუნველყოფს ყოვლისმომცველ ინფორმაციას მომხმარებლის მოგზაურობის ყველა ასპექტზე, რაც საშუალებას აძლევს ჩვენს მომხმარებლებს უკეთ გაიგონ მათი მომსახურება და განახორციელონ ინფორმირებული გაუმჯობესება მომხმარებელთა საერთო ლოიალობის გასაუმჯობესებლად',
  cx_solution_49: 'უკუკავშირის შეგროვების ანალიზი',
  cx_solution_50:
    'უკუკავშირის შეგროვების ანალიზი - არის მნიშვნელოვანი პროცესი, რომელსაც ჩვენ ვახორციელებთ, მათ შორის, სისტემატური შეგროვებისა და ანალიზების მომხმარებელთა გამოხმაურების სხვადასხვა წყაროებიდან, როგორიცაა გამოკითხვები, ჩვენებები და სოციალური მედია, რაც საშუალებას გვაძლევს გამოვიტანოთ ღირებული შეხედულებები, გამოვავლინოთ ტენდენციები და გავაკეთოთ მონაცემების საფუძველზე რეკომენდაციები ჩვენი მომხმარებლებისთვის, რათა გააუმჯობესონ პროდუქტები. , მომსახურება და მომხმარებლის საერთო გამოცდილება',
  cx_solution_51: 'ონლაინ ფოკუს-ჯგუფები',
  cx_solution_52:
    'ონლაინ ფოკუს-ჯგუფები - არის დინამიური კვლევის სესიები, რომლებსაც ჩვენ ვატარებთ, ვაერთიანებთ მონაწილეთა მრავალფეროვან ჯგუფს კონკრეტული თემების ან პროდუქტების სიღრმისეულად განსახილველად, რაც საშუალებას გვაძლევს შევკრიბოთ ხარისხობრივი შეხედულებები, აღმოვაჩინოთ ურთიერთობები, პრეფერენციები და აღქმები და გამოვიკვლიოთ იდეები და კონცეფციები, რომლებიც საბოლოოდ აცნობებენ ჩვენს კლიენტებს შემდგომი ქმედებების სტრატეგიის შემუშავება.',
  cx_solution_53: '20 წლიანი უნიკალური მომხმარებლის გამოცდილების შექმნა',
  cx_solution_54:
    'დარწმუნდით, რომ თქვენი შეტყობინება იპყრობს და რეზონანსს უწევს თქვენს აუდიტორიას.',
  cx_solution_55:
    'ჩვენ მზად ვართ მივაღწიოთ შედეგებს, რომლებიც აღემატება თქვენს მოლოდინს',
  cx_solution_56:
    'ჩვენ ვპოულობთ ყოვლისმომცველ გადაწყვეტილებებს, რომლებიც ხელს უწყობს თქვენს ზრდას',
  cx_solution_57:
    'გააუმჯობესეთ თქვენი მომხმარებლის გამოცდილება ჩვენი მეთოდოლოგიით ',
  cx_solution_58:
    'მომხმარებელთა მოგზაურობის რუკა არის თქვენი სამიზნე აუდიტორიის განსაზღვრა, მათი საჭიროებებისა და გარემოს გაგება და, შედეგად, გეგმის შექმნა საინტერესო გამოცდილების მიწოდებისთვის',
  cx_solution_59: 'BHT',
  cx_solution_60:
    'ბრენდის ჯანმრთელობის კვლევამ შეიძლება გაზომოს, თუ როგორ ურთიერთქმედებს ბრენდი თავის აუდიტორიასთან, მის გამოყენებასთან, პოზიციონირებასთან და შესრულებასთან',
  cx_solution_61: 'CSI',
  cx_solution_62:
    'მომხმარებელთა კმაყოფილების ინდექსი არის ქულა, რომელიც მიუთითებს რამდენად კმაყოფილი არიან თქვენი მომხმარებლები კომპანიის პროდუქტებით/მომსახურებით.',
  cx_solution_63:
    'ფასების მონიტორინგი არის კონკურენტების ფასების შეგროვების, დამუშავებისა და ანალიზის პროცესი',
  cx_solution_64: 'NPS',
  cx_solution_65:
    'Net Promoter Score - არის მომხმარებელთა გამოცდილების მეტრიკის ოქროს სტანდარტი, რომელიც დაფუძნებულია ერთ კითხვაზე',
  cx_solution_66: 'HR-კვლევა',
  cx_solution_67:
    'ადამიანური რესურსების კვლევა გამოიყენება HR პრაქტიკისა და მუშაობის შესაფასებლად და უზრუნველყოფს მიმდინარე მოვლენებისა და მენეჯმენტის დეტალურ ანალიზს',
  cx_solution_68:
    'გამოყენებადობის ტესტირება არის დაკვირვება, თუ როგორ ურთიერთობენ რეალური ადამიანები ვებსაიტთან, აპლიკაციასთან ან სხვა პროდუქტთან და აკვირდებიან მათ ქცევასა და რეაქციებს მასზე',
  cx_solution_69: 'სხვა',
  cx_solution_70:
    'ექსპერტები ირჩევენ საუკეთესო მეთოდოლოგიას თქვენი ბიზნესისთვის',
  cx_solution_71: 'Დავიწყოთ',
  cx_solution_72: '1 - პირველადი შეხვედრა',
  cx_solution_73:
    'პირველი შეხვედრის დროს ჩვენ ყურადღებას ვაქცევთ ძირითად ამოცანებს და ვიწინასწარმეტყველებთ შედეგს',
  cx_solution_74: '2 - კონცეფციის შემუშავება',
  cx_solution_75:
    '4Service ანალიტიკური დეპარტამენტი აგროვებს მონაცემებს და კოორდინაციას უწევს ანგარიშის სტრუქტურას. შემდეგ ჩვენ წარვუდგენთ შედეგებს კლიენტს, სრულფასოვნად და რეკომენდაციებით განხორციელებისთვის.',
  cx_solution_76: '3 - საველე სამუშაოები',
  cx_solution_77:
    'კვლევის ჩასატარებლად ვიზიდავთ მონაწილეებს, ვატარებთ ინტერვიუებს და კვლევის სხვა ძირითად ეტაპებს. კლიენტი იღებს გადაწერილ აუდიო-ვიდეო ინტერვიუებს, ასევე მოკლე რეზიუმეს.',
  cx_solution_78: '4 - ანალიტიკა',
  cx_solution_79:
    '4Service ანალიტიკური დეპარტამენტი აგროვებს მონაცემებს და კოორდინაციას უწევს ანგარიშის სტრუქტურას. შემდეგ ჩვენ წარვუდგენთ შედეგებს კლიენტს, სრულფასოვნად და რეკომენდაციებით განხორციელებისთვის.',
  cx_solution_80: '5 - სახელოსნო',
  cx_solution_81:
    'განხორციელების გეგმასთან დაკავშირებით კლიენტთან დისკუსიის წარმართვა',
  cx_solution_82: 'შეიტყვეთ მეტი ჩვენი საუკეთესო პრაქტიკის შესახებ',
  cx_solution_83:
    'მომხმარებელთა მოგზაურობის რუკა საშუალებას გაძლევთ სწრაფად შეისწავლოთ ყველა საკომუნიკაციო არხი, დაადგინოთ პოტენციური ხარვეზები კრიტიკულ შეხების წერტილებში და მიიღოთ ღრმა ხედვა იმ სფეროებში, რომლებიც შესაძლოა გადახრის დაგეგმილი კურსიდან.',
  cx_solution_84: 'როდის უნდა იქნას გამოყენებული?',
  cx_solution_85:
    'რეალური აუდიტორიის მონაცემებზე დაფუძნებული პერსონალიზებული სარეკლამო კამპანიის შექმნა',
  cx_solution_86:
    'სამიზნე აუდიტორიის სხვადასხვა სეგმენტის მოტივაციის იდენტიფიცირება და მათი მოთხოვნილებების დაკმაყოფილება',
  cx_solution_87:
    'ზუსტი ფოკუსირება თითოეულ ჯგუფზე და მიიღეთ მაქსიმალური კონვერტაცია',
  cx_solution_88:
    'მხარდაჭერის ტექნიკა საშუალებას გაძლევთ შეაფასოთ თქვენი მიზნების მისაღწევად ოპტიმალური გზების შესაძლებლობები.',
  cx_solution_89: 'ახალი ვებსაიტის ან პროდუქტის ტესტირება გაშვებამდე',
  cx_solution_90:
    'განვითარებული პროცესების ვალიდაცია ცვლილებების განხორციელებამდე',
  cx_solution_91: 'ვებსაიტის ან პროდუქტის შეფასება გაყიდვების შემცირების ფონზე',
  cx_solution_92:
    'ახალი პროდუქტის გაშვება, რომელიც აკმაყოფილებს მომხმარებლის მოთხოვნებს',
  cx_solution_93:
    'კონკურენტი კომპანიების შესწავლა ბაზარზე წამყვანი პოზიციის უზრუნველსაყოფად',
  cx_solution_94:
    'ჩვენ გთავაზობთ ყოვლისმომცველ 360° მიდგომას მომხმარებელზე ორიენტირებული სერვისის მოდელის შესაქმნელად.',
  cx_solution_95: 'პერსონალის მომზადება და განვითარება',
  cx_solution_96: 'მომსახურების სტანდარტების გაუმჯობესება',
  cx_solution_97: 'მომხმარებელთა ნაკადის გაზრდა და გაყიდვები',
  cx_solution_98: 'პერსონალის KPI და მოტივაციის სისტემის დაყენება',
  cx_solution_99: 'შეიტყვეთ ჩვენი წარმატების ისტორიების შესახებ',
  cx_solution_100: 'Საავტომობილო ინდუსტრია',
  cx_solution_101: 'თამბაქოს ინდუსტრია',
  cx_solution_102: 'Საცალო',
  cx_solution_103: 'ხარისხის ეტაპი',
  cx_solution_104: 'რაოდენობრივი ფაზა (სეგმენტაცია)',
  cx_solution_105: 'ონლაინ ფოკუს-ჯგუფები',
  cx_solution_106: 'მიაღწიეთ ონლაინ აუდიტორიას მთელს მსოფლიოში',
  cx_solution_107: 'ინტერვიუს ტექნიკის კომბინაცია',
  cx_solution_108: 'მხოლოდ ღია კითხვები',
  cx_solution_109: 'რესპონდენტებისთვის მრგვალი საათის მხარდაჭერა',
  cx_solution_110: 'მნიშვნელოვანი დეტალების შენახვა და რეალური საგზაო რუკა',
  cx_solution_111: 'Ბაზრის კვლევა',
  cx_solution_112: 'კომპანიისა და კონკურენტების დიაგნოზი',
  cx_solution_113: 'სერვისის მოდელების განახლება და ახალი ბიზნეს პროცესები',
  cx_solution_114: 'მომხმარებელზე ორიენტირებული სერვისის ხელშეწყობა',
  cx_solution_115:
    'ცვლილებების განხორციელება და კონტროლი მომსახურების სტრატეგიების შემუშავებაზე',
  usage_attitude_1: 'გამოყენება და კავშირი (U&A',
  usage_attitude_2:
    'მიიღეთ ყოვლისმომცველი წარმოდგენები იმის შესახებ, თუ როგორ აღიქვამს, იყენებს და ურთიერთობს თქვენი ბრენდის მიზნობრივი აუდიტორია.',
  usage_attitude_3: 'დაუკავშირდით ექსპერტს',
  usage_attitude_4: 'შესახებ',
  usage_attitude_5:
    '<b>შეისწავლეთ მომხმარებელთა ჩვევები</b>, რათა გამოავლინოთ ღრმა პრეფერენციები და გავლენები',
  usage_attitude_6:
    '<b>გაიგეთ, „რა“</b> დგას მომხმარებლის არჩევანის მიღმა ჩვენი დეტალური ანალიზის საშუალებით',
  usage_attitude_7:
    '<b>გაიგეთ, როგორ</b> ურთიერთობენ მომხმარებლები თქვენს პროდუქტებთან, რათა შეიმუშავოთ სტრატეგიული იდეები',
  usage_attitude_8:
    '<b>მიიღეთ წარმოდგენებია</b> მომხმარებელთა ქცევის, ჩვევებისა და პრეფერენციების შესახებ, რათა მიიღოთ დასაბუთებული გადაწყვეტილებები',
  usage_attitude_9: 'გამოცდილება',
  usage_attitude_10:
    '4Service ექსპერტები, რომლებსაც აქვთ 20 წელზე მეტი გამოცდილება მომხმარებელთა მომსახურებაში, შეიმუშავებენ უნიკალურ გადაწყვეტილებებს, რომლებიც ხელს უწყობენ თქვენი ბიზნესის ზრდას',
  usage_attitude_11: 'Დაგვიკავშირდით',
  usage_attitude_12: 'ვისთვის',
  usage_attitude_13: 'ვინ სარგებლობს ბრენდის გამოყენებისა და ასოციაციისგან?',
  usage_attitude_14:
    'დაინტერესებულია სხვადასხვა მრეწველობისა და მომსახურების სექტორი:',
  usage_attitude_15:
    '<b>აღიარებული</b> მომხმარებელთა საჭიროებები და ტკივილის წერტილები',
  usage_attitude_16:
    '<b>აღმოჩენილია</b> მომხმარებელთა აქტივობის გაზრდის შესაძლებლობა',
  usage_attitude_17:
    '<b>დეველოპერები</b> ახალი პროდუქტის კატეგორიები ან მარკეტინგული სტრატეგიები',
  usage_attitude_18: '<b>მიღება</b> კონკურენტული გარემოს ღრმა გაგება',
  usage_attitude_19:
    'მეთოდოლოგია შეირჩევა ინდივიდუალურად, კლიენტის მოთხოვნიდან გამომდინარე',
  usage_attitude_20:
    '<b>თვისებრივი კვლევა</b> მოიცავს არარიცხობრივი მონაცემების შეგროვებას და ანალიზს ცნებების, აზრების ან გამოცდილების გასაგებად.',
  usage_attitude_21:
    '<b>რაოდენობრივი კვლევები</b> მოიცავს გამოკითხვების, კითხვარების ან ინტერვიუების მეშვეობით მიღებული მონაცემების ობიექტურ გაზომვას და რიცხვობრივ ანალიზს.',
  usage_attitude_22:
    '<b>მონაცემთა შეგროვების შემდეგ</b> ექსპერტები აანალიზებენ ინფორმაციას და აკეთებენ დასკვნებს, რომ მოგაწოდოთ საუკეთესო რეკომენდაციები.',
  usage_attitude_23: 'ვისაც სჭირდება',
  usage_attitude_24: 'თქვენი წარმატების ისტორია აქ იწყება',
  usage_attitude_25:
    '<b>თქვენ მიიღებთ კვლევას</b> ღირებული შეხედულებებით, რომლებიც ამოძრავებს სტრატეგიული გადაწყვეტილებების მიღებას, რაც საშუალებას აძლევს მოქმედებას, რომელიც დაფუძნებულია მომხმარებლის ქცევის ღრმა გაგებაზე.',
  usage_attitude_26:
    '<b>ვლევა იძლევა მყარ საფუძველს გაუმჯობესებისთვის</b> და ბრენდის სტრატეგიების ოპტიმიზაცია, მათი დაახლოება მომხმარებელთა პრეფერენციებთან და დამოკიდებულებებთან.',
  usage_attitude_27: 'გადაწყვეტილება',
  usage_attitude_28: 'გამოიკვლიეთ მრავალი შესაძლებლობა ჩვენი გადაწყვეტილებებით',
  usage_attitude_29: 'პროდუქტის სარგებელი კატეგორიაში',
  usage_attitude_30:
    'განსაზღვრეთ მომხმარებელთა მთავარი პრეფერენციები კატეგორიებში, მათ შორის საკვები, სასმელი, ტანსაცმელი, ელექტრონიკა და სხვა.',
  usage_attitude_31: 'მოხმარება/გამოყენება',
  usage_attitude_32:
    'გააანალიზეთ კონკრეტული პროდუქტების/მომსახურების მოხმარების ან გამოყენების სიხშირე და გამოავლინეთ მათ გამოყენებასთან დაკავშირებული შემთხვევები და მომენტები.',
  usage_attitude_33: 'ქცევა შეძენისას',
  usage_attitude_34:
    'გამოიკვლიეთ არხები, რომლებსაც თქვენი მომხმარებლები იყენებენ შესყიდვების შესასრულებლად და დაადგინეთ ინფორმაციის წყაროები, რომლებსაც ისინი ეყრდნობიან.',
  usage_attitude_35: 'მომხმარებელთა მოტივაცია და საჭიროებები',
  usage_attitude_36:
    'გამოიკვლიეთ მოტივები და ბარიერები, რომლებიც გავლენას ახდენენ მოხმარებაზე. შეაფასეთ მომხმარებელთა შესყიდვებზე მოქმედი ფაქტორები. შეისწავლეთ პროდუქტის კატეგორიის აღქმა და გაანალიზეთ როგორ აღიქმება ფასი.',
  usage_attitude_37: 'Ჩვენი მიდგომა',
  usage_attitude_38: 'ბრენდის გამოყენებისა და დამოკიდებულების შესწავლა',
  usage_attitude_39: 'ინფორმაცია',
  usage_attitude_40:
    'გამოკითხვების ჩატარება როგორც რაოდენობრივი, ასევე ხარისხობრივი მეთოდებით',
  usage_attitude_41: 'Დავიწყოთ',
  usage_attitude_42:
    'მიზნების დასახვა და ინდივიდუალური მოთხოვნების საფუძველზე მეთოდების განსაზღვრა',
  usage_attitude_43: 'ანალიზი',
  usage_attitude_44: 'ჩვენი ექსპერტების მიერ რთული ტექნიკების გამოყენება',
  usage_attitude_45:
    'ჩვენ ვიყენებთ ინსტრუმენტების ცალკეულ კომპლექტს თქვენი კონკრეტული მოთხოვნების გათვალისწინებით',
  usage_attitude_46: 'СATI',
  usage_attitude_47:
    'კომპიუტერის დახმარებით სატელეფონო გამოკითხვა არის მეთოდი, რომელსაც ვიყენებთ გამოკითხვების ჩასატარებლად და ტელეფონით ღირებული მონაცემების შესაგროვებლად, სპეციალიზებული პროგრამული უზრუნველყოფის გამოყენებით პროცესის გასამარტივებლად და ჩვენი ბაზრის კვლევის სიზუსტის უზრუნველსაყოფად.',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    'კომპიუტერის დახმარებით ვებ გამოკითხვა არის მნიშვნელოვანი ინსტრუმენტი ჩვენს არსენალში, რომელიც საშუალებას გვაძლევს ჩავატაროთ გამოკითხვები და შევაგროვოთ მონაცემები ინტერნეტში სპეციალიზებული პროგრამული უზრუნველყოფის გამოყენებით, რაც უზრუნველყოფს მონაცემთა ეფექტური და ზუსტი შეგროვებას ჩვენი კლიენტების ბაზრის კვლევის საჭიროებისთვის.',
  usage_attitude_50: 'САРІ',
  usage_attitude_51:
    'კომპიუტერის დახმარებით პირისპირ ინტერვიუ არის მეთოდი, რომელსაც ვიყენებთ მონაცემთა შეგროვების პროცესების გასამარტივებლად, ინტერვიუების გასამარტივებლად და თქვენი ბიზნესისთვის ზუსტი ინფორმაციის მიწოდებისთვის.',
  usage_attitude_52: 'Ფოკუს ჯგუფები',
  usage_attitude_53:
    'ფოკუს ჯგუფები არის დინამიური კვლევის სესიები, რომლებსაც ჩვენ ვატარებთ მონაწილეთა მრავალფეროვანი ჯგუფის გაერთიანებით კონკრეტულ თემებზე ან პროდუქტებზე სიღრმისეული დისკუსიისთვის, რაც საშუალებას გვაძლევს შევაგროვოთ ხარისხობრივი ინფორმაცია, გამოვავლინოთ დამოკიდებულებები, პრეფერენციები და აღქმები და გამოვიკვლიოთ იდეები და ცნებები, საბოლოო ჯამში ინფორმირება. ჩვენი კლიენტები გადაწყვეტილების მიღების პროცესებისა და სტრატეგიის შემუშავების შესახებ.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    'პირადი კომუნიკაცია ჩვენი მიდგომის განუყოფელი ნაწილია, რაც ხელს უწყობს კლიენტებთან და მომხმარებლებთან უშუალო ურთიერთქმედებას და პერსონალიზებულ კომუნიკაციას, რითაც ხელს უწყობს ნდობას, გაგებას და ეფექტურ კომუნიკაციას, რომელიც აუცილებელია ხანგრძლივი ურთიერთობების დასამყარებლად და ბიზნესის წარმატების ფოკუს ჯგუფების წარმართვისთვის',
  usage_attitude_56: 'ეთნოგრაფიული კვლევა',
  usage_attitude_57:
    'ადამიანებისა და კულტურების შესწავლა მათ ბუნებრივ გარემოში ჩაძირვისა და დაკვირვების გზით, რაც ხშირად იწვევს ქცევის, რწმენის და სოციალური დინამიკის ღრმა გაგებას.',
  parthership: 'პარტნიორობა',
  minimum_number_characters: 'მინიმალური რაოდენობა 2 სიმბოლო',
  request_details: 'მოითხოვეთ დეტალები',
  footer_7: 'ბაზრის კვლევა',
  main_43: 'ფოკუსირება ხარისხზე',
  main_44: 'ჩვენ ვაკონტროლებდით ხარისხს',
  main_45:
    'როცა საქმე კვლევის მონაცემებს ეხება. ჩვენ ყველა მონაცემთა კომპლექტს ვაწვდით კლიენტებს',
  main_46: 'ეკონომიურად ეფექტური',
  main_47: 'ჩვენი გამოცდილება, რესურსები და გამარტივებული',
  main_48: 'ბიზნეს პროცესები საშუალებას გვაძლევს დაზოგოთ ფული და დრო',
  main_49: 'ჭკვიანი გადაწყვეტილებები',
  main_50: 'ჩვენ ვიყენებთ სხვადასხვა ტექნიკას',
  main_51:
    'და ინსტრუმენტების ნაკრები თქვენი კონკრეტული პრობლემების გადასაჭრელად',
  menu_22: 'ობიექტის შემოწმების აუდიტი',
  menu_23: 'სერვისის დიზაინი',
  menu_24: 'CX',
  main_67:
    'კონკურენტული ფასების ანალიზი ოპტიმიზაციას უკეთებს შეთავაზებებს, ზრდის მოგებას და ზრდის ბაზრის წილს მომხმარებელთა გადახდის სურვილის მონაცემების გამოყენებით ძირითადი მახასიათებლების დასადგენად',
  main_68:
    'უზრუნველყოფს თქვენი საცალო მაღაზიების შესაბამისობას ბრენდის სტანდარტებთან, აფასებს ფიზიკურ ატრიბუტებს და მათ გავლენას მომხმარებელთა აღქმაზე',
  main_69: 'CX ხსნარი',
  main_70:
    'აღმოაჩინეთ ჩვენი უნიკალური 360-გრადუსიანი CX გადაწყვეტა: ჩვენ ვაფორმებთ ხელსაწყოებს და სერვისებს თქვენი მიზნების მიხედვით თქვენი ბიზნესის მართვისთვის',
  main_71: 'მეტყველების ანალიტიკა',
  main_72:
    'ჩვენი მოწინავე მეტყველების ანალიტიკის ხელსაწყო სალაპარაკო ენას ტექსტში გადააქვს, რაც უზრუნველყოფს ბიზნესისთვის ფასდაუდებელ შეხედულებებს, რათა გააუმჯობესონ მომხმარებელთა გამოცდილება, დააკვირდეს შესრულებას, უზრუნველყოს შესაბამისობა და გაზარდოს ზრდა',
  brand_awareness_1: 'ბრენდის ცნობადობა',
  brand_awareness_2: 'და გამოყენება',
  brand_awareness_3:
    'გახსენით თქვენი ბრენდის ცნობადობისა და გამოყენების პოტენციალი ბიზნესის წარმატებისთვის',
  brand_awareness_4: 'ესაუბრეთ ექსპერტს',
  brand_awareness_5: 'შესახებ',
  brand_awareness_6:
    '<b>შეაფასეთ ხარისხი დან</b> თქვენი ბრენდის აღიარება და გაცნობა',
  brand_awareness_7:
    '<b>განსაზღვრეთ ბრენდის დონე </b> ცნობადობა თქვენს სამიზნე ბაზარზე',
  brand_awareness_8:
    '<b>ყურადღებით დააკვირდით</b> შეკავებისა და ლოიალობის განაკვეთებზე',
  brand_awareness_9:
    '<b>აირჩიეთ ოპტიმალური სტრატეგია</b> საჭირო ინდიკატორების გასაუმჯობესებლად',
  brand_awareness_10:
    'გამოიკვლიეთ მრავალი შესაძლებლობა ჩვენი გადაწყვეტილებებით',
  brand_awareness_11: 'ბრენდის ცნობადობა',
  brand_awareness_12: 'ბრენდის გამოყენება',
  brand_awareness_13:
    '<b>აღმოაჩინეთ</b> თქვენი ბრენდის აღიარება სამომხმარებლო სეგმენტებს შორის',
  brand_awareness_14: '<b>მონიტორი</b> თქვენი აუდიტორიის ინფორმირებულობის დონე',
  brand_awareness_15:
    '<b>სწავლა</b> მომხმარებელთა სპონტანური აზრები შესყიდვის შესახებ',
  brand_awareness_16:
    '<b>გაიგე</b> ძირითადი წყაროები, რომლებიც ხელს უწყობენ თქვენი ბრენდის ცნობადობას',
  brand_awareness_17:
    '<b>განვიხილოთ</b> მომხმარებელთა რაოდენობა, რომლებიც განიცდიან თქვენი ბრენდის პროდუქტებსა თუ მომსახურებას',
  brand_awareness_18:
    '<b>იდენტიფიცირება</b> მომხმარებლები, რომლებიც დარჩნენ თქვენი ბრენდის თავიდან ცდის შემდეგ',
  brand_awareness_19: '<b>განბლოკვა</b> თქვენი ბრენდის რეკომენდაციის ალბათობა',
  brand_awareness_20:
    '<b>გამოაჩინე</b> მომხმარებელთა პროცენტი, რომლებიც განიხილავენ თქვენს ბრენდს მომავალი გამოყენებისთვის',
  brand_awareness_21: 'ვინ სარგებლობს ბრენდის ცნობადობისა და გამოყენებისგან?',
  brand_awareness_22: 'ბიზნესი იწყებს ახალ პროდუქტს',
  brand_awareness_23: 'ბიზნესი, რომელიც აცოცხლებს დამკვიდრებულ ბრენდს',
  brand_awareness_24:
    'ნებისმიერი ბიზნესი, რომელიც ცდილობს გაიგოს და გააძლიეროს, როგორ არის მათი ბრენდის აღიარება და გამოყენებული მომხმარებლების მიერ',
  brand_awareness_25:
    'ჩვენი მეთოდოლოგიები გთავაზობთ ღირებულ შეხედულებებს თქვენი ბრენდის ცნობადობისა და გამოყენების ოპტიმიზაციისთვის',
  brand_awareness_26:
    'მეთოდოლოგია ინდივიდუალურად შეირჩევა კლიენტის მოთხოვნის საფუძველზე',
  brand_awareness_27: 'ბრენდის გამოყენების ძაბრის მეთოდოლოგია',
  brand_awareness_28:
    'საცდელი განაკვეთი ასახავს აუდიტორიის პროპორციას, რომელმაც იცის ბრენდი და სცადა მისი პროდუქტები ან მომსახურება.',
  brand_awareness_29:
    'განმეორების მაჩვენებელი მიუთითებს აუდიტორიის პროცენტულ მაჩვენებელზე, რომელიც იცნობს ბრენდს და სცადა მისი პროდუქტები ან სერვისები, რომლებიც განაგრძობდნენ შესყიდვებს ან იყენებდნენ შეთავაზებებს ბოლო 12 თვის განმავლობაში.',
  brand_awareness_30:
    'შეკავების მაჩვენებელი ავლენს იმ პირთა პროპორციას, რომლებიც მუდმივად იყენებდნენ ბრენდის პროდუქტებს ან სერვისებს, რაც მიუთითებს პროცენტზე, რომელიც მონაწილეობდა ამ შეთავაზებებით ბოლო 6 თვის განმავლობაში.',
  brand_awareness_31:
    'შეკავების მაჩვენებელი ასახავს მომხმარებელთა პროცენტს, რომლებმაც გამოიყენეს ბრენდის პროდუქტები/მომსახურებები ბოლო 6 თვის განმავლობაში, აგრძელებენ არჩევანს და აჩვენებენ ბრენდისადმი ლოიალობას დროთა განმავლობაში.',
  brand_awareness_32: 'Brandawareness მეთოდოლოგია',
  brand_awareness_33:
    'Top of mind (TOM) წარმოადგენს რესპონდენტის მიერ სპონტანურად ნახსენებ პირველ ბრენდს.',
  brand_awareness_34:
    'მთლიანი სპონტანური ცნობიერება წარმოადგენს სპონტანური ხსენებების მთლიანობას, მათ შორის TOM-ს.',
  brand_awareness_35:
    'Aided Awareness ცხადყოფს, რამდენად კარგად არის თქვენი ბრენდის აღიარება მომხმარებლების მიერ მოთხოვნისას.',
  brand_awareness_36: 'ბრენდის ატრიბუტის შესრულების რუკა',
  brand_awareness_37:
    'ეს ინსტრუმენტი აფასებს და ვიზუალურად წარმოაჩენს სხვადასხვა ბრენდის ატრიბუტების მნიშვნელობას, იძლევა ხედვას იმის შესახებ, თუ როგორ უწყობს ხელს თითოეული თქვენი ბრენდის მთლიან შესრულებასა და მომხმარებლის აღქმას.',
  brand_awareness_38:
    'ჩვენი ყოვლისმომცველი ანალიზით აღმოაჩინეთ თქვენი ბრენდის გავლენის გაძლიერების გასაღები.',
  brand_awareness_39: 'ბრენდების აღქმის რუკა',
  brand_awareness_40:
    'ეს ინსტრუმენტი გთავაზობთ მომხმარებელთა აღქმის ვიზუალურ წარმოდგენას კონკურენტული ბაზრის ლანდშაფტში. ეს მიდგომა გადამწყვეტია ბრენდებს შორის განსხვავებების მკაფიოდ განსაზღვრისთვის, ბაზრის ძირითადი ატრიბუტების ხაზგასმით.',
  brand_awareness_41:
    'ის აუმჯობესებს ბრენდებსა და ამ განმსაზღვრელ მახასიათებლებს შორის ურთიერთობების დაკვირვებას და ინტერპრეტაციას.',
  brand_awareness_42:
    'კონკრეტული ბრენდის სიახლოვე გარკვეულ ატრიბუტებთან ნიშნავს მის ძლიერ კავშირს ამ მახასიათებლებთან. ანალოგიურად, ორ ბრენდს შორის სიახლოვე მიუთითებს მათ მსგავსებაზე, ასახავს საერთო სურათებს და, შესაბამისად, ბაზრის იმავე სეგმენტში კუთვნილებას.',
  consumer_journey_map_1: 'სამომხმარებლო მოგზაურობის რუკა',
  consumer_journey_map_2:
    'აღმოაჩინეთ და გადალახეთ ბარიერები თქვენს ბიზნესში ჩვენი სამომხმარებლო მოგზაურობის რუქით',
  consumer_journey_map_3: 'სანდო',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    'გახსენით CJM-ის პოტენციალი თქვენს მომხმარებლებსა და თქვენს ბრენდს შორის ურთიერთქმედების ოპტიმიზაციისთვის',
  consumer_journey_map_6:
    'განსაზღვრეთ რა ნაბიჯებს დგამს მომხმარებელი პროდუქტის შეძენამდე',
  consumer_journey_map_7:
    'მიიღეთ ინფორმაცია თქვენი რეალური მომხმარებლებისგან და არა წარმოსახვითი მომხმარებლებისგან',
  consumer_journey_map_8:
    'მიიღეთ ყოვლისმომცველი გაგება თქვენი მომხმარებლების გამოცდილების შესახებ',
  consumer_journey_map_9:
    'გამოტოვებული შესაძლებლობების იდენტიფიცირება და კონკურენტების წინაპირობა',
  consumer_journey_map_10: 'აღმოაჩინეთ ჩვენი CJM მიდგომა',
  consumer_journey_map_11:
    'ჩვენ ვქმნით მომხმარებელთა ურთიერთქმედების გზას პროდუქტთან, სერვისთან, კომპანიასთან ან ბრენდთან სხვადასხვა არხებით და გარკვეული პერიოდის განმავლობაში.',
  consumer_journey_map_12:
    'ჩვენ გამოვყოფთ ეტაპებს, რომლებსაც თქვენი მომხმარებლები ნავიგაციას უწევენ შესყიდვის დასრულებამდე, მომხმარებლის მოლოდინებს, ემოციებსა და მოტივაციას თითოეულ ეტაპზე.',
  consumer_journey_map_13: 'ისარგებლეთ ჩვენთან ერთად',
  consumer_journey_map_14:
    'ჩვენ გთავაზობთ გამოცდილი პროფესიონალების გუნდს, რომლებსაც ესმით გლობალური ბიზნესის წარმატების სირთულეები',
  consumer_journey_map_15:
    'ჩვენ მზად ვართ მივაღწიოთ შედეგებს, რომლებიც აღემატება თქვენს მოლოდინს',
  consumer_journey_map_16:
    'ჩვენ აღმოვაჩენთ კომპლექსურ გადაწყვეტილებებს, რომლებიც ხელს უწყობენ თქვენს ზრდას',
  consumer_journey_map_17:
    'ჩვენ სპეციალიზირებული ვართ მორგებული CJM გადაწყვეტილებების მიწოდებაში',
  consumer_journey_map_18: 'დაჯავშნეთ კონსულტაცია',
  consumer_journey_map_19: 'მონაცემებზე დაფუძნებული გადაწყვეტილებები',
  consumer_journey_map_20:
    'მიიღეთ გადაწყვეტილებები რეალურ მონაცემებზე დაყრდნობით, ვიდრე ვარაუდებზე',
  consumer_journey_map_21: 'ოპტიმიზაცია CJM-ის',
  consumer_journey_map_22:
    'დაამყარეთ ძლიერი ურთიერთობები მომხმარებლებთან მათი საჭიროებებისა და მოლოდინების გათვალისწინებით ყოველი ეტაპზე',
  consumer_journey_map_23: 'გასწირეთ გზა',
  consumer_journey_map_24:
    'შეადარეთ თქვენი ბიზნესი კონკურენტებთან და იყავით ბაზრის წინაშე',
  consumer_journey_map_25: 'რეკომენდაციები',
  consumer_journey_map_26:
    'ჩვენი CJM რეკომენდაციების დანერგვით გახსნით წარმატების კარს, განავითარებთ მომხმარებელთა ერთგულებას, გაზრდით გაყიდვებს და მაქსიმალურად გამოიყენებთ თქვენი ბიზნესის პოტენციალს',
  consumer_journey_map_27:
    'აღმოაჩინეთ ნამდვილი მომხმარებლის მოგზაურობა ჩვენი Consumer Journey Map-ის დახმარებით',
  consumer_journey_map_28:
    'ექსპერტები 20+ წლიანი გამოცდილებით უზრუნველყოფენ სრულფასოვან კვლევას',
  consumer_journey_map_29:
    'კვალიფიკაციური კვლევა მოიცავს არანუმერული მონაცემების შეგროვებას და ანალიზს, რათა გაიგოთ კონცეფციები, შეხედულებები ან გამოცდილებები.',
  consumer_journey_map_30:
    'კვანტიტატური კვლევის მეთოდები მოიცავს მონაცემების ობიექტურად გაზომვას და ანალიზს გამოკითხვების, კითხვარების და სერვეების მეშვეობით.',
  consumer_journey_map_31:
    'მონაცემების შეგროვების შემდეგ, ექსპერტები ანალიზებენ ინფორმაციას და გთავაზობენ საუკეთესო რეკომენდაციებს.',
  boarding_1: 'მომხმარებლის მოგზაურობის რუკა',
  boarding_2:
    'მომხმარებლის მოგზაურობის რუკა (CJM) ეხება მიზნობრივი აუდიტორიის განსაზღვრას, მათი საჭიროებებისა და გარემოს გაგებას და შემდეგ გეგმის შექმნას, რათა მივაწოდოთ მათ საინტერესო გამოცდილება',
  boarding_3: 'Net Promoter Score',
  boarding_4:
    'Net Promoter Score (NPS) არის მომხმარებლის გამოცდილების შეფასების ოქროს სტანდარტი, დაფუძნებული ერთ კითხვაზე: რამდენად მზად ხართ ურჩიოთ ორგანიზაცია/პროდუქტი/მომსახურება?',
  boarding_5: 'ბრენდის ჯანმრთელობის მონიტორინგი',
  boarding_6:
    'ბრენდის ჯანმრთელობის მონიტორინგი (BHT) კვლევა ზომავს, თუ როგორ ასრულებს თქვენი ბრენდი ცნობადობის, გამოყენების, ბრენდის პოზიციონირებისა და შესრულების მიხედვით',
  boarding_7: 'ადამიანური რესურსების კვლევა',
  boarding_8:
    'ადამიანური რესურსების კვლევა გამოიყენება HR პრაქტიკებისა და შესრულების შესაფასებლად და დეტალური ანალიზის გაკეთებისთვის არსებული განვითარების და მართვის შესახებ',
  boarding_9: 'UX ტესტირება',
  boarding_10:
    'გამოყენებადობის (UX) ტესტირება ამოწმებს, თუ როგორ ურთიერთობენ რეალური ადამიანები ვებგვერდთან, აპლიკაციასთან ან სხვა პროდუქტთან და აკვირდება მათ ქცევას და რეაქციებს',
  boarding_11: 'მომხმარებლის კმაყოფილების ინდექსი',
  boarding_12:
    'მომხმარებლის კმაყოფილება ზომავს, თუ რამდენად დაკმაყოფილდა მომხმარებლის მოლოდინები კომპანიის მიერ მიწოდებული პროდუქტის ან მომსახურების შესახებ',
  boarding_13: 'რეკლამის ტესტირება',
  boarding_14:
    'რეკლამების კამპანია დიდი ინვესტიციაა. დარწმუნდით, რომ თქვენი რეკლამები მძლავრია და მაქსიმალური ROI-ს მოაქვს',
  boarding_15: 'მინდვრის/სავაჭრო აუდიტი',
  boarding_16:
    'შეაგროვეთ დეტალური მონაცემები თქვენი მაღაზიის ან ბრენდის შესახებ, გაანალიზეთ ზრდის ბარიერები და შექმენით ეფექტური სტრატეგიები მათი დაძლევისათვის',
  boarding_17: 'Play4Sales',
  boarding_18:
    'შესრულების მართვის პროგრამული უზრუნველყოფა. გაყიდვების გასაზრდელი გეიმიფიცირებული აპლიკაცია',
  boarding_19: 'Voicer',
  boarding_20:
    'უკუკავშირის მართვის სისტემა. თქვენი მომხმარებლის ხმა ერთ სისტემაში. მომხმარებლის უკუკავშირის მართვის სისტემა',
  boarding_21: 'კვალიფიკაციური კვლევა',
  boarding_22:
    'კვალიფიკაციური კვლევა არანუმერული მონაცემების შეგროვებასა და ანალიზს მოიცავს კონცეფციების, შეხედულებების ან გამოცდილებების გასაგებად',
  boarding_23: 'კვანტიტატური კვლევა',
  boarding_24:
    'კვანტიტატური კვლევის მეთოდები მოიცავს ობიექტური გაზომვას და მონაცემების ნუმერულ ანალიზს გამოკითხვების, კითხვარების და სერვეების საშუალებით',
  boarding_25: 'საიდუმლო შეძენა',
  boarding_26:
    'საიდუმლო შეძენა არის მარკეტინგული კვლევის ტექნიკა, რომელიც ზომავს და აკვირდება მომხმარებელსა და კომპანიას შორის ურთიერთქმედებას წინასწარ განსაზღვრულ სცენარში',
  boarding_27: 'Wantent',
  boarding_28:
    'AI-ზე დაფუძნებული კონტენტის ინტელექტის პლატფორმა, რომელიც უზრუნველყოფს აუდიტორიის შეხედულებებს',
  boarding_29: 'ფასების მონიტორინგი',
  boarding_30:
    'ფასების მონიტორინგი არის კონკურენტების ფასების შეგროვების, დამუშავების და ანალიზის პროცესი',
  boarding_31: 'მომსახურების დიზაინი',
  boarding_32:
    'მომსახურების დიზაინი არის იმის გაგება, თუ რა სურთ და სჭირდებათ იმ ადამიანებს, რომლებიც გამოიყენებენ პროდუქტს ან მომსახურებას, მათთან დროის გატარებით',
  boarding_33: 'ავტომობილის ინდუსტრიის ფასების ანალიზი',
  boarding_34:
    'კონკურენტული ფასების ანალიზი ოპტიმიზირებს შეთავაზებებს, ზრდის მოგებას და აძლიერებს ბაზრის წილს მომხმარებლის მზაობაზე დაფუძნებული მონაცემებით, რაც მნიშვნელოვან მახასიათებლებს ავლენს',
  boarding_35: 'სავაჭრო ობიექტის აუდიტი',
  boarding_36:
    'უზრუნველყოფს, რომ თქვენი სავაჭრო ობიექტები შეესაბამება ბრენდის სტანდარტებს, აფასებს ფიზიკურ ატრიბუტებს და მათ გავლენას მომხმარებლის აღქმაზე',
  boarding_37: 'CX გადაწყვეტილება',
  boarding_38:
    'აღმოაჩინეთ ჩვენი უნიკალური 360 გრადუსიანი CX გადაწყვეტილება: ჩვენ ვადაპტირებთ ინსტრუმენტებსა და მომსახურებებს თქვენი ბიზნესის საჭიროებების შესაბამისად',
  boarding_39: 'საუბრის ანალიზი',
  boarding_40:
    'ჩვენი მოწინავე საუბრის ანალიზის ინსტრუმენტი აქცევს სასაუბრო ენას ტექსტად, რაც ბიზნესს აძლევს ფასდაუდებელ შეხედულებებს მომხმარებლის გამოცდილების გასაუმჯობესებლად, შესრულების მონიტორინგისთვის, შესაბამისობის უზრუნველსაყოფად და ზრდის ხელშეწყობისთვის',
  boarding_41: 'გამოყენება და დამოკიდებულება',
  boarding_42:
    'გამოყენება და დამოკიდებულება არის ჩვენი მიდგომა, რომელიც მოიცავს იმაში გაგებას, თუ როგორ ურთიერთობენ აუდიტორიები თქვენს ბრენდთან, გამოყენების პრაქტიკული ნიმუშების და ფსიქოლოგიური დამოკიდებულებების ანალიზის გზით, რაც მარკეტინგული და პროდუქტის სტრატეგიების მორგებას იძლევა',
  boarding_43: 'ბრენდის ცნობადობა და გამოყენება',
  boarding_44:
    'ბრენდის ცნობადობა და გამოყენება მოიცავს მიზნობრივი ბაზრის ფარგლებში აღიარების, ნაცნობობის, ურთიერთობის სიხშირის და შენარჩუნების შეფასებას, ბრენდის ხილვადობის და ჩართულობის გასაზრდელად',
  boarding_45: 'ბრენდის იდენტობა და პოზიციონირება',
  boarding_46:
    'ბრენდის იდენტობა და პოზიციონირება მოიცავს ყოვლისმომცველ ანალიზს, რომელიც ავლენს მომხმარებლის აღქმებს, აუდიტორიის მრავალფეროვან შეხედულებებს და იმაში, თუ როგორ აღიქმება თქვენი ბრენდი',
  boarding_47: 'მომხმარებლის პროფილირება და სეგმენტაცია',
  boarding_48:
    'მომხმარებლის პროფილირება და სეგმენტაცია მოიცავს მიზნობრივი ბაზრის დაყოფას სხვადასხვა ჯგუფად საერთო მახასიათებლების მიხედვით, რაც შესაძლებლობას იძლევა შეიქმნას პერსონალიზებული სტრატეგიები, რომლებიც შეესაბამება კონკრეტულ აუდიტორიის სეგმენტებს',
  boarding_49: 'მომხმარებლის მოგზაურობის რუკა',
  boarding_50:
    'მომხმარებლის მოგზაურობის რუკა არის ვიზუალური წარმოდგენა ეტაპების, შეხების წერტილების, ემოციებისა და მოტივაციების შესახებ, რომლებიც მომხმარებელს აქვს თქვენი პროდუქტის ან ბრენდის მიმართ ურთიერთქმედების პროცესში',
  boarding_51:
    'შეისწავლეთ ინოვაციური ტექნიკები, რომლებიც გთავაზობენ ქმედითი შეხედულებების მიღებას და გავლენიანი შედეგების მიღწევას თქვენი ბიზნესისთვის',
  boarding_52:
    'შეისწავლეთ ჩვენი პროდუქტის კომპლექტი მონაცემებზე დაფუძნებული ინტელექტით, რომელიც მორგებულია თქვენს ინდუსტრიაზე, რაც საშუალებას გაძლევთ მიიღოთ ინფორმირებული გადაწყვეტილებები და დარჩეთ ბაზარზე პირველ ადგილას',
  boarding_53:
    'მოიცავს ბაზრის ტენდენციებში, მომხმარებლის ქცევაში და კონკურენტულ ლანდშაფტებში ღრმა ჩაღრმავებას ჩვენი ყოვლისმომცველი ბაზრის კვლევითი გადაწყვეტილებებით',
  boarding_54: 'Ad Hoc კვლევა',
  boarding_55:
    'Ad Hoc კვლევა არის პერსონალიზებული მიდგომა, რომელიც შექმნილია კონკრეტული პრობლემის გადასაჭრელად, არსებული მეთოდოლოგიების შერწყმით ან ახალი მიდგომით უნიკალური გადაწყვეტის შესაქმნელად',
  boarding_56: 'სოციოლოგიური კვლევა',
  boarding_57:
    'სოციოლოგიური კვლევა იკვლევს ადამიანის ქცევისა და სოციალური ურთიერთქმედებების ნიმუშებს, რაც უზრუნველყოფს ფასდაუდებელ შეხედულებებს ინოვაციური სტრატეგიების გასაუმჯობესებლად და სამიზნე აუდიტორიებთან მნიშვნელოვან კავშირების შესაქმნელად',
  not_found_1: 'უი! ჩვენ ვერ ვპოულობთ ამ გვერდს',
  not_found_2: 'რატომ არ შეამოწმეთ ჩვენი პროდუქცია?',
  not_found_3: 'განვიხილოთ საკონსულტაციო',
  customer_profiling_segmentation_1: 'კლიენტის პროფილების და სექტრაციის შექმნა',
  customer_profiling_segmentation_2:
    'ჩვენ დაგეხმარებით თქვენი სამიზნე აუდიტორიის განსაზღვრაში, რაც თქვენს სტრატეგიას უფრო ეფექტურს გახდის',
  customer_profiling_segmentation_3:
    'ბაზრის სექტრაციის ძალის გამოყენება თქვენი მესიჯების ყოველთვის სწორ სამიზნე მომხმარებელ ჯგუფებზე გადასატანად',
  customer_profiling_segmentation_4: 'მომხმარებლების უფრო ღრმა გაგება',
  customer_profiling_segmentation_5:
    'შეიძინეთ თქვენი პროდუქტის საუკეთესო სამიზნე აუდიტორია',
  customer_profiling_segmentation_6: 'ახალი სექტრების შესწავლა',
  customer_profiling_segmentation_7: 'შეიძინების ბარიერების აღმოჩენა',
  customer_profiling_segmentation_8:
    'ჩვენ ვსპეციალობით მორგებული სექტრაციის გადაწყვეტილებების მიწოდებაში',
  customer_profiling_segmentation_9: 'უნიკალური მიდგომა',
  customer_profiling_segmentation_10:
    'გამოიცადეთ უნიკალური, მორგებული სექტრაციის გადაწყვეტილება, რომელიც სპეციალურად თქვენი საჭიროებისთვის არის შექმნილი',
  customer_profiling_segmentation_11: 'სამიზნე პერსონები',
  customer_profiling_segmentation_12:
    'გაფართოებული ბაზრის ანალიზზე დაფუძნებული სამიზნე პერსონების შექმნა',
  customer_profiling_segmentation_13: 'ახალი სექტრები',
  customer_profiling_segmentation_14:
    'აღმოაჩინეთ თქვენი ყველაზე ფასეული აუდიტორია სექტრები და გააღვივეთ მორგებული მიზნობრივი მარკეტინგის სარგებელი',
  customer_profiling_segmentation_15: 'რეკომენდაციები',
  customer_profiling_segmentation_16:
    'განახორციელეთ ჩვენი რეკომენდაციები და გახსენით წარმატება, მოითხოვეთ მომხმარებელთა ერთგულება, გაზარდეთ გაყიდვები და მაქსიმალურად მოიმატეთ თქვენი ბიზნესის პოტენციალი',
  customer_profiling_segmentation_17:
    '20+ წლიანი გამოცდილების მქონე ექსპერტები აწვდიან კომპლექსურ კვლევას',
  customer_profiling_segmentation_18:
    'კვალიფიციური კვლევა მოიცავს არანუმერალური მონაცემების შეგროვებას და ანალიზს კონცეფციების, მოსაზრებების ან გამოცდილების გასაზიარებლად.',
  customer_profiling_segmentation_19:
    'კვანტიტატიური კვლევის მეთოდები გულისხმობს მონაცემების ობიექტური გაზომვისა და ნომინალური ანალიზის განხორციელებას გამოკითხვების, კითხვარების და სარეკლამო გამოკითხვების მეშვეობით.',
  customer_profiling_segmentation_20:
    'მონაცემების შეგროვების შემდეგ, ექსპერტები ანალიზის ჩატარებას და დასკვნების გამოტანას ახდენენ, რათა მოგაწვდონ საუკეთესო რეკომენდაციები.',
  customer_profiling_segmentation_21:
    'ჩვენ უბრალოდ არ ვზომავთ, არამედ გაწვდავთ მოქმედების გეგმას კონკრეტული ნაბიჯ-ნაბიჯ მოქმედებებით',
  customer_profiling_segmentation_22: 'ჩვენი მეთოდოლოგია',
  customer_profiling_segmentation_23: 'ჯაკარდის ინდექსი',
  customer_profiling_segmentation_24:
    'როდესაც გამოკითხულები პირდაპირ ჰკითხავენ, მათი პასუხები კომპანიის არჩევანს შეიძლება არ შეესაბამებოდეს მათი რეალური ქცევების. პირდაპირი კითხვების ნაცვლად, ჩვენ ვიყენებთ სტატისტიკურ ჯაკარდის ანალიზს, რათა გავიგოთ კომპანიების თვისებების და მომხმარებლის არჩევანის შორის ურთიერთობა.',
  customer_profiling_segmentation_25: 'დამნერგვები',
  customer_profiling_segmentation_26:
    'ჩვენ ვასახელებთ დამნერგებებს (ფაქტორებს, რომლებიც გავლენას ახდენენ კონკრეტულ შედეგზე) და ვკატეგორიზებთ მათ ძირითადი, საშუალო და უმნიშვნელო დამნერგვებით მათი მნიშვნელობის მიხედვით.',
  customer_profiling_segmentation_27: 'სექტრაცია',
  customer_profiling_segmentation_28:
    'თქვენ მიიღებთ სექტრაციას მომხმარებლის არჩევანის მკაფიო მახასიათებლებით.',
  customer_profiling_segmentation_29: 'ჩვენი მიდგომა სექტრაციისთვის',
  customer_profiling_segmentation_30: 'დემოგრაფიული',
  customer_profiling_segmentation_31: 'ასაკი',
  customer_profiling_segmentation_32: 'სქესი',
  customer_profiling_segmentation_33: 'შემოსავლები',
  customer_profiling_segmentation_34:
    'ეს ეხმარება პროდუქტის, მომსახურების და მარკეტინგის მორგებას კონკრეტული ჯგუფების მიხედვით, რაც გააუმჯობესებს რელევანტობას და ეფექტურობას',
  customer_profiling_segmentation_35: 'ფსიქოგრაფიული',
  customer_profiling_segmentation_36: 'ცხოვრების წესი',
  customer_profiling_segmentation_37: 'ფასეულობები',
  customer_profiling_segmentation_38: 'ქცევები',
  customer_profiling_segmentation_39:
    'ეს შესაძლებელს ხდის პირადი მარკეტინგისთვის, უფრო ღრმა კავშირების დამყარებისთვის მომხმარებლებთან და კომპანიას გაზრდილი ერთგულებისა და გაყიდვებისთვის',
  customer_profiling_segmentation_40: 'ქცევითი',
  customer_profiling_segmentation_41: 'მოქმედებები',
  customer_profiling_segmentation_42: 'მოტივაცია',
  customer_profiling_segmentation_43: 'ყიდვის სიხშირე',
  customer_profiling_segmentation_44:
    'ეს საშუალებას იძლევა მიზნობრივი მარკეტინგისთვის, გაზრდილი მომხმარებლის დაკმაყოფილებისა და კომპანიას გაზრდილი შენარჩუნებისა და გამართული სარგებელი',
  customer_profiling_segmentation_45: 'გეოგრაფიული',
  customer_profiling_segmentation_46: 'ლოკაცია',
  customer_profiling_segmentation_47:
    'ეს საშუალებას იძლევა მიზნობრივი მარკეტინგისთვის, მორგებული პროდუქტებისთვის, ეფექტური დისტრიბუციისთვის და გაზრდილი ბაზრის გასაზრდელად.',
  brands_identity_1: 'ბრენდის იდენტობა და პოზიციონირება',
  brands_identity_2:
    'გაახლებეთ თქვენი ბრენდი ჩვენი ღრმა ანალიზით, რომელიც მოიცავს მომხმარებლის აზრების გამოკვლევას და თქვენი სტრატეგიის დახვეწას წარმატებისთვის',
  brands_identity_3: 'გაუთვალისწინეთ ექსპერტი',
  brands_identity_4: '<b>აღმოაჩინეთ სრული</b> ბრენდის იდენტობის ანალიზი',
  brands_identity_5:
    '<b>შეისწავლეთ ინფორმაცია</b>, რომელიც მიღებულია მომხმარებლის აზრებზე',
  brands_identity_6: '<b>გაგება სხვადასხვა</b> სამიზნე აუდიტორიის შეხედულებები',
  brands_identity_7:
    '<b>მოიპოვეთ ინფორმაცია</b> მომხმარებლის ქცევის, ჩვევებისა და პრეფერენციების შესახებ ინფორმირებული გადაწყვეტილების მისაღებად',
  brands_identity_8:
    '4Service-ის ექსპერტები, რომლებიც 20 წელზე მეტი კლიენტების გამოცდილების მქონე, ქმნიან უნიკალურ გადაწყვეტილებებს, რომლებიც ხელს უწყობენ თქვენს ბიზნესის ზრდას',
  brands_identity_9:
    '<b>თქვენ ექნება ხელმისაწვდომობა კვლევის პაკეტზე, რომელიც შეიცავს ყველა აუცილებელ მონაცემს.</b> ეს გამოყენების ინსტრუმენტია, რომელიც ხაზს უსვამს სიძლიერის და ყურადღების საჭიროების ადგილებს',
  brands_identity_10:
    '<b>ჩვენი სერვისები იძლევა ბიზნესებს საჭირო ინსტრუმენტებს</b> ინფორმირებული გადაწყვეტილებების მისაღებად, სტრატეგიების დახვეწისთვის და წარმატებისთვის მათი ინდუსტრიების ჩათვლით.',
  brands_identity_11: 'თქვენი ბრენდის პოზიციის გაზრდისთვის კონკურენტულ ბაზარზე',
  brands_identity_12:
    'ბიზნესები, რომლებიც ცდილობენ გაზარდონ მათი ბაზრის წარმოება',
  brands_identity_13:
    'ბიზნესები, რომლებიც ცდილობენ გაზარდონ თავიანთ სტრატეგიებს',
  brands_identity_14: 'ბრენდის იდენტობა',
  brands_identity_15: 'ბრენდის პოზიციონირება',
  brands_identity_16:
    '<b>აღმოაჩინეთ თქვენი ბრენდის</b> აღქმა მომხმარებლის სეგმენტებში.',
  brands_identity_17:
    '<b>შეისწავლეთ თვისებები</b>, რომლებიც თქვენს ბრენდს და კონკურენტებს უკავშირდება.',
  brands_identity_18:
    '<b>შეაფასეთ სიძლიერეები</b> და სუსტი მხარეები სტრატეგიული გაუმჯობესებისთვის.',
  brands_identity_19:
    '<b>შეაფასეთ ბრენდის იმიჯის</b> შესაბამისობა წამოწვდილი ღირებულებების მიმართ.',
  brands_identity_20: '<b>შეაფასეთ აღქმული</b> ნდობა თქვენი ბრენდის.',
  brands_identity_21:
    '<b>შეისწავლეთ არქეტიპული</b> და სიმბოლური აღქმა თქვენი ბრენდის.',
  brands_identity_22:
    '<b>შეისწავლეთ თქვენი ბრენდის</b> უნიკალური გაყიდვის წერტილები და განსხვავებები კონკურენტებთან შედარებით.',
  brands_identity_23:
    '<b>შეისწავლეთ ძირითადი მახასიათებლები, რომლებიც გავლენას ახდენენ</b> მომხმარებლის პროდუქტის/მომსახურების შეძენის ალბათობაზე.',
  brands_identity_24:
    '<b>გაირკვიოს როგორ არის თქვენი ბრენდი ამჟამად პოზიციონირებული</b> მომხმარებელთა გონებაში და გამოავლინეთ ასპექტები, რომლებიც უნდა კომუნიკირდეს სასურველი ბაზრის სეგმენტების მისაღწევად.',
  brands_identity_25:
    'მეთოდოლოგია ინდივიდუალურად შერჩეულია კლიენტის მოთხოვნის საფუძველზე.',
  brands_identity_26: 'ბრენდის ცნობადობა და გამოყენება',
  brands_identity_27:
    'ბრენდის დონეს შეფასება მოიცავს ცნობადობის და მოხმარების დონეების გაზომვას, რაც შეფასების ძირითადი კომპონენტია.',
  brands_identity_28: 'ბრენდის მიწოდება და ნდობა',
  brands_identity_30: 'ბრენდის იმიჯის შესრულება',
  brands_identity_31:
    'ბრენდის შესრულების შეფასება მოიცავს მისი ასოცირების შეფასებას ექვს მნიშვნელოვან ღირებულებასთან (3 რაციონალური და 3 ემოციური), კატეგორიაში მისი გამორჩეულობის შეფასებას და მომხმარებლებში orgullo-ს გაჩენას.',
  brands_identity_32: 'ბრენდის ჯანმრთელობის ქულა',
  brands_identity_33:
    'ბრენდის ჯანმრთელობის ქულა გაწვდავს სრულყოფილ გაგებას იმაზე, როგორ მუშაობს თქვენი ბრენდი კონკურენტულ გარემოში.',
  sociological_research_1: 'სოციოლოგიური კვლევები',
  sociological_research_2:
    'ჩვენ ვატარებთ სიღრმისეულ ანალიზს საზოგადოებრივი მოვლენებისა და პროცესების, რაც ხელს უწყობს გაცნობიერებულ გადაწყვეტილებების მიღებას უნიკალური ანალიტიკური დასკვნებისა და რეკომენდაციების მეშვეობით',
  sociological_research_3: 'დაგვიკავშირდით',
  sociological_research_4: 'ჩვენი კლიენტები',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI არის მონაცემთა შეგროვების მეთოდი, რომელშიც ტელეფონით გამოკითხვებისთვის გამოიყენება კომპიუტერი. CATI პროგრამული უზრუნველყოფა ავტომატიზირებს მონაცემთა შეგროვების, პასუხების შეყვანისა და გამოკითხვის მართვის პროცესს. CATI-ის გამოყენება ამარტივებს გამოკითხვის კონტროლს, სწრაფად აანალიზებს და ამუშავებს მიღებულ მონაცემებს და უზრუნველყოფს გამოკითხვის მაღალი დონის სტანდარტიზაციას.',
  sociological_research_7: 'СATI',
  sociological_research_8:
    'CAWI არის მონაცემთა შეგროვების მეთოდი, რომელშიც რესპონდენტები ავსებენ გამოკითხვის კითხვარებს ან პასუხობენ კითხვებს ვებ-ინტერფეისის მეშვეობით და მონაცემები ავტომატურად იკრიბება და მუშავდება სპეციალიზებული პროგრამული უზრუნველყოფის მეშვეობით. CAWI მეთოდი საშუალებას იძლევა ჩატარდეს მასშტაბური გამოკითხვები, სწრაფად შეგროვდეს და გაანალიზდეს მონაცემები.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI არის პირისპირ გამოკითხვის მონაცემთა შეგროვების მეთოდი, რომელშიც მკვლევარი იყენებს ტაბლეტს ან მობილურ ტელეფონს რესპონდენტების პასუხების შესაყვანად, რაც საშუალებას აძლევს მონაცემთა შეგროვების ავტომატიზაციას, ამცირებს შეყვანის შეცდომებს და აადვილებს შედეგების ანალიზს.',
  sociological_research_11:
    'ჩვენი ექსპერტები იყენებენ სხვადასხვა ინსტრუმენტებს',
  sociological_research_12: 'შერჩევა',
  sociological_research_13:
    'ჩვენ ვანგარიშობთ და ვიყენებთ ნებისმიერი სირთულის შერჩევას',
  sociological_research_14:
    'ჩვენ ვიყენებთ მარტივ, სისტემატიზირებულ, სტრატიფიცირებულ და კლასტერულ შერჩევას',
  sociological_research_15:
    'ეროვნული რეპრეზენტატიული პირისპირ კვლევებისთვის ვიყენებთ სტრატიფიცირებული მრავალსაფეხურიანი შერჩევის პროცედურებს',
  sociological_research_16:
    'რეგიონების მიხედვით დასახლებული პუნქტების შერჩევა ხორციელდება მათი ზომისა და ტიპის შესაბამისად, მათი რაოდენობა განისაზღვრება თითოეული რეგიონის მოცულობის პროპორციულად',
  sociological_research_17: 'ჩვენ ვატარებთ',
  sociological_research_18: 'საზოგადოებრივი აზრის კვლევები',
  sociological_research_19: 'სოციალურ-ეკონომიკური კვლევები',
  sociological_research_20: 'საოფისე კვლევა',
  sociological_research_21: 'სოციალური სერვისების ხარისხის შეფასება',
  sociological_research_22: 'განსაკუთრებული შემთხვევის კვლევა',
  sociological_research_23: 'პერსონალის კვლევა',
  sociological_research_24:
    'სპეციფიკური აუდიტორიების კვლევა (მგრძნობიარე ჯგუფები, მათ შორის შიდა იძულებით გადაადგილებული პირები, სამხედროები, ახალგაზრდობა და ა.შ.)',
  sociological_research_25: 'ჩვენ ვმუშაობთ თითოეულ კლიენტთან ინდივიდუალურად',
  sociological_research_26: 'ჩვენი კლიენტები:',
  sociological_research_27: 'სადმეურნეო ფონდები',
  sociological_research_28: 'საზოგადოებრივი ორგანიზაციები და გაერთიანებები',
  sociological_research_29: 'სახელმწიფო სტრუქტურები',
  sociological_research_30: 'ჩვენი მიდგომა მუშაობისადმი',
  sociological_research_31:
    'ჩვენ ვიყენებთ მეცნიერულ მიდგომას მუშაობაში და ღრმა გაგებას არსებული რეალობისა, ასევე მრავალფეროვან კვლევის მეთოდებს მონაცემთა შეგროვებისთვის.',
  sociological_research_32:
    'ჩვენ ვიწვევთ ვიწროდ სპეციალიზირებულ ექსპერტებს შესაბამისი გამოცდილებით კონკრეტული მოთხოვნის გადასაჭრელად და გვყავს ექსპერტების გუნდი სხვადასხვა მიმართულებებში.',
  sociological_research_33:
    'ჩვენი საკუთარი ანალიტიკური განყოფილება აანალიზებს შეგროვებულ მონაცემებს, იყენებს უნიკალური ინსტრუმენტების კომპლექტს დავალების სპეციფიკის შესაბამისად.',
  sociological_research_34:
    'ჩვენ ვამზადებთ ანგარიშებს დეტალური დასკვნებით და რეკომენდაციებით, რომლებიც ითვალისწინებს თქვენი სამიზნე აუდიტორიის მოთხოვნებსა და მოლოდინებს.',
  sociological_research_35:
    'ჩვენ ვუწევთ კონსულტაციებს და მხარდაჭერას რეკომენდაციების განხორციელებისას, რაც გეხმარებათ დადებითი ცვლილებების განხორციელებაში.',
  sociological_research_36: 'ჩვენი კვლევები ტელევიზიაში',
  sociological_research_37: 'გაეცანით ჩვენს ანგარიშებს',
  sociological_research_38:
    'ჩვენი მეცნიერული მიდგომა მუშაობაში უზრუნველყოფს ჩვენს დამკვეთებს ზუსტი და სანდო სოციალური მონაცემებით მთელ უკრაინასა და ევროპაში მინიმალური ცდომილების დონის მიღწევით',
  sociological_research_39:
    'ჩვენ ვმუშაობთ სოციალური კვლევების პრინციპებისა და ეთიკის ყველა სტანდარტის დაცვით.',
  sociological_research_40:
    'ჩვენ ვიცავთ უკრაინის სოციოლოგთა ასოციაციის პროფესიული ეთიკის კოდექსსა და ჰელსინკის დეკლარაციის ეთიკურ პრინციპებს კვლევების ჩასატარებლად. ESOMAR-ის წევრები, უკრაინის მარკეტინგის ასოციაციის წევრები, უკრაინის საკონტაქტო ცენტრების ასოციაციის წევრები.',
  sociological_research_41: 'საველე სამუშაოები',
  sociological_research_42: 'ონლაინ პანელი',
  sociological_research_43: 'პერმანენტული ინტერვიუერები',
  sociological_research_44: 'სუპერვაიზერები',
  sociological_research_45: 'საველე სამუშაოების ხარისხის კონტროლი',
  sociological_research_46: 'GPS კოორდინატების 100% -იანი ფიქსაცია (CAPI)',
  sociological_research_47: 'კითხვარების ვალიდაცია (CAWI, CAPI, CATI, PAPI)',
  sociological_research_48: 'ინტერვიუების 100% ჩაწერა (CAPI, CATI)',
  sociological_research_49:
    'ჩვენ ვიყენებთ ლიცენზირებულ პროგრამულ უზრუნველყოფას:',
  sociological_research_50:
    'SPSS სტატისტიკური მონაცემების ანალიზისთვის, მონაცემთა ნაკრებების დამუშავება',
  sociological_research_51:
    'DigSee Sure CAPI-სთვის: კითხვარის ლოგიკა, გეოლოკაცია, ინტერვიუების აუდიოჩანაწერი, ვიდეომასალების ჩვენება',
  sociological_research_52:
    'SurveyMonkey CAWI-სთვის: კითხვარის ლოგიკა, მოსახერხებელი ფორმატი, ვიზუალიზაცია',
  sociological_research_53:
    'VoIPTime (საკონტაქტო ცენტრი): ნებისმიერი სირთულის კითხვარის პროგრამირება, აუდიოჩანაწერების გადაცემა დამკვეთს',
  sociological_research_54: 'შერჩევა',
  sociological_research_55:
    'ჩვენ ვანგარიშობთ და ვიყენებთ ნებისმიერი სირთულის შერჩევას',
  sociological_research_56:
    'ჩვენ ვიყენებთ მარტივ, სისტემატიზირებულ, სტრატიფიცირებულ და კლასტერულ შერჩევას',
  sociological_research_57:
    'ეროვნული რეპრეზენტატიული პირისპირ კვლევებისთვის ვიყენებთ სტრატიფიცირებული მრავალსაფეხურიანი შერჩევის პროცედურებს',
  sociological_research_58:
    'რეგიონების მიხედვით დასახლებული პუნქტების შერჩევა ხორციელდება მათი ზომისა და ტიპის შესაბამისად, მათი რაოდენობა განისაზღვრება თითოეული რეგიონის მოცულობის პროპორციულად',
  sociological_research_59: 'გუნდი',
  sociological_research_60:
    'ჩვენი სოციოლოგები უკრაინის სოციოლოგთა ასოციაციის წევრები არიან',
  sociological_research_61:
    'ჩვენ გვყავს 12 შტატიანი ანალიტიკოსი, რომლებსაც აქვთ გამოცდილება როგორც რაოდენობრივ, ასევე ხარისხობრივ პროექტებში სხვადასხვა დარგებში.',
  sociological_research_62:
    'ჩვენი ძლიერი ანალიტიკური გუნდი მოიცავს 10 წელზე მეტი ხნის გამოცდილების მქონე პროფესიონალ სპეციალისტებს. ჩვენ გვყავს მეცნიერები, მეცნიერებათა კანდიდატები, MBI.',
  sociological_research_63: "Iryna Maksym'yuk",
  sociological_research_64:
    'კვლევის დეპარტამენტის უფროსი. 15 წელზე მეტი გამოცდილება მარკეტინგულ კვლევაში, კვლევის მენეჯმენტში ყველა ეტაპზე, ანალიტიკური ანგარიშების მომზადება, პრეზენტაციების ჩატარება',
  sociological_research_65: 'Andriy Biloskurskyi',
  sociological_research_66:
    'პროგრამირებისა და მონაცემთა დამუშავების განყოფილების უფროსი. მარკეტინგის, სოციოლოგიური და მარკეტინგული კვლევების 20 წლიანი გამოცდილება',
  sociological_research_67: 'Olena Somova',
  sociological_research_68:
    'პროგრამირების სპეციალისტი, დონსუუს სოციოლოგიის ასპირანტურა. 5 წლიანი მუშაობა მარკეტინგულ კვლევაში ქალთა დემოკრატიული ალიანსის გამგეობის წევრი, ფონდების მოზიდვის დეპარტამენტის ხელმძღვანელი.',
  sociological_research_69: 'Anna Padalka',
  sociological_research_70:
    'კვლევითი დეპარტამენტის სოციოლოგიური კვლევის დეპარტამენტის ხელმძღვანელი, აქვს საერთაშორისო და ეროვნულ დონეზე სოციოლოგიურ და სოციალურ პროექტებთან მუშაობის 13 წლიანი გამოცდილება.  სოციოლოგიურ მეცნიერებათა კანდიდატი, უკრაინის საკონტაქტო ცენტრების სრულიად უკრაინული ასოციაციის კვლევითი კომიტეტის ხელმძღვანელი.',
  ad_hoc_1: 'ად ჰოკი',
  ad_hoc_2: 'აღმოაჩინეთ ჩვენი ალტერნატიული კვლევა უნიკალური შემთხვევებისთვის',
  ad_hoc_3: 'მოითხოვეთ ჩვენთან',
  ad_hoc_4: 'ჩვენი მიდგომა',
  ad_hoc_5:
    'ჩვენი ექსპერტების გუნდი მჭევრმეტყველად ანალიზებს შეგროვებულ მონაცემებს და გაწვდავს კომპლექსურ გადაწყვეტილებებს, რომლებიც თქვენს ზრდას უწყობს ხელს.',
  ad_hoc_6:
    'ჩვენ ვმუშაობთ უნიკალურ კვლევაზე, რომელიც სპეციალურად თქვენი მოთხოვნების შესაბამისად არის შემუშავებული, მრავალფეროვანი მეთოდოლოგიებიდან, მათ შორის გამოკითხულები, ინტერვიუები, ფოკუს-ჯგუფები, მონაცემების ანალიზი და სხვ.',
  ad_hoc_7: 'რატომ უნდა აირჩიოთ ად ჰოკი კვლევა?',
  ad_hoc_8: 'ფლექსიბილობა',
  ad_hoc_9:
    'ერთნაირი კვლევის პროექტები არ არსებობს. ად ჰოკი კვლევით, ჩვენ გვაქვს შესაძლებლობა შევცვალოთ და გავავითაროთ უნიკალური მიდგომა საჭიროების შემთხვევაში, რათა თქვენი ხედვები დარჩეს შესაბამისი და მოქმედი.',
  ad_hoc_10: 'წერტილოვანი',
  ad_hoc_11:
    'ჩვენი მეთოდოლოგიების სპეციფიურ მოთხოვნებზე მორგებით, ჩვენ გაწვდავთ ზუსტ და მიზნობრივი შედეგებს, რომლებიც ფასეული ხედვები გაწვდავენ.',
  ad_hoc_12: 'ინოვაცია',
  ad_hoc_13:
    'ჩვენ ვიღებთ ინოვაციასა და კრეატიულობას ჩვენს კვლევით პროცესში, ახალი ტექნიკებისა და მიდგომების გამოძებნით, რათა აღმოვაჩინოთ დამალული შესაძლებლობები და გამოწვევები.',
  ad_hoc_14: 'სწრაფი დრო',
  ad_hoc_15:
    'ად ჰოკი კვლევა საშუალებას გვაძლევს სწრაფი განხორციელება, რაც გაწვდავს კრიტიკულ ხედვებზე დროულად, რომ დარჩეთ კონკურენტული თქვენს ინდუსტრიაში.',
  ad_hoc_16: 'ჩვენი ექსპერტიზა',
  ad_hoc_17:
    '4Service-ის ექსპერტები 20 წლის განმავლობაში ბაზრის კვლევისა და მომხმარებლის გამოცდილების სფეროში ქმნიან უნიკალურ გადაწყვეტილებებს, რომლებიც თქვენს ბიზნესს ზრდას უწყობს ხელს.',
  ad_hoc_18:
    'ჩვენ ვიყენებთ უნიკალურ ინსტრუმენტების ნაკრებს თქვენს სპეციფიურ მოთხოვნებზე დაფუძნებულად.',
  ad_hoc_19: 'არ არსებობს ერთიანი მეთოდოლოგია თქვენი საჭიროებისთვის?',
  ad_hoc_20: 'მოითხოვეთ ად ჰოკი კვლევა',
  ad_hoc_21: 'სპეციფიური პრობლემისთვის მორგებული',
  ad_hoc_22:
    'ჩვენ ვახდენთ სხვადასხვა მეთოდოლოგიის ნაწილების კომბინაციას, ასევე სრულიად ახალ მიდგომას.',
  ad_hoc_23: 'ინდივიდუალური მიდგომა',
  ad_hoc_24:
    'ჩვენ ყურადღებით ვაკეთებთ გადაწყვეტილებას თქვენი პრობლემის შესაბამისად.',
  ad_hoc_25: 'მეტი ზემოთ და მიღმა',
  ad_hoc_26:
    'ჩვენ გაწვდავთ მოქმედ გეგმას რეკომენდაციებით, რათა თქვენი ბიზნესი მიაღწიოს თავის მიზნებს.',
  ad_hoc_27: 'გაქვთ არასტანდარტული პრობლემა',
  ad_hoc_28: 'არანაირი მეთოდოლოგია არ მუშაობს თქვენი პრობლემისთვის.',
  ad_hoc_29:
    'გსურთ მოითხოვოთ სხვადასხვა მეთოდოლოგიები ან მათი ნაწილები ერთდროულად.',
  ad_hoc_30: 'ვის შეუძლია ისარგებლოს ად ჰოკი კვლევით?',
  career: 'კარიერა',
  four_opinion_1: '4Service‑ის ჯილდოთი გამსვლელი გამოკითხვა',
  four_opinion_2:
    'ვლით ონლაინ გამოკითხვებში მონაწილეობა და აგრძნობ ყოველდღე თუნდაც სახლში ყოფნისას',
  four_opinion_3: 'დარეგისტრირდით და დაიწყეთ შემოსავალი',
  four_opinion_4: 'ჩვენი უპირატესობები',
  four_opinion_5: 'ნდობა დაგვყარეს',
  four_opinion_6:
    'ჩვენი საზოგადოება უკრაინაში 90 000‑ზე მეტ და ყაზახეთში 100 000 მომხმარებელს აერთიანებს',
  four_opinion_7: 'ჩვენ ვაფასებთ თქვენს დროს',
  four_opinion_8:
    'ჩვენ ვაფასებთ თქვენს დროს, ამიტომ გამოკითხვებში მონაწილეობისთვის შეგიძლიათ მიიღოთ საჩუქარი ან ფულის პრემია',
  four_opinion_9: 'თქვენი აზრი მნიშვნელოვან გავლენას ახდენს',
  four_opinion_10:
    'თქვენი ყოველი კომენტარი ბრენდებს ეხმარება უკეთ გაიგონ თავიანთი მომხმარებლების მოთხოვნილებები',
  four_opinion_11:
    '参加 ან გამოკითხვებში მონაწილეობა 4Service‑ის 4Forum‑ზე და გააკეთეთ ონლაინ ან მოიგეთ პრიზი',
  four_opinion_12: 'შენმიერდით 4Forum‑ს',
  four_opinion_13: 'კიდევ მეტი საინტერესო ისტორიები ჩვენს არხზე',
  four_opinion_14: 'მეტის დალილება უკრაინისთვის',
  four_opinion_15: 'მეტის დალილება ყაზახეთისთვის',
  four_opinion_16: 'რატომ ღირს ჩვენს გამოკითხვებში მონაწილეობის მიღება?',
  four_opinion_17:
    '4Service არის საერთაშორისო კვლევითი ჰოლდინგი, რომელიც მენეჯმენტს უკეთებს მომხმარებლის გამოცდილებას',
  four_opinion_18:
    'ჩვენ ევროპაში მომხმარებლის გამოცდილების მენეჯმენტის ტოპ‑10 სააგენტოს შორის ვართ',
  four_opinion_19:
    'ჩვენი მისიაა გააუმჯობესოს მომხმარებელთა მომსახურება მთელს მსოფლიოში!',
  four_opinion_20: 'როგორ დავიწყოთ ონლაინ გამოკითხვებით შემოსავლის მიღება?',
  four_opinion_21: 'დარეგისტრირდით ვებ‑გვერდზე',
  four_opinion_22: 'გამოკითხვის მოწვევებს მიიღებთ ელექტრონულ ფოსტაზე.',
  four_opinion_23: 'დაასრულეთ გამოკითხვები ბოლომდე და მიიღეთ შემოსავალი',
  four_opinion_24: 'რეალური გამოხმაურებები ჩვენს მონაწილეებიდან',
  four_opinion_25: 'Вიტალი კოხანი',
  four_opinion_26:
    '“მე გავაკეთე გამოკითხვა და თითქმის დავივიწყე. ცოტა ხანში ქალბატონმა ნატალიამ შემომერეკა და მითხრა, რომ გავმარჯვდი პრიზში. და აი ის — ჩემი Samsung Galaxy M52 5G. დიდი მადლობა 😁”',
  four_opinion_27: 'ვიქტორია პოპოვსკა',
  four_opinion_28:
    '“მე მივიღე სარადიო დინამიკი, დიდი მადლობა გულწრფელი, სამართლიანი და საინტერესო გათამაშებისთვის.”',
  four_opinion_29: 'იულია ოლეკსანდროვნა',
  four_opinion_30:
    '“ეს ალბათ ყველაზე საოცარი რამაა, რაც ბოლო დროს დამემართა 💕 არამხოლოდ მოვიგე, არამედ მართლა ძალიან მაგარი რამე. ბევრის მოსვლა მელოდა, მაგრამ ესოდენ კარგი — არც კი წარმომედგინა. კიდევ ერთხელ დიდი მადლობა!”',
  four_opinion_31:
    'მხოლოდ ჩვენთან გაქვთ შესაძლებლობა იშოვნოთ “จริง” ფული ან მოიგოთ პრიზი',
  four_opinion_32: 'იყავით ინფორმირებულნი ბოლო გამოკითხვებზე ჩვენს არხზე',
  four_opinion_33: 'გადასვლა არხზე',
  four_opinion_34:
    'თქვენი პასუხები ეხმარება ბიზნესს გააუმჯობესოს სერვისები და პროდუქტები ყველა მომხმარებლისთვის.',
  four_opinion_35:
    'გამოკითხვებისთვის გადახდა კეთდება ყოველ თვის ბოლოს, მინიმალური თანხის დაგროვების შემდეგ.',
  four_opinion_36:
    'გთხოვთ აუცილებლად შეიყვანოთ თქვენი გადახდის დეტალები თქვენს პირად კაბინეტში — ამის გარეშე გადახდა შეუძლებელია.',
  four_opinion_37: 'მიიღეთ ჯილდო თქვენი აზრისთვის',
  four_opinion_38:
    'გაზიარეთ თქვენი შეხედულებები და მიიღეთ სამართლიანი ანაზღაურება თითოეული დასრულებული გამოკითხვისთვის. ჩვენ ვიხდით ფულით და არა გაურკვეველი “ქულებით.”',
  four_opinion_39: 'ბრენდების ნდობა',
  four_opinion_40:
    'ჩვენ გვენდობიან, ამიტომ ვატარებთ ყოველთვიურად 100 000‑ზე მეტ ინტერვიუს.',
  four_opinion_41: 'მოპყრეთ გავლენა პროდუქტისა და სერვისების მომავალზე',
  four_opinion_42:
    'მწარმოებლები და კომპანიები თქვენი გამოხმაურებების მოსმენას ახდენენ იმისათვის, რომ პროდუქცია უკეთესი გახადონ თქვენთვის.',
  four_opinion_43: 'იყავით პირველები, ვინც გაიგებს სიახლეებზე',
  four_opinion_44:
    'ტესტეთ საინტერესო პროდუქტები, რეკლამები და ამიდეები მათი ბაზარზე გამოსვლამდე.',
  four_opinion_45: ' მარტივი და მოსახერხებელი პროცესი',
  four_opinion_46:
    'მონაწილეობეთ თქვენთვის ხელსაყრელ დროს — კომპიუტერიდან ან სმარტფონიდან, ადგილმდებარეობის შეზღუდვის გარეშე.',
  four_opinion_47: 'სანდოობა და უსაფრთხოება',
  four_opinion_48:
    'ჩვენ ვაძლევთ კონფიდენციალურობას და დროულ გადახდებს. თქვენი ინფორმაცია არასდროს გაიცემება მესამე პირებზე.',
  cati_1: 'CATI',
  cati_2: 'ეფექტიანი კომპიუტერული სატელეფონო გამოკითხვები',
  cati_3: 'დაგვიკავშირდით',
  cati_4: 'ჩვენ გვენდობიან',
  cati_5:
    '<b>CATI (Computer Assisted Telephone Interviewing)</b> – ეს არის მონაცემთა შეგროვების მეთოდი სატელეფონო გამოკითხვების საშუალებით, სადაც ოპერატორები სპეციალურ პროგრამულ უზრუნველყოფას იყენებენ პასუხების ჩასაწერად, კითხვების ლოგიკის უზრუნველსაყოფად და შედეგების ანალიზისთვის.',
  cati_6: 'CATI-ს მთავარი უპირატესობები 4Service-ისგან:',
  cati_7: '<b>ოპერატიულობა</b> გამოკითხვების ჩატარებაში',
  cati_8: '<b>მაღალი მონაცემთა ხარისხი</b>',
  cati_9: '<b>მოქნილობა</b> კითხვარების მორგებაში',
  cati_10: '<b>პროცესის ავტომატიზაცია</b>',
  cati_11: 'ხარისხის კონტროლის <b>მრავალფეროვანი ინსტრუმენტები</b>',
  cati_12: '<b>მძიმეად მისაწვდომი რესპონდენტების</b> გამოკითხვის შესაძლებლობა',
  cati_13: '<b>ყველა საუბრის</b> <b>ჩაწერა</b> შემდგომი მოსმენის მიზნით',
  cati_14: '<b>დიდი სამიზნე აუდიტორიის</b> სწრაფი დაფარვის შესაძლებლობა',
  cati_15:
    'მეთოდი <b>ეკონომიკურად მომგებიანია</b> სხვა მონაცემთა შეგროვების მეთოდებთან შედარებით',
  cati_16: 'Solves',
  cati_17: 'რა ამოცანებს აგვარებს სატელეფონო გამოკითხვები:',
  cati_18:
    '<span>სეგმენტაციის ბაზრის კვლევები.</span> სხვადასხვა მომხმარებელთა ჯგუფების იდენტიფიცირება ზუსტი ტარგეტინგისა და ეფექტიანი მარკეტინგული სტრატეგიებისთვის',
  cati_19:
    '<span>კლიენტების კმაყოფილების დონის შეფასება.</span> მომხმარებელთა ლოიალობის შეფასება SCI, NPS ინდექსების დახმარებით',
  cati_20:
    '<span>NPS მენეჯმენტი და action-გეგმის დანერგვა.</span> სატელეფონო გამოკითხვების გამოყენება მომხმარებელთა გამოცდილების აქტიური მართვისთვის საკონტაქტო ცენტრის მეშვეობით',
  cati_21:
    '<span>მოთხოვნისა და ბაზრის ტენდენციების ანალიზი.</span> პროდუქციისა და სერვისების პოპულარობის კვლევა, პერსპექტიული რეგიონებისა და განვითარების მიმართულებების განსაზღვრა',
  cati_22:
    '<span>კონკურენტული გარემოს ანალიზი.</span> ბრენდის პოზიციის შეფასება ბაზარზე, კონკურენტებთან შედარება და ზრდის შესაძლებლობების იდენტიფიცირება',
  cati_23: 'For whom',
  cati_24: 'CATI იდეალურია:',
  cati_25: 'კომპანიებისთვის, რომლებიც გეგმავენ პროდუქტის გაშვებას',
  cati_26:
    'ბაზრის შესახებ აქტუალური მონაცემების შესაგროვებლად, კონკურენტული გარემოს შესწავლისა და მომხმარებელთა პრეფერენციების ანალიზისთვის',
  cati_27: 'ბრენდებისა და კომპანიებისთვის, რომლებიც მომხმარებლებთან მუშაობენ',
  cati_28:
    'კლიენტების კმაყოფილების დონის (Customer Satisfaction, NPS) შეფასებისთვის, საჭიროებების ანალიზისა და უკუკავშირის შეგროვებისთვის',
  cati_29: 'რითეილისა და e-commerce-სთვის',
  cati_30:
    'მომხმარებელთა ქცევის გასაგებად, ახალი პროდუქტების სატესტოდ, და შეძენის გადაწყვეტილებებზე გავლენის მქონე ფაქტორების განსასაზღვრად',
  cati_31: 'ბანკებისა და საფინანსო დაწესებულებებისთვის',
  cati_32:
    'სერვისის უზრუნველყოფისთვის, კომპანიისადმი ნდობის დონის შესამოწმებლად და მომსახურებაზე უკუკავშირის შესაგროვებლად',
  cati_33: 'სოციალური ორგანიზაციებისთვის',
  cati_34:
    'სოციოლოგიური კვლევების ჩატარებისა და საზოგადოებრივი აზრის შესასწავლად',
  cati_35: 'სახელმწიფო უწყებებისთვის და არასამთავრობო ორგანიზაციებისთვის',
  cati_36:
    'სტატისტიკური მონაცემების შეგროვებისთვის, სოციალური პრობლემების შესასწავლად და კვლევითი პროგრამების განსახორციელებლად',
  cati_37: 'Quality',
  cati_38: 'ზარის ხარისხის შეფასების კრიტერიუმები',
  cati_39: 'საკომუნიკაციო ძირითადი უნარები',
  cati_40:
    'მისალმებისა და საუბრის დასრულების სტანდარტების დაცვა, ასევე რესპონდენტისთვის კომფორტული ენის არჩევა',
  cati_41: 'კომუნიკაციის სტილი',
  cati_42:
    'გრამატიკული სიზუსტე, თავაზიანობა, მეგობრული ტონი და რესპონდენტთან ნდობის დამყარების უნარი',
  cati_43: 'საუბრის მართვა',
  cati_44:
    'აქტიური მოსმენის ტექნიკების გამოყენება, რესპონდენტის ყურადღების შენარჩუნება და დიალოგის ეფექტურად წარმართვა',
  cati_45: 'თემატური ცოდნა',
  cati_46:
    'გამოკითხვის თემატიკის სიღრმისეული ცოდნა და რესპონდენტის დამატებით შეკითხვებზე ზუსტი პასუხის გაცემა',
  cati_47: 'კითხვარის შევსების სიზუსტე',
  cati_48:
    'პასუხების ზუსტი დაფიქსირება ყოველგვარი დამახინჯების გარეშე, ინსტრუქციების დაცვა და უზუსტობების თავიდან აცილება',
  cati_49: 'Why 4Service',
  cati_50: 'რატომ ირჩევენ 4Service-ის CATI-ს?',
  cati_51:
    'CATI იდეალურია კომპანიებისთვის, რომლებიც სატელეფონო გამოკითხვების საშუალებით ზუსტ, სტრუქტურირებულ მონაცემებს ეძებენ',
  cati_52: 'საკუთარი საკონტაქტო ცენტრი',
  cati_53:
    'ჩვენ უკვე ჩავატარეთ 70 000-ზე მეტი შედეგიანი ზარი, 100%-იანი კლიენტური მოთხოვნების შესრულებით',
  cati_54: 'ხარისხის გარანტია',
  cati_55: 'თითოეული ზარის 100%-იანი ვალიდაცია – მონაცემთა სანდოობის გარანტია',
  cati_56: 'ინდივიდუალური მიდგომა',
  cati_57: 'ვქმნით უნიკალურ კითხვარებს პერსონალური მოთხოვნების შესაბამისად',
  cati_58: 'თანამედროვე პროგრამული უზრუნველყოფა',
  cati_59: 'VolPtime ნებისმიერი სირთულის CATI-ს შესასრულებლად',
  cati_60: 'B2B-სთან მუშაობის გამოცდილება',
  cati_61:
    'ვმუშაობთ იურიდიულ პირებთან, ვიკითხავთ ბიზნესისა და მრეწველობის სხვადასხვა სფეროს წამყვან სპეციალისტებს',
  cati_62:
    'დატოვეთ განაცხადი და ჩვენ შეგირჩევთ საუკეთესო გადაწყვეტას თქვენთვის!',
  cati_63: 'Technology',
  cati_64:
    'ვიყენებთ თანამედროვე ტექნოლოგიებს შედეგების ანალიზისა და თქვენი ბიზნესის გაუმჯობესებისთვის',
  cati_65: 'შესაძლებლობები:',
  cati_66: '<span>VolPtime</span> - პროფესიონალური პროგრამული უზრუნველყოფა',
  cati_67: 'შემომავალი (ცხელი)/გამავალი ავტომატიზებული ხაზების ორგანიზაცია',
  cati_68:
    'სტატისტიკა ოპერატორების, თითოეული ტიპის მიმართვისა და კონსულტაციის ხანგრძლივობის მიხედვით',
  cati_69: 'საკონტაქტო ცენტრის მუშაობის ონლაინ-მონიტორინგი',
  cati_70: 'ყველა სატელეფონო აუდიო კონსულტაციის ჩაწერა',
  cati_71: 'დაშორებული და მარტივი პროგრამის კონფიგურაცია',
  cati_72:
    '<span>Survey Monkey</span> - პროფესიონალური სერვისი კითხვარების პროგრამირებისთვის',
  cati_73: 'კითხვარების სხვადასხვა სირთულის პროგრამირება',
  cati_74: 'კვლევის ყველა მოთხოვნის გათვალისწინება',
  cati_75: 'მარტივობა, გასაგები ინტერფეისი და კომფორტი რესპონდენტებისთვის',
  cati_76: 'Quality',
  cati_77: 'კლიენტებთან დიალოგების ხარისხის შეფასება',
  cati_78: 'შეფასების სისტემა ჩეკ-ლისტის მიხედვით',
  cati_79:
    'მომსახურების ხარისხი იზომება სპეციალური ჩეკ-ლისტით, სადაც ხარისხის შეფასების თანამშრომლები აფასებენ საშუალო ქულას ანგარიშგების პერიოდში',
  cati_80: 'სტანდარტების დაცვის მიზნობრივი მაჩვენებლები',
  cati_81:
    'სტანდარტების დაცვა ფასდება განსაზღვრული დონეების მიხედვით, რომლებიც არ შეიძლება იყოს 90%-ზე ნაკლები. ეს მაჩვენებლები შეიძლება შეიცვალოს თანამშრომლის გამოცდილების მიხედვით',
  cati_82: 'ზარების მონიტორინგი ჩაწერილ და რეალურ დროში',
  cati_83:
    'დაახლოებით 40% ზარების მოუსმენენ ჩაწერილ ფორმატში და 20% რეალურ დროში, რაც შესაძლებელს ხდის სტანდარტების დარღვევებზე სწრაფ რეაგირებას',
  cati_84: 'Experts',
  cati_85: 'გაქვს საკუთარი საკონტაქტო ცენტრი',
  cati_86: 'საკონტაქტო ცენტრის ხელმძღვანელი',
  cati_87: 'პერსონალის შერჩევის მენეჯერები',
  cati_88: 'უკრაინა - დაშორებული პლატფორმა',
  cati_89: 'ყაზახეთი - დაშორებული პლატფორმა',
  cati_90: 'ტექნიკური კოორდინატორი',
  cati_91: 'პროექტის მენეჯერები',
  cati_92: 'პროექტის მენეჯერები',
  cati_93: 'სასწავლო და ხარისხის კონტროლის განყოფილება',
  cati_94: 'ოპერატორები 60 ადამიანი (20% ინგლისური ენის ცოდნით)',
  cati_95: 'ოპერატორები 20 ადამიანი',
  cati_96: 'ხარისხის კონტროლის განყოფილების ხელმძღვანელი',
  cati_97: 'ზარების ხარისხის კონტროლის სპეციალისტები',
  cati_98: 'სასწავლო ტრენერები',
  main_73: 'დღიურის კვლევა',
  main_74:
    'დღიურის კვლევა სასარგებლოა ხანგრძლივი გამოცდილებისა და განმეორებითი აქტივობების შესასწავლად. აკვირდით და მიიღეთ სიღრმისეული ხედვა მომხმარებელთა გამოცდილებისა და ცხოვრების წესის ცვლილებებზე დროის განმავლობაში მათ ყოველდღიურ გარემოში.',
  main_75: 'თანამშრომელთა გამოცდილება (EX)',
  main_76:
    'თანამშრომელთა გამოცდილების (EX) მეთოდოლოგია არის სტრატეგიული მიდგომა, რომელიც ეხმარება ორგანიზაციებს უკეთესი პროცესების, კულტურებისა და გარემოს დიზაინში, რათა მათ თანამშრომელთა მოლოდინებსა და ბიზნეს მიზნებს შეესაბამებოდეს, საბოლოოდ კი აუმჯობესებს როგორც თანამშრომელთა კეთილდღეობას, ასევე კომპანიის ეფექტურობას.',
  main_77: 'CATI',
  main_78: 'კომპიუტერით მხარდაჭერილი სატელეფონო ინტერვიუ (CATI)',
  main_79:
    'CATI არის მოქნილი და ეფექტური კვლევის მეთოდოლოგია, რომელიც უზრუნველყოფს მაღალხარისხიანი მონაცემების შეგროვებას სხვადასხვა ბიზნეს საჭიროებისთვის — მომხმარებელთა კმაყოფილებიდან და თანამშრომელთა ჩართულობიდან დაწყებული, ბაზრისა და სოციალური კვლევით დასრულებული — რაც იძლევა ზუსტ, დროულ და ქმედით ანალიზს.',
  diary_study_1: 'დღიური',
  diary_study_2: 'კვლევა',
  diary_study_3:
    'დააკვირდით და შეაგროვეთ მონაცემები მომხმარებელთა გამოცდილებისა და ცხოვრების წესის ცვლილებებზე დროის განმავლობაში',
  diary_study_4: 'ესაუბრეთ ექსპერტს',
  diary_study_5: 'დაგვიკავშირდით',
  diary_study_6: 'დაიწყეთ',
  diary_study_7:
    'მოითხოვეთ დღიურის კვლევა, რათა ერთდროულად მიიღოთ როგორც რაოდენობრივი, ისე ხარისხობრივი მონაცემები, რომლებიც ფასეულ ინფორმაციას იძლევა მომხმარებელთა ქცევაზე, ბაზრის ტენდენციებსა და ბრენდის ეფექტურობაზე.',
  diary_study_8:
    'ცხოვრების სტილისა და მომხმარებელთა გამოცდილების დინამიკის კვლევა',
  diary_study_9:
    'დღიურის კვლევა გთავაზობთ სიღრმისეულ, კონტექსტუალურ ინფორმაციას იმის შესახებ, თუ როგორ ურთიერთობენ მომხმარებლები, რაც საშუალებას იძლევა გამოვლინდეს წესები და ცვლილებები, რომლებიც სხვა მეთოდებით შეიძლება შეუმჩნეველი დარჩეს.',
  diary_study_10:
    'მეთოდი იძლევა რეალურ დროში მონაცემების შეგროვების შესაძლებლობას ბუნებრივ გარემოში, რაც მნიშვნელოვნად ზრდის მის სანდოობასა და რელევანტურობას.',
  diary_study_11: 'მიაწოდეთ',
  diary_study_12: 'ჩვენ გთავაზობთ მორგებულ დღიურის კვლევებს',
  diary_study_13: 'მომხმარებელთა ჩართულობა',
  diary_study_14:
    'ჩვენ ვქმნით ონლაინ თემებს, რომელთა მონაწილეებიც დროის განმავლობაში აფიქსირებენ თავიანთ ქცევებს, აქტივობებსა და გამოცდილებას ყოველდღიურ გარემოში.',
  diary_study_15: 'ბაზრის კვლევა',
  diary_study_16:
    'ჩვენი მიდგომა მოიცავს სიღრმისეულ ბაზრის კვლევას, რათა შევთავაზოთ რელევანტური და გააზრებული ინფორმაცია ჩვენი კლიენტების კონკრეტული საჭიროებებისთვის.',
  diary_study_17: 'ბრენდის ანალიზი',
  diary_study_18:
    'ჩვენ ღრმად ვიკვლევთ მომხმარებელთა აღქმებსა და ქცევებს, რათა აღმოვაჩინოთ მნიშვნელოვანი ინფორმაცია, რომელიც აყალიბებს ბრენდის სტრატეგიებს.',
  diary_study_19: 'ექსპერტები',
  diary_study_20:
    '4Service-ის 20 წელზე მეტი გამოცდილების მქონე ექსპერტები ქმნიან უნიკალურ გადაწყვეტილებებს, რომლებიც ეხმარება თქვენს ბიზნესს ზრდაში.',
  diary_study_21: 'პროექტის მენეჯმენტი',
  diary_study_22:
    'ჩვენი გუნდი უზრუნველყოფს პროექტის მენეჯმენტის სრულ მხარდაჭერას, რაც გულისხმობს ყველა ეტაპის დეტალურ დაგეგმვასა და შესრულებას.',
  diary_study_23: 'კონსულტაცია',
  diary_study_24:
    'ჩვენ გთავაზობთ ექსპერტულ კონსულტაციას, რათა დავეხმაროთ კლიენტებს პროექტის ყველა ეტაპზე, პრობლემების გადაჭრაში და ეფექტურობის გაუმჯობესებაში.',
  diary_study_25: 'ხარისხის უზრუნველყოფა',
  diary_study_26:
    'ჩვენ ვიცავთ მკაცრ ხარისხობრივ სტანდარტებს ყველა ეტაპზე, რაც უზრუნველყოფს პროექტების მოლოდინზე მაღლა შესრულებას.',
  diary_study_27: 'სარგებელი',
  diary_study_28: 'მოიპოვეთ სარგებელი ჩვენთან ერთად',
  diary_study_29: '<b>უსაზღვრო მონაცემების წყარო</b> დროში',
  diary_study_30: '<b>ექსპერტული რეკომენდაციები</b> პროცესის ყველა ეტაპზე',
  diary_study_31:
    '<b>ბიზნესების დაკავშირება</b> მომხმარებლებთან მსოფლიო მასშტაბით',
  diary_study_32:
    '<b>მოსახერხებელი მონაცემების შეგროვება</b> დეტალური უკუკავშირითა და პასუხებით',
  diary_study_33: '<b>ხელმისაწვდომი მონაცემები</b> პროექტის ნებისმიერ ეტაპზე',
  diary_study_34: '<b>კომპლექსური გადაწყვეტილებები</b> თქვენი ზრდისთვის',
  diary_study_35: 'კვლევა',
  diary_study_36:
    'მიიღეთ მორგებული რაოდენობრივი კვლევა სპეციალური შეხედულებებით',
  employee_experience_1: 'თანამშრომელთა გამოცდილება',
  employee_experience_2:
    'თქვენი ბიზნესის წარმატება იწყება თანამშრომელთა გამოცდილებით',
  employee_experience_3: 'დაგვიკავშირდით',
  employee_experience_4: 'თქვენი წარმატების ისტორია იწყება აქ',
  employee_experience_5:
    '4Service-ის ექსპერტები 20 წელზე მეტი ბაზრის კვლევისა და მომხმარებელთა გამოცდილების სფეროში ქმნიან უნიკალურ გადაწყვეტილებებს თქვენი ბიზნესის ზრდისთვის.',
  employee_experience_6:
    'ჩვენი სერვისები ბიზნესებს აძლევს საჭირო ინსტრუმენტებს გააზრებული გადაწყვეტილებების მისაღებად, სტრატეგიების გაუმჯობესებისთვის და ინდუსტრიაში წარმატების მისაღწევად.',
  employee_experience_7:
    'ჩვენ ვირჩევთ თქვენს საჭიროებებზე მორგებულ იდეალურ მეთოდოლოგიას',
  employee_experience_8: 'თანამშრომლის მოგზაურობის რუკა',
  employee_experience_9:
    'ჩვენ ვამუშავებთ თანამშრომლის ცხოვრების ციკლს დასაქმებიდან დათხოვნამდე, გამოვყოფთ მთავარ შეხების წერტილებს, რაც გავლენას ახდენს მათ გამოცდილებაზე. ეს ეხმარება გაუმჯობესების ზონების იდენტიფიცირებას და ჩართულობის ზრდის შესაძლებლობების აღმოჩენას.',
  employee_experience_10: 'თანამშრომლის მოგზაურობის რუკა შედარებითი ანალიზით',
  employee_experience_11:
    'ჩვენ ვაუმჯობესებთ თანამშრომლის მოგზაურობის რუკას ინდუსტრიულ სტანდარტებთან შედარებით. ეს ეხმარება შიდა პროცესების გამარტივებას, ერთგულების ზრდასა და საუკეთესო პრაქტიკის დანერგვას.',
  employee_experience_12: 'დამსაქმებლის ბრენდის ჯანმრთელობის კვლევა',
  employee_experience_13:
    'ჩვენ ვაფასებთ, როგორ აღიქვამენ თანამშრომლები კომპანიის ბრენდს შიგნიდან. ძლიერი შიდა ბრენდი ზრდის მოტივაციასა და ერთგულებას, რაც აისახება მომხმარებელთა უკეთ მომსახურებასა და გარე რეპუტაციაზე.',
  employee_experience_14: 'თანამშრომელთა რეკომენდაციის ინდექსი (eNPS)',
  employee_experience_15:
    'eNPS-ის მეშვეობით ვზომავთ, რამდენად სავარაუდოა, რომ თანამშრომლები რეკომენდაციას გაუწევენ კომპანიას როგორც კარგ სამუშაო ადგილს. ეს მარტივი, მაგრამ ძლიერი მაჩვენებელი ასახავს საერთო კმაყოფილებასა და ერთგულებას.',
  employee_experience_16:
    'თანამშრომელთა ერთგულებისა და კმაყოფილების ინდექსი (ECSI)',
  employee_experience_17:
    'ჩვენი ECSI მეთოდოლოგია აფასებს, რამდენად ერთგული და კმაყოფილია თანამშრომელი თავისი როლითა და კომპანიით. ეს ეხმარება ჩართულობის დონის განსაზღვრას და გაუმჯობესების საჭიროების იდენტიფიცირებას.',
  employee_experience_18:
    'სიღრმისეული ინტერვიუები ყოფილ და ამჟამინდელ თანამშრომლებთან',
  employee_experience_19:
    'ჩვენ ვესაუბრებით ყოფილ თანამშრომლებს, რათა გავიგოთ, რატომ ტოვებენ კომპანიას და როგორ უნდა გაუმჯობესდეს შენარჩუნება. ამჟამინდელ თანამშრომლებთან საუბარი აჩვენებს გზებს მომხმარებელთა მომსახურების გაუმჯობესებისა და KPI-ების მიღწევის ბარიერების გადალახვისთვის.',
  employee_experience_20: 'UGC ანალიზი',
  employee_experience_21:
    'მომხმარებელთა მიერ გენერირებული კონტენტის (UGC) ანალიზი ხორციელდება სპეციალიზებული ვებსაიტებიდან, სოციალური მედიის, ფორუმებისა და ვიდეო პლატფორმებიდან მიმოხილვების შეგროვებით. ეს ანალიზი გაძლევთ წარმოდგენას რეალურ მოლოდინებზე, პრობლემებზე, ტენდენციებზე და ბრენდის შედარებით სიძლიერესა და სისუსტეებზე.',
  employee_experience_22: 'საიდუმლო თანამშრომელი',
  employee_experience_23:
    'საიდუმლო თანამშრომელი არის კომპანიის შეფასება პოტენციური თანამშრომლის პერსპექტივიდან. ის აფასებს შიდა პროცესების ორგანიზებას, არსებული თანამშრომლების კომუნიკაციას კანდიდატებთან და კომპანიის სერვისისა და კომუნიკაციის სტანდარტების დაცვას.',
  employee_experience_24: 'მოტივაციური ვიზიტები',
  employee_experience_25:
    'მოტივაციური ვიზიტები ასახავს თანამშრომლების დაჯილდოებას, ვინც აკმაყოფილებს მომსახურების სტანდარტებს, მაგალითად, მომხმარებელთან შესანიშნავი კომუნიკაცია ან წარმატებული გადაყიდვა. საიდუმლო მყიდველები გამოავლენენ საუკეთესო თანამშრომლებს, რაც ზრდის მოტივაციას და აძლიერებს სხვების ჩართულობას.',
  employee_experience_26: 'სერვის დიზაინი',
  employee_experience_27:
    'ჩვენ ვიყენებთ სერვის დიზაინს ბიზნესის გამოწვევების იდენტიფიცირებისა და ინოვაციური გადაწყვეტილებების მოსაძებნად, რაც აყალიბებს სტრატეგიებს მომსახურების გაუმჯობესებისა და მომხმარებლის ან თანამშრომლის საჭიროებების დაკმაყოფილებისათვის.',
  employee_experience_28: 'HR კვლევა',
  employee_experience_29:
    'HR კვლევა ხელს უწყობს შეაფასოს, რამდენად ეთანხმებიან თანამშრომლები კომპანიის მისიასა და ღირებულებებს და რამდენად ეფექტურად გადასცემენ მათ კლიენტებს.',
  employee_experience_30: 'თანამშრომლებთან თანაშექმნა (ფოკუს-ჯგუფები)',
  employee_experience_31:
    'თანამშრომელთა უშუალო ჩართულობით ვმართავთ თანაშექმნის ფოკუს-ჯგუფებს, რათა მივიღოთ უკუკავშირი და შეხედულებები. ეს კოლაბორაციული პროცესი აძლიერებს პერსონალის ჩართულობას და პატრონობის განცდას.',
  employee_experience_32: 'რატომ ღირს ინვესტირება თანამშრომელთა გამოცდილებაში?',
  employee_experience_33: 'შეამცირეთ პერსონალის გადინება',
  employee_experience_34:
    'შეინარჩუნეთ თქვენი საუკეთესო კადრები ისეთი სამუშაო გარემოს შექმნით, სადაც მათ სურთ დარჩენა და განვითარება.',
  employee_experience_35: 'გააზარდეთ თანამშრომელთა ლოიალურობა',
  employee_experience_36:
    'შექმენით გრძელვადიანი ერთგულება და ერთგულება თანამშრომლებში, შეამცირეთ ძვირადღირებული ხელახალი აყვანის საჭიროება.',
  employee_experience_37: 'ცვლილებებზე მარტივი ადაპტაცია',
  employee_experience_38:
    'შეამცირეთ წინააღმდეგობა ახალი წესების და ინიციატივების მიმართ, რაც უზრუნველყოფს უფრო რბილ გარდამავალ პროცესებს.',
  employee_experience_39: 'გააზარდეთ პროდუქტიულობა',
  employee_experience_40:
    'დაეხმარეთ თქვენს გუნდს ახალი პროცესების ათვისებაში და საკუთარი როლების სრულფასოვნად შესრულებაში.',
  employee_experience_41: 'შეამცირეთ ბიზნეს-ხარჯები',
  employee_experience_42:
    'გააუმჯობესეთ პროცესები, რაც გამოიწვევს დანაზოგს და შემოსავლის ზრდას.',
  employee_experience_43:
    'კარგი თანამშრომელთა გამოცდილება ბიზნესის ზრდის მამოძრავებელია',
  employee_experience_44:
    'თანამშრომელთა გამოცდილება (EX) მოიცავს ყველაფერს, რასაც თანამშრომლები ხვდებიან და გრძნობენ კომპანიაში ყოფნისას.',
  employee_experience_45:
    'პოზიტიური EX აყალიბებს თანხვედრას კომპანიის მიზნებთან, ამაღლებს მოტივაციას და აძლიერებს ჩართულობას.',
  employee_experience_46:
    'კმაყოფილი და მოტივირებული თანამშრომლები აწვდიან შესანიშნავ მომსახურებას, რაც უზრუნველყოფს კმაყოფილ მომხმარებლებსა და მდგრად ზრდას.',
  employee_experience_47:
    'EX-ში ინვესტიცია ქმნის დადებით შედეგებს – უკეთესი შენარჩუნება, გაზრდილი პროდუქტიულობა და ძლიერი ბიზნეს-შედეგები.',
  employee_experience_48: 'თქვენი EX + CX პირდაპირ აისახება ბიზნესზე',
  employee_experience_49:
    'თანამშრომელთა გამოცდილება (EX) და მომხმარებელთა გამოცდილება (CX) ერთმანეთს უკავშირდება. კმაყოფილი გუნდი ბევრად მეტად უზრუნველყოფს მაღალი ხარისხის მომსახურებას, რაც იწვევს კმაყოფილ მომხმარებლებს. ჩვენი ინტეგრირებული EX და CX მიდგომით შეგიძლიათ დააკავშიროთ შიდა კულტურა გარე მომსახურების ხარისხთან.',
  employee_experience_50:
    'თანამშრომელთა და მომხმარებელთა გამოცდილების ინტეგრაციით ვქმნით ჰოლისტურ მიდგომას მათი გაუმჯობესებისკენ. შედეგი არის უფრო ძლიერი, შეკრული კორპორაციული კულტურა, რომელიც აძლიერებს ბიზნესის წარმატებას.',
  employee_experience_51: 'კმაყოფილი დამსაქმებელი',
  employee_experience_52: 'შესანიშნავი მომსახურება',
  employee_experience_53: 'კმაყოფილი მომხმარებელი',
  career_1: 'გახდით ნაწილი',
  career_2: '4Service',
  career_3: 'გელით ჩვენს გუნდში უსაზღვრო შესაძლებლობებით პროფესიული ზრდისთვის!',
  career_4: 'ვაკანსიები',
  career_5: 'ვაკანსია ვერ იპოვეთ?',
  career_6: 'გამოგვიგზავნეთ თქვენი რეზიუმე და დაგიკავშირდებით!',
  career_7: 'რეზიუმეს გაგზავნა',
  career_8: 'რეგისტრაციის ფორმა',
  career_9: '*სახელი',
  career_10: '*გვარი',
  career_11: '*ელ.ფოსტა',
  career_12: '*ტელეფონის ნომერი',
  career_13: 'რეზიუმეს ატვირთვა',
  career_14: 'გაგზავნა',
  career_15: 'დაიწყეთ კარიერა 4Service-ში',
  career_16: 'ძირითადი ამოცანები:',
  career_17: 'მოთხოვნები:',
  career_18: 'ჩვენ გთავაზობთ:',
  career_19: 'განაცხადის გაგზავნა',
  career_20: '4Service — საერთაშორისო კვლევითი ჰოლდინგი',
  career_21: 'ვმუშაობთ 2001 წლიდან',
  career_22: 'ჩვენს შესახებ',
  career_23: 'ვავითარებთ კორპორაციულ კულტურას',
  career_24: 'ჩვენი ინიციატივები',
  career_25: 'ვაუმჯობესებთ მომხმარებელთა მომსახურებას მთელ მსოფლიოში',
  career_26: '4Service-ის ვაკანსიები',
  career_27: 'თქვენი შესაძლებლობები 4Service-თან ერთად',
  career_28:
    'გონებრივი ჯანმრთელობის მხარდაჭერა ყოველკვირეული სესიების “Morning coffee”, გუნდური აქტივობებისა და სოციალური ინიციატივების მეშვეობით',
  career_29:
    'საინტერესო სამუშაო გამოცდილება მსოფლიოში ცნობილ ბრენდებთან, როგორიცაა: <span>Mercedes, Huawei, Philip Morris</span>',
  career_30:
    'მუდმივი პროფესიული განვითარება სემინარების, ტრენინგებისა და ვორქშოფების საშუალებით',
  career_31: 'ფარული მყიდველის როლი და გავლენა ცნობილი ბრენდების განვითარებაზე',
  career_32:
    'თანამშრომლობა ნებისმიერი წერტილიდან და შესაძლებლობა იმუშაოთ დისტანციურად ან ოფისიდან შემდეგ ქვეყნებში: <span>უკრაინა, ყაზახეთი, რუმინეთი, ავსტრია, აზერბაიჯანი, საქართველო</span>',
  career_33:
    'პირადი ბრენდის განვითარება ღონისძიებებსა და ვებინარებში, ასევე ნეთვორქინგში მონაწილეობით',
  shoppers_1: 'პლატფორმა',
  shoppers_2: 'ფარული მყიდველებისთვის',
  shoppers_3: 'შეერთება',
  shoppers_4: 'შეაფასეთ სერვისი და გამოიმუშავეთ 4Service-თან ერთად',
  shoppers_5: 'დაიწყეთ თქვენი კარიერა 4Service-ში',
  shoppers_6: 'თქვენ გელით საინტერესო პროექტებზე მუშაობა',
  shoppers_7: 'შეერთება',
  shoppers_8: 'შეერთდით ჩვენს გუნდს',
  shoppers_9: 'გაიგეთ მეტი ›',
  shoppers_10: 'სუპერვაიზერი',
  shoppers_11:
    'მენეჯერი, რომელიც აკონტროლებს გუნდის მუშაობას, პასუხისმგებელია დაგეგმვაზე, მუშაობის კოორდინაციაზე, ხარისხის კონტროლზე და ორგანიზაციული საკითხების გადაჭრაზე, უზრუნველყოფს დასახული ამოცანების შესრულებას.',
  shoppers_12: 'ფარული მყიდველი',
  shoppers_13:
    'ექსპერტი, რომელიც სტუმრობს მაღაზიებს, რესტორნებს ან სხვა დაწესებულებებს სცენარის შესაბამისად და შემდეგ ანგარიშობს თავის შთაბეჭდილებებს.',
  shoppers_14: 'მერჩენდაიზერი',
  shoppers_15:
    'სპეციალისტი, რომელიც პასუხისმგებელია პროდუქციის განლაგებაზე მაღაზიებში ბრენდის ან კომპანიის სტანდარტების შესაბამისად.',
  shoppers_16: 'აუდიტორი',
  shoppers_17:
    'სპეციალისტი, რომელიც ამოწმებს საქმიანობას სტანდარტებისა და მოთხოვნების შესაბამისობაზე.',
  shoppers_18: 'ტესტერი',
  shoppers_19:
    'სპეციალისტი, რომელიც ამოწმებს სერვისის, პროდუქტის ან პროცესის ხარისხს მომხმარებლის თვალსაზრისით, აფასებს მოლოდინების შესაბამისობას და ავლენს შესაძლო პრობლემებს.',
  shoppers_20: 'ფარული კანდიდატი',
  shoppers_21:
    'სპეციალისტი, რომელიც აანალიზებს მომხმარებელთა მომსახურების პროცესს, აფასებს კომუნიკაციის ხარისხს, რეაგირების სისწრაფეს, პროცედურების მოხერხებულობას და საერთო შთაბეჭდილებას ურთიერთქმედებაზე.',
  shoppers_22: 'პრომოუტერი',
  shoppers_23:
    'ექსპერტი, რომელიც ხელს უწყობს პროდუქციის პოპულარიზაციას დემონსტრაციის, სარეკლამო მასალების დარიგების, აქციების ორგანიზებისა და მომხმარებელთა კითხვებზე პასუხის გზით.',
  shoppers_24: 'ინტერვიუს მონაწილე',
  shoppers_25:
    'ღრმა ინტერვიუს მონაწილე მონაწილეობს დეტალურ კვლევაში, რომელიც მიზნად ისახავს მისი აზრების, ემოციების, მოტივაციების ან გამოცდილების გამოვლენას კონკრეტულ თემაზე, პროდუქტზე ან სერვისზე.',
  shoppers_26: 'გახდით 4Service-ის ნაწილი',
  shoppers_27: 'ჩვენ ვმუშაობთ <b>მსოფლიოს მასშტაბით</b>',
  shoppers_28: 'ჩვენი გუნდი მოიცავს <b>1000+ პროფესიონალს</b>',
  shoppers_29: 'გვაქვს წარმატებული <b>20+ წლიანი გამოცდილება</b> ბაზარზე',
  shoppers_30: 'ინსტრუქციები',
  shoppers_31: 'როგორ ჩავწეროთ ვიზიტის აუდიო',
  shoppers_32: 'როგორ ჩავწეროთ ზარის აუდიო',
  shoppers_33: 'ვერ ახერხებთ აუდიოფაილის მიმაგრებას კითხვარზე?',
  shoppers_34:
    'MSPA-ს პროფესიული სტანდარტებისა და ეთიკის კოდექსი ფარული მყიდველებისთვის',
  shoppers_35: 'F.A.Q.',
  shoppers_36: 'ხშირად დასმული კითხვები',
  shoppers_37: 'რამდენი შეიძლება გამოიმუშაოთ თვეში?',
  shoppers_38: 'რამდენად ხშირად შემიძლია დავასრულო დავალებები ჩემს ქალაქში?',
  shoppers_39:
    'რა უნდა გავაკეთო, თუ ლოკაცია დახურულია და რა ჯილდოა ასეთი ვიზიტისთვის?',
  shoppers_40: 'როგორ ხდება ჯილდოს მიღება?',
  shoppers_41: 'რა ვადებში ხდება ჯილდოს მიღება?',
  shoppers_42: 'ვის უნდა მივმართო ჯილდოს მიღებასთან დაკავშირებული კითხვებით?',
  shoppers_43:
    'თქვენი თვიური ჯილდოს ოდენობა დამოკიდებულია იმაზე, რამდენად ინტენსიურად ასრულებთ დავალებებს.',
  shoppers_44:
    'ერთი დავალების შესრულების ღირებულება შეიძლება მერყეობდეს 40 ₾-დან - მარტივი ვიზიტები და ზარები, 1200 ₾-მდე - კომპლექსური და პრემიუმ ვიზიტები. ეს დამოკიდებულია პროექტის სირთულესა და სპეციფიკაზე.',
  shoppers_45:
    'დავალებების შესრულება შეიძლება გახდეს თქვენთვის სასიამოვნო ჰობი, რომელიც შერწყმულია თქვენს ყოველდღიურ შესყიდვებთან ან კაფეების, პიცერიებისა და რესტორნების მეგობრებთან ერთად მონახულებასთან.',
  shoppers_46: 'ლოკაციების რაოდენობა, პროექტების მასშტაბები;',
  shoppers_47:
    'როტაცია (ერთი და იგივე ლოკაციის მონახულება არაუმეტეს 1-ჯერ სამ თვეში / კვარტალში);',
  shoppers_48:
    'თქვენი პროფილის / უნარების შესაბამისობის დონე პროექტის მოთხოვნებთან;',
  shoppers_49: 'განაცხადის წარდგენის ოპერატიულობა.',
  shoppers_50: 'თუ ლოკაცია, რომელსაც ამოწმებთ:',
  shoppers_51:
    'დახურულია – გადაიღეთ შესასვლელი კარები, დახურვის მიზეზის შესახებ განცხადება, თუ არსებობს, ან ლოკაციის სამუშაო გრაფიკი, ლოკაციის ფასადი მისამართით.',
  shoppers_52:
    'მითითებულ მისამართზე არ არის – გადაიღეთ მიმდებარე ტერიტორიის ვიდეოჩანაწერი, მეზობელი შენობის ფასადის ფოტო მისამართით. ამის შემდეგ დაუკავშირდით თქვენს კოორდინატორს.',
  shoppers_53:
    'ჯილდოს მიღება ხდება ბარათზე: „PrivatBank“ ფიზიკური პირებისთვის.',
  shoppers_54:
    'ჯილდოს მიღების ვადებს შეგიძლიათ გაეცნოთ თქვენს პირად კაბინეტში.',
  shoppers_55:
    'ასევე შეგიძლიათ მიმართოთ თქვენს კოორდინატორს ან დაუკავშირდეთ ფარული მყიდველების მხარდაჭერის სამსახურს მისამართზე: ua@4service.support, წერილის თემაში მიუთითეთ პროექტის სახელი, რომელთანაც დაკავშირებული კითხვა გაქვთ.',
  shoppers_56:
    'ჯილდოს მიღების ზოგადი ვადები მითითებულია პირად კაბინეტში: „მთავარი გვერდი“.',
  shoppers_57:
    'თუ არ მიგიღიათ ჯილდო და ვადები გასულია, შეასრულეთ შემდეგი ქმედებები პირად კაბინეტში:',
  shoppers_58:
    '1. შეამოწმეთ, შევსებულია თუ არა თქვენი პირადი მონაცემები და არ არის ცარიელი ველები;',
  shoppers_59:
    '2. სწორად მითითებულია თქვენი გადახდის ბარათის რეკვიზიტები, ბარათის მოქმედების ვადა არ არის გასული;',
  shoppers_60: '3. მითითებულია ფიზიკური პირის საბანკო ბარათი;',
  shoppers_61:
    '4. თქვენი სახელი და გვარი სისტემაში ემთხვევა ბარათზე მითითებულ სახელს და გვარს (შევსებულია შეცდომების გარეშე).',
  shoppers_62:
    'თუ შეამოწმეთ ყველა მონაცემი და ყველაფერი სწორად არის შევსებული – მიმართეთ ფარული მყიდველების მხარდაჭერის სამსახურს მისამართზე: ua@4service.support, წერილის თემაში მიუთითეთ პროექტის სახელი, რომელთანაც დაკავშირებული კითხვა გაქვთ.',
  shoppers_63: 'აპლიკაციები <br /> ფარული მყიდველებისთვის',
  shoppers_64: 'გადმოწერეთ 4Shoppers აპლიკაცია:',
  shoppers_65: 'ან',
  shoppers_66: 'დაგვიკავშირდით',
  shoppers_67: 'ჩატი მხარდაჭერასთან',
  shoppers_68: 'ტელეფონი:',
  shoppers_69: 'ელფოსტა:',
  shoppers_70: 'დარჩა კითხვები?',
  shoppers_71: 'მხარდაჭერის სამსახური <br /> საველე პერსონალისთვის',
  shoppers_72: 'დაგვიკავშირდით',
  shoppers_73: 'საველე პერსონალის მხარდაჭერის სამსახური',
  shoppers_74:
    'კითხვები ვიზიტებზე, გადახდებზე და სხვა ნიუანსებზე ფარული მყიდველის მუშაობასთან დაკავშირებით',
  shoppers_75: 'ვეთანხმები პერსონალური მონაცემების დამუშავებას შესაბამისად',
  shoppers_76: 'თქვენი სახელი და გვარი',
  shoppers_77: 'პრობლემის არსი',
  shoppers_78: 'თქვენი ლოგინი',
  shoppers_79: 'საკონტაქტო ტელეფონი',
  shoppers_80: 'გადახდის ვადები',
  shoppers_81: 'სხვა',
  shoppers_82: 'დაგვიკავშირდით',
  service_design_81: 'გადადით ბიბლიოთეკაში',
  service_design_82: 'მოგესალმებით სერვის დიზაინში!',
  footer_btn_1: 'გახდით ფარული მყიდველი',
  footer_btn_2: 'მიიღეთ ანაზღაურებადი გამოკითხვები',
};
